var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB3Map(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1199.27 568.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "map-map"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m556.22,253.98l-.84,2,.11,3.16-3.9-1.58-1.69-1.16-2.11-.63-.21-.63,1.05-1.05h1.16l1.48.53,3.17-.21,1.79-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520,237.21l.28,1.69-.98,2.39-2.67,1.12-1.69.14-1.69,1.55-.14.98-1.55,1.55-.14,2.95.28,2.95-1.55,1.83-.42,1.83-1.83.84-.98,1.12-1.27.56-.42.98-1.83,1.27-1.69-.56-1.69-.28-2.67.7-1.83,1.69-1.27-.28-.56-.56-1.27-.7-.98-2.39-1.27-.28-.7.14.14-1.69.98-1.55.56-3.37-.84-2.81.84-1.12.14-3.09.84-1.27.42-2.53-1.12-1.55-1.27.56-2.81.28-1.55-.56-.14-1.41-1.55-2.39.98-1.55,1.69-.7.7-1.27,1.41-.14.56.84,3.66.14.98-.28,1.41-.28,2.95.98,2.11-.42,2.95.7,3.38.14,2.25,1.55h.84l.98.84,3.66-.14.98.28.42.28.7.28h3.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m534.49,231.94l1.97-1.9,2.81-.56,1.12.56,1.83,2.81.28,2.81,1.83,1.27.56,1.55,1.55,1.27,1.12.14.56,1.27,2.67,1.55.84.14,1.12,1.27h.84l.56.7,1.27.42.28,1.27,1.12.7h.84l.98,1.12v1.41l.56,1.83-1.27,1.69-.42,1.27.7.84,2.11-1.55.56-1.69,1.27-.7-.14-1.41-1.55-1.69.56-2.25,1.69-.28,1.12.56,1.83,1.27.56-.42-.28-1.27-1.97-1.69-1.69-.56-.14-1.12-2.25-.28-.84-.7-.7-1.83-2.67-.42-2.81-1.69-1.41-3.37-1.27-1.97-2.95-2.11.14-3.09-.14-.56,1.12-1.27,3.09-.56v1.41l.7-1.12.21-.84v-.84l-.84-1.05v-1.69l-2.74-.84h-1.05l-.84-.63h-1.48l-1.05.84h-2.95l-.84,1.69-3.38-.42-1.05-.84-1.27.42-.42,2.53-.84.42-1.48-.21-1.48.21.42,3.37.63,2.95,1.48.42,1.27,1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.92,96.71l-3.4-1.26-1.27-.38-.63-.51-2.74-.13-3.8.63-3.38-1.14-2.11-.13-.84.25-3.59-.63-2.11-1.14-2.74-.13-3.17.38-2.11.38-1.48-.38,1.27-.76-2.95-.63.84-1.01h-2.74l-2.11.63-2.32-1.26-1.48.13-.42.89h-1.05l-1.48-.76,2.11-1.01-1.27-.13-1.69-.63-3.8,2.4-3.17.13-.63-.25-2.95,1.52-2.95,1.52h-1.06l-2.95,1.01-1.48,1.65-1.06,3.29-2.74,1.52-6.12.13-.21,1.9-1.27.25,1.48.76,1.48.51,2.74,1.14,2.74,1.9.21,1.77,1.27.25,1.27.13h2.74l.84-.13,1.06.38-.42.63-.84.94,1.9,1.26,1.69-.84,2.53-.21.84,1.05-.84.63-2.95.42-.63,1.9h-1.27l-1.27,1.05-3.38-1.06-2.95.42.21-1.26.21-1.48-2.74.22-2.53.63-.84,1.26-2.11.21-.63,1.69-1.06.42-1.9,1.9,1.69,1.48h1.06l1.9.21.84.84-.84.42h-1.9l2.74,4.01h2.95l2.11-.63,1.69.84,2.74.21,1.06-1.48,1.69-.42,1.06-1.05,2.53.84v1.69h-1.69l-.21.63,1.9,2.11.21,2.32-2.75,3.36-1.69-.63-1.9.84-2.74,1.26-1.27-1.26-2.11,2.74-.42,2.32-1.06.63-1.48,3.59-.63.63.42,1.9,1.27,1.9.84-.21.63.84-.63,2.32-1.27.21,4.65,4.21,2.11-.21,2.32-.63.14-1.26.84-.28v1.97l.56,1.97.56,3.09-.56,2.25,1.69-.56,3.1-1.69,1.12.84,1.12.28,1.12,1.69.84.28.84-2.53,1.41.84.84.28,1.41-.28,1.41-1.12.28,1.12-1.69,4.22v2.81l-2.25.84-1.97,2.53-2.81,1.97-1.27,1.4-.42,1.69-.84.42-1.26-.63-1.9.42-2.32,1.9-1.27,1.9-1.48,1.16-1.27-.21-1.79.95-.63,1.58.1.84,2.22-.63,1.69-1.48.53-.95h.84l2.74-1.48.63-1.9.84.21.63.63h1.48l2.95-1.69,1.69-1.05,1.9-.63.21-.84,4.64-3.58,1.27-1.05v-1.48l2.74-1.9,1.9-1.48,2.32-1.26.42-2.32,1.48-.42-.21-2.53h-1.48l-.21-1.05,1.48-2.11h1.9l1.48-1.68-.42-1.9,5.49-6.96,2.11.21,1.06-1.26h1.06l-.63,3.16-1.9-.21-2.95,2.11.21,1.26-1.69,4.22.21.84.63-.21.63.42-.63.63-.84.42-.42.84h2.53l3.17-1.9,1.48-2.11h3.17l.84-2.53-.42-1.26.42-.63-1.06-.42,2.11-2.32.84.21-.42,1.26h1.27l1.9-.63.63,1.48,2.95,1.9,1.69-.42.63.63.42,2.32h3.8l1.69.21,1.06.42h2.95l.63.63,2.95.63,1.69-1.05.21,2.74,3.8,1.48.84,2.32,1.9,2.11,3.59-.21-1.07-1.26.21-.63h1.05l1.27,1.48h.63l.63-2.53.84,2.11,1.27.42,1.27.84,1.69,4.01.42,2.74,1.48,1.48,1.05.63.21,2.53,1.05,1.69.21,1.48.63.21.42,1.05,1.9.42.42,2.32h.63l1.27.21.77-1.05-.28-2.25.56-2.81-3.94-2.53-2.25-2.25-3.66-8.43-1.97-1.41-2.25-3.94-2.25-1.69-2.25.56-2.25,2.53h-1.41l-4.5-6.75-1.41-1.69-1.12.84-.56,1.97-3.28-2.25v-55.16Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6,110.68v.63l.63.63-.42.63-1.48-1.69,1.27-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.17,153.06l-.84.21-1.9,2.11-.11.74,1.16-.1,1.69-2v-.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.91,152.64l.11-.74,1.37-.21.21,1.05-1.06.63-.63-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.06,152.75l-.42.32-.53-.63.42-.42.53.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.32,154.01l-.32.74-.53-.32.32-.63.53.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.71,189.27l-.14-.56-.56-.14-2.25,1.83-.14.56.98-.14,2.11-1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.35,190.67l-2.81,2.67-.42-.42.84-1.26.14-.98,1.27-.42.99.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.43,152.99l1.83.98.14,1.97-1.12.42-1.12.7-1.69-1.55-1.12-.28-.14-1.12,1.83-.42,1.41-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.69,132.61l2.25.28h3.09l2.67,1.69,1.83.28-.28.7-1.97.56-1.27.56-3.24-1.97-2.67.7-.84-1.41.42-1.4Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.17,153.06l-.84.21-1.9,2.11-.11.74,1.16-.1,1.69-2v-.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.91,152.64l.11-.74,1.37-.21.21,1.05-1.06.63-.63-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.39,166.03l3.59-.32.32-.63-1.27-.84-2.43.21-.42.53.21,1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.6,168.57l1.69-.21,1.48-.84,3.48-.1.42.84-.63.95-2.21,1.37v.74l-1.9.21-.63.74-1.16-.53v-.74l-1.16-.74-.11-1.37.74-.31Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.06,152.75l-.42.32-.53-.63.42-.42.53.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.32,154.01l-.32.74-.53-.32.32-.63.53.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.89,182.23l.98-.84-.42-.42-.7.28.14.98Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.58,182.38l.84-.56.42.28-.84,1.12-.42-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.79,75.96l1.12.68v.51l2.53,1.18v3.38l.84,2.49,1.9,1.9-.63,2.4,4.01,2.28.84-.51,1.69.38.42,1.52,3.8,1.9v.89l-.42.51h-1.27l-1.05.25-1.05-.38-1.27.89-1.9-.51-.42.51.42,1.39,1.9-.51,1.27.38.61,1.85-2.09.17-2.53.76-2.53-.25-1.69.38-.84-1.26-2.74-.63-.42-1.01h-1.48l-.42,1.39-1.9,1.01h-3.38l-3.16,1.39-1.9.13-7.81.38-1.9-1.26v-2.02l-1.05-.63-4.01-.13-3.16-.38-2.95-1.9v-1.14l2.53-1.01,6.54-.63,3.8.25,3.38-.25.42-.51-3.38-.89-1.27-.13-2.95-.63-4.01,1.01-2.95-.13-2.74-.76-1.9-2.15,2.74-.63,3.16-.25,1.48-1.26-1.05-.38-3.8.38-1.05.51-.84-.25.21-1.01-2.11-.13-.21-2.28,2.32-.63-.21-.89-1.69-.63,1.27-1.9,2.32-.63,1.27-.25,3.59-2.15,2.53-.76,1.69.51.84,1.39-1.69,1.39.42,1.14,1.27-.76.84.38,1.05-.38-.21-1.14,1.27-.51,4.64,1.52.21,1.39-1.48.89v.51h1.9l.63-.89,1.05-.76,1.48.63.42-.63-.63-1.39-.42-1.01h1.9l2.74,2.28.63,2.02.63,2.91,1.27.63,2.11-2.02-1.05-1.14-.84-2.15.42-1.39-.63-1.77v-1.26l.84-.13,1.05.51,1.27.25,1.62-.38Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.91,100.25l.84.38v.63l-1.48.38-1.27,1.01-3.38.38-1.9-.76,1.27-1.26,2.95-.13,2.96-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.43,74.57l-1.27.25-.84.63-4.85,2.28-1.27.76-2.74,1.52-.42,1.65-.84.38-.63-.51-1.69.76v3.04l-2.11,1.26-.84-.51-2.32,1.65-1.69.89-1.69-.13-.42-2.53-5.06-2.28-1.48-.13.21-2.15,2.53-1.26-.21-.76-.84-.63v-1.14l1.05.13,1.27-.76-1.47-.63v-1.14l2.74-2.15-2.11-4.68,6.54-.51,1.69-.63,2.53.13,3.16,2.28.63.76.84-.76h.84l.21,1.26.84-.38.21-.89,3.59-.25,5.7,4.05.2,1.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.02,72.41l-1.27.38-1.27.38-1.9-.13-1.48-.76-1.9.51-.84-.63-1.05.25.21,1.26,1.05.63-1.48.25v.76l.84.76,1.69.13.21.38-.84.25,1.05,2.02-1.69.51-.63.25-2.95-2.02-1.9.13-.42,1.52.63,1.26,2.32,1.14.42.63,2.32.38.84,1.01,1.9.51,1.69,3.29,3.16-.51v-.89l-1.05-.38v-.88l1.9.89,3.38-.76.63-1.26-.63-1.77,1.27-.89-.84-1.01-.21-.38-1.9-.13v-1.26l-.84-.38-2.53.13.63-1.01,1.9-2.15.21-.51,1.05-.51.63-1.39h-2.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.91,96.21l1.27-.76,1.05.13,1.69.89.63.76,1.05.38.21.51,2.74,2.02-1.27.63-1.9.89h-1.27l-2.32-1.01-3.16-.51-1.9-.13-.63-1.01,3.59-1.39.21-1.39Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.95,100.38l.42-.51.84-.25v.76l-.84.38-.42-.38Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.31,101.26v-.51l1.05-.25h1.05v.51l-1.27.63-.84-.38Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.08,102.15l-.21-.38,1.69-.13.63.51-.84.13-1.27-.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.96,74.82l2.53.89,2.53,1.52.84-.13,1.27-3.04-.42-.38-1.05-.38-1.05-.38-3.59.25-1.06,1.64Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.62,83.43l.84-.13,1.69.13,2.11-2.78-2.11-1.9,1.27-.25,1.27.25h2.11l1.48.38,5.27-6.33-.21-1.52-4.01-.38-1.48.25-2.11-1.14-2.74.51-1.69-.25-2.74,1.14,1.69.89v.63l-1.27-.38-.84.38.21,4.81-.42.63,1.27,1.9.42,3.16Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.8,72.29l1.69.25,1.48-.38,1.05-1.01-.42-.38-2.11.13-1.69.76v.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.18,78.24l-1.27-.38-.21-.89.84-.13,1.05.51-.42.89Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.35,67.99l-.63-.63.42-.38.84.51-.63.51Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.36,72.54l-2.11-.13-1.05-.25h-2.53l-3.59,2.15-.63.25-2.53,2.28v2.15l-1.69,1.14-.42.76,1.05,1.01-.84.89.42,1.26-.84,1.26,1.27,1.52,3.8.63,2.74.63.42.89-1.69-.38h-1.48l-1.9-.51-1.48.25.42,1.39,1.27.76,2.11,1.26,1.27,1.26h1.69l1.69-1.26,1.05.25.21,1.39,1.69.51,2.11-.38,1.9.13,1.9.76,1.27.13,1.48.25,1.69.51v-.76l-1.27-.76-.63-.63.63-.38,1.27.51,1.05.89,1.9.76.63-.63-.63-.51,1.69-.38,2.32,1.01,2.53-.13.63-1.14-2.53-1.39v-.51l1.69-.51,1.27,1.01,1.05.13,1.69,1.26-.21,1.65,1.27.63.84,1.39,3.38,1.14.21.51-3.59,1.14.21,1.01,1.48.13,1.27-.51,2.11-1.01h1.26l-.84.89,1.48,1.39,1.69-.13.84,1.39,1.9,1.14.42.89.21,1.01.84.63v2.53l-1.48.13-1.05,1.57-4.01,3.16.42,2.11,2.11,1.69v1.9l-1.48-.63-2.53,1.48-3.59.21-1.27-.63-1.27-.85-1.05,1.05v1.26l-1.9,1.48-.21,2.53,2.53,1.9,2.95.21,1.69-2.53,1.05-.21,2.11,2.32.63-.84-.21-1.48,1.27.21.42.84h2.32l.42,2.74,2.32,2.11,1.9.21.42,1.48-1.27.21.42,1.69,1.27.42,2.74,2.53,1.48-.42,1.27.42-.21,2.32,2.53,1.69h1.69l4.64,1.69,1.69-.63-1.05-2.32-3.17-2.11-1.69-2.32-3.17-4.01.42-1.48.84-.21,1.69,2.11,1.05-.21,1.27,1.69,1.69-.42,2.11,2.53,1.9,2.95,1.27-.21v-1.9l.84-1.48-1.48-1.26.42-.84,1.9.21v-1.69l-1.48-1.9v-1.05l-.84-.63v-1.05l-2.32-2.95-1.48-.42-2.11-2.74-.63-1.26-1.27-.84-2.11-2.53.63-1.48,1.9,1.69,1.27-.84-.63-1.05-1.05-2.32,2.53-1.26,2.11,2.32.63,1.26h2.53l.21.84-1.27,2.32,2.11,2.74,1.05.84,1.27.42,1.48,1.69.84-1.9-.84-2.53v-1.69l1.48,1.48,2.32-1.48-.63-4.22,2.53-.21.42-2.84-1.27-.38.21-.76-1.48-.63-2.95,1.52-.21-.63.84-.63-.84-.76-3.17.38.42-1.65-1.27-.76-1.27-.25v-1.01l-2.32.13-1.69.76-1.69-2.28-2.74-1.52-3.8-.89.42-.76,3.59.63.21-1.01-1.27-.63,4.64-.25-.63-.89-3.8-1.01,1.27-.51h1.26l.63-1.01-2.74-1.9-1.27,1.26-1.9.51v-.76l-2.53-.38,2.53-.63,1.9-1.65-3.17-1.26-2.32.13-1.69,1.9-1.27-.13.42-1.01,1.05-.89-.42-.51-2.32.89-.84-.89,3.38-1.01-.63-2.4-1.69-1.01h-2.54l-.21,1.39-1.27.63-.84-.51-.63.51-.84-.76.84-1.14-1.27-.25-1.05,1.39-1.27-.25.21-1.39,2.11-1.77-1.05-.38-1.69,1.14-1.05-1.14,1.27-1.9-2.74-1.14-1.48.13-1.27-.38-3.59.13-1.27,1.01,2.32.63-.21.63-1.05.13-.42,1.77h-1.47l-1.05-1.39-.21-1.01h-1.9l-1.69.63-.21,1.01-1.05.13.42-2.78,1.05-.89-.42-1.14-.42-.76-.21-1.9-1.47-1.27v-1.01l-1.05-.63h-1.69l-4.64,1.39v1.14l-1.05-.38-1.55.61,1.13.78-2.74.76.63,3.42,2.74,1.01-.42.76-2.11-.76-1.48.76.42,1.9,1.59,1.83-.32,1.96-1.48-.13v-2.53l-2.53-1.39-.21-4.55-.21-.76,2.95-3.04.42-.76,1.61-1.63-.98-.52Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.23,73.43l.63,1.65.84.51.63,3.29,1.27.51,1.27-.38.42-.76,4.64-.25,4.01.89.63-.89-2.32-.89.21-1.39-1.27-1.01-1.27-.13-2.95-1.52-4.01.38-.63-.38-2.11.38Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.62,95.7l-2.32.89v.38h.84l2.53-1.14-1.05-.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.82,95.57v.63l-1.9.63-1.05-.38.63-.51,2.32-.38Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.15,98.73l-.42-.89.21-.63.84.13.63.38-1.27,1.01Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.67,98.11l1.27-.51.84.25.21,1.14-2.11,1.14-2.11-.13v-.38l1.69-.63.21-.89Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.88,102.15l1.05.38v-1.14l-1.05-.13v.89Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.68,102.91l-2.53,2.02.21,2.4.84.76,2.53-.38,2.74-1.39-.21-.89-.42-.51v-1.64l-3.16-.38Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.27,101.01l-.21,1.14-.84-.25v-.63l1.05-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.01,105.06l-1.05-.51v-.51h1.69l1.05,1.01h-1.69Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.93,104.05l.42.38-.84.76-.84-.38.21-.51,1.05-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.9,114.48l.84.84.84.42.21.84h-1.05l-1.27-1.48.42-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.58,115.53l.42-.63.63.63.42,2.11h-1.05l-.42-2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.62,117.64l.63-1.05,1.05.21.42,2.32,1.48,1.68.84-.63,2.74,1.05,1.27,1.48,3.59,1.48.42,2.32-.63,2.32,3.8.63.42.63-.42,1.9-3.59-.21-1.69-.84-.42-1.26-.84-1.05-1.27.42-1.48,2.11-1.27.21-2.11,2.74-1.69.84-.42-3.59-3.59-.42-.42-.84,2.74-5.48.21-5.48.21-1.47Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.43,135.35l-2.95.21-1.69,1.48-.21,2.53,1.9-.21,2.74-2.32.21-1.69Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.24,139.36l-1.69.21-.63.84-.21,2.74,1.69,1.26.21-1.69,1.05-1.26-.42-2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.56,133.03h1.69l.84.84-.84,1.26-1.27-.63-.42-1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.73,132.4l-.21-.63.63-.42,1.68,1.27v.84l-1.27-.21-.84-.85Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.52,129.66l-.63.42-.63-.84.63-.42.63.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.03,
    y: 93.55,
    width: 2.11,
    height: 0.38,
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.68,152.43v-.84l1.27-.84.42.63-.42.84-1.27.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.96,174.08l-.28,1.41-1.12.98.56.84,1.27-.98.56-1.69-.14-.98-.85.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.92,59.49l-1.48-.18-1.05.46-1.05-.18v-1.01l-1.27-.55,1.27-.55,1.48-.27,2.11-.55.42-1.1,1.27-.09.42-.73,3.38-1.46v-.82l1.9-.64,3.38-.09.63.18h1.69l1.05-.18-1.05-.46v-.37l2.32-.27,1.9,1.19-.42.46h-1.05l-.63.91,1.05.73-1.27.55,1.05,1.19-2.53.55-.63,1.65-3.16-1.19.84-1.37h-1.9l-.63,2.1-1.27.64-.84-.82-1.27.27.63,2.1-2.53.46.21-1.28-1.05.09-.21,1.74h-.84l-.85-1.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.99,43.03l1.69,1.19,1.48.09v1.28l-3.38.55-1.69-.91-.63.55-1.48.09-1.48-.18-2.11.18-.42-.73,1.27-.27.21-.64,3.16-.18,1.69-.91,1.69-.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.76,38.92l3.16.18,2.32-.46,2.32,1.65.63,1.65,1.05.18v-1.01l2.11-.46,2.11.64-.63,1.37,3.16.73.21,1.1,2.95,2.1-1.05,1.74-2.74.09-1.69-1.46-.21-.46-1.9-.18-1.69-.73-1.9.46-1.05-.55-3.59.27-1.48-.73.42-1.01,3.8.09-1.05-.82.21-.55-.84-.37v-.73l-.84.18-.63.73-1.27-.27-.21-1.28-1.9-.18.21-1.92Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.83,48.24l1.69-.46,1.69.27.63.82-2.53.18-1.48-.82Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.88,46.55l.53-.41,1.16.27-.42.41-.95.05-.32-.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.91,48.97l1.48.18,3.16,2.1.42,1.55h-2.74l-1.69-2.1-.63-1.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.73,47.51l-2.95-.18-2.74.09-5.06,1.19.21,1.92,2.95.82,5.06-.37,1.48-.55-.42-.73-2.32-.37.21-.73,3.8-.46-.21-.64Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.81,47.88l1.69.73-.42.64-1.9.09-1.9-1.46,1.05-.18,1.48.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.15,55.19l.84-.27,2.11.09v1.55l1.27.55-.42,1.37,1.27.18.63,1.46.84-.27h1.05l.21.82,1.05-.09-.42-1.55h1.27l2.53,1.01-.42,1.46-1.05,2.44-4.01.89-.84-.63-1.05.63-1.69-.13v-.63l-1.69-.13-.42.89-4.43,1.26-1.05,1.39-4.85.76-2.32-.13-2.53-1.77,2.74-.38,1.05-1.01,1.27.13,3.16-.25,1.27-1.14-.21-.38-2.32.13-1.27.38-1.48-.38-1.69.63-1.48-.13v-1.01l1.48-.38-1.05-.32-2.74.7,1.27,1.01-1.9.38-1.27-.51-.84.76-1.48-.51-.84-1.01-1.9.13-1.69-.59.84-.82,3.59-.18,2.32-.64-.63-.37-2.95.18-1.05-.46,1.48-.73,1.69.09,1.69-.18-.84-.37h-2.53l-.42-.46,1.05-.91h1.48l1.9.27v-.37l-1.69-.82,1.48-.46,2.53.27.63,1.1,3.8-.18,3.59,2.47.63.91,3.16.18,2.74.82,1.48-.55-.21-1.19h-2.53l-.63-.46,2.32-1.01-.42-.82-2.95-.27-.42-.55.84-.37,2.11-.27v-1.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.12,54.46l1.69-.18,1.69.09.63.55-1.27.27-2.32-.27-.42-.46Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.26,58.85l-.21,1.1-1.48,1.65-1.9-.27.21-.64,1.9-1.37,1.48-.46Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.55,62.05l-2.11,1.51,1.05.51,1.69-.13,1.27-1.34-1.9-.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.19,58.02l1.9.64,3.38-.37v-.45l-1.69-.27-3.59.45Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.24,59.21l4.43-.64.21.27-4.43.82-.21-.46Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.93,59.76l1.48-.27,1.27-.09.21.37-2.53.46-.42-.46Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.21,59.67l-.42.64-2.95.09-.63.37.42.55h2.32l.63-.27,3.59-.09,1.05-.46,1.05-.09.84.64-1.9.46-1.27.27-.63.55,1.27.35.21,1.9,6.54-1.02.84-1.01-1.05-.96.42-.37.63.09,1.27.64-.42-1.46-.42-.37-.63-3.66-.63-.64-.21-.73-1.27-.09-1.05.18,1.27.64-1.27.37-1.48-.64-4.43.27,1.27,1.55,1.48.46.21.64,1.48.64-.63.27-2.53-.73-1.48-.82-1.69-1.1-1.05.46.21,1.19.21.73.84.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.73,61.04l-1.69-.09-1.48.18-.84.55-1.69.82-.63.8,1.05,1.77,2.53.63,2.32.63,1.9.25,1.05-1.26-.21-1.39-1.05-.63.84-.71-1.27-.91-.84-.64Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.08,61.35l1.28-.41,3.64-1.6.99.55,1.69-.12,2.67-.06,2.11.49.28.67,2.25-.18,1.12.79.28,1.08-1.83.59-.14.68,2.11.25.28,1.18-1.55.26-.84-.76-.99.59.99,1.18-.99.84-2.25-.17-1.12.93-3.09-.68-.56-2.11-1.41-.08-.98,2.45-2.66-.42-.58-1.01-1.12-.34-.42,1.26-2.81.59-6.19-.08.7-1.18-1.41-.76-3.1,1.35-3.09-1.1-2.39.59-1.27-.68-.56-2.19,1.41-.08-.14-.93-1.55-.82.98-1.22-1.83-1.1-1.27-2.01-2.25-.06-1.12.18-2.81-.37-.7-.85-1.55-.3-.84-.85-2.53-.79,1.55-1.28,2.67-.12,3.66.79.98-.3,1.41.06-.28,2.86.7-.06,2.39-1.22,2.53.37,1.55-.55,1.83.18.14.73-1.83-.06-.99.3.99.49,1.55-.18,1.27.67,2.95.06-.14.73-2.53.18-1.97-.43h-2.39l1.97.79-1.27,1.1.84.49,2.25-.79,1.69.18.28,1.34,1.27,1.04,1.12.06-.28-1.46,1.41.18.84.91,2.25.06-.28-.73,1.41.06.56.91,1.55.43,1.12-.37-.84-.67,3.24.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.62,42.09l.84,1.16,4.08,1.1,1.12.79-.14.49h-1.26v.37l1.41.91-1.12.79-1.41.24-2.67.3-.84.49-.84-.06-.28-.67-1.97-.98.14-.3,1.83.24.7-.61-.98-.49-1.69-.12-.84-2.01.14-.49-.42-.85.99-.55,3.24.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228,49.47l1.41-.37,3.09.24,1.97-.3,1.69.18-1.83,1.34-5.2-.3-.98.12-.15-.92Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.95,45.87l.14.61.84.18v-.73l-.99-.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.36,61.53l.14-.49,1.41-.61,1.55-.06-.14.61-1.12.37-.28-.24-1.55.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.39,59.46l.7.79h.56l.28-.18-.56-.67-.98.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.84,58.24l.56-.12.7.37-.99.18-.28-.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.64,55.01l1.41.06-.14-.3-.84-.12-.42.36Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.98,55.92l.42-.43,1.69-.37-.7-.18-1.97.24-.28.49.42.24",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.68,57.14l2.67-.18.28-.43-2.81-.98-.98.12.14.98.7.49Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.89,54.46l-.42.24.14,1.34.84.18.84-.3-.42-1.46h-.99Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.02,51.47v.98l-1.27.43-1.97.18h-1.27l-1.69,1.04-1.69.12.14,2.13,1.69.06.42-.43.28-.3.56.06.42.91,1.55.24.42-.37-.14-.37h.7l.84.55,1.27-.24.28-.67h1.27l-.14,1.1,1.83.3,2.53.12-1.69-1.22.7-.24,1.41.24.7.43.7-.24-.28-.43,1.97-.18.42.91.84-.49-.42-.49h1.41l.28,1.04,1.41.24.99-.49-.56-.85h1.97l.98.73,1.27.12.28.37-.42,1.04,1.27.24,3.8-1.22.42-.73h2.25l.84-.91-.42-1.71-1.27-.18-1.27,1.1-1.55-.24v-1.04l.7-.43-.14-.67h-1.12l-1.12.61-.99-.37-4.22.18-.28-.49,1.83-.79-.98-.91.56-.12,2.39,1.46,5.2-.06,2.81-1.28-.84-1.34-.84-.43.7-.61,3.94.24,3.24-.85-1.27-.43-2.25-.18-.28-.24,1.69-.24,2.95-.06.7-.37-.28-.91-2.95-.67.7-.18,2.25.18,1.55-.37-1.69-1.89h-2.08l-1.97-.79-2.81.37-.7-.43,1.83-.24,1.97.06v-.3l-3.52-.06.14-.37,2.39-.24,2.67.24,1.55.73h2.25l.42-1.1-4.64-.37-4.64.3.28-.55,1.55-.12-.28-.24,2.67.12.14-.24-2.25-.3,2.53-.43.84.12.56.43,2.11-.06.14-.73h2.53l1.83-.49-.28-.85-3.24-.37-.42-.43,1.97-.18,2.81.61.7.37,2.67-.12,2.11-1.04-.28-.67,1.12-.55-.98-.24-2.81.37-.84-.12.14-.85,1.27-.37,1.55.55,1.12-.55,2.95-.24-.7-.79-1.41-.49-.28-.98,1.69.37.28.61.98.24,2.11-.79.98-1.4,3.1-1.52,1.27-.37,2.11-1.59.98-.24,2.25-1.77,1.41-.18,1.55-1.22.98-.43-.28-.37-1.83.06-1.83.37-2.11.61-1.41.24-4.5,1.04-2.67.79-1.12.06-.7.43-2.67-.37.98-.49h2.81l2.39-.73,3.52-.73,3.09-.73-.28-.61-3.23.06-.98.3-2.95-.18-.28-1.28.56-.06,1.41.49,2.67-.12,1.12.18,4.08-.37,1.83-.79,2.67-.06,1.55-.64,1.69-.27,2.11-.73.7-.79,1.27-.43-.42-.55,2.67-.97.28-1.83-2.67-1.1h-4.5l-.28-1.95-1.27-.43.84-.37.42-.79-1.12-.18-1.97.24-.98.49-.56-.24-.14-.73h-.98l-.42,1.28-.98.06-.98-.73-1.41.06-3.8,1.95-3.09.24v-.37l4.92-1.71-.14-1.34-3.38.06-1.97-.37-2.39.18-.28-.61-2.39-.06-.56-.73-3.1.37v.61l2.25.73-.98.3-3.09-1.04v-.67l-2.67.12-1.27.12-.7.91.42.67,3.65,1.77.28.79-1.69.37-1.83-1.22-2.11-.85-1.97-2.19-6.12.03-1.05.37.21,1.19,3.38.82,1.05,1.1,1.48.91-.84,1.01-2.11.73-.21-1.74-2.95-1.83-1.9-1.19-1.48.37-.84-.37-3.16-.27-1.27.55,1.27,1.01,2.74.73-.84.46-2.32-.09-2.95-1.55h-1.48l-.84.18,3.8,1.83.42.73-1.05.27-2.53-1.37-2.95.09-.42.46.84.46h1.9l.63.46-.42.37-2.11.09-.63.91,1.48,1.1,4.01.82,1.48,1.28.21.55-1.27.09-4.22-1.55-1.9-1.01-.84.09.21.55,1.48.82-2.11.09-3.16-2.74-2.96-1.19-1.48.27.84,1.83-2.74-.09-.21.82,1.9.82,3.16.37.84.64-1.9.64-2.11-.09-1.48-.82-.63.27.21.73-1.48-.55-1.05-1.01h-2.32l-2.32,1.1-.63.91-2.95-.46-1.27,1.19-2.74,1.28,1.48.55,2.74.18,2.11-.37.21.46-2.11.55.42.82,3.59-.37,2.74-.91,2.53.18-.63.37-3.38.82-2.32.91v.46l-1.27.27.63,1.19,4.64.27,4.43-.18,3.59-1.65,1.27-.18.63.27-2.95,1.65-2.53.55h-4.22l-3.8.73.84.91,2.95.37,2.53.91,1.05-.27,1.27-1.37,2.53-1.19,3.8-.91,4.22-.37.21.64-6.96,1-2.11,1.19-1.05,1.19v.73l4.43.09,1.27-.37v-1.65l1.27-.18.42,1.01,1.9-.64h2.32l-.42.37-2.53.82.63.46,4.22-.46,2.32-.64,3.8-2.1-1.48-1.55,2.32-.27.63-1.1,1.9-.73,1.48-.18.21.46-2.53,1.74-1.05,2.19,3.38-.64h3.58l.42.73-2.74.82-4.01-.27-4.22,1.01,1.48.37h2.11l-.21.46-2.95.46-2.11.09-2.74.91-3.8-.18v.91l2.32.82,1.69,1.55.84,1.65,1.69.55,1.69-.27,1.05.27-1.48.82h-3.8l-1.69-2.19-4.01-2.74-3.38-.55-4.43-.09-.63,1.19,2.32,1.28-2.48.37v.46l3.74,1.19,2.32,1.28.42,1.1,2.11,1.46-.21.64-2.11-.27-1.05.55,2.74.73h3.8l3.59-.37v.82l-2.53.27-.42.82-3.16-1.01-2.95.09-2.53-.37-2.11.27-1.27-.18-.84.18-1.69,2.38v1.65h2.53l.84-.91.84.18-.63,1.1,1.9-.09,1.27-1.37v-.91l1.27.18.63,1.74-1.48.55v.73l-1.69.37.63,1.55,2.53.73,2.74-.46,1.9-2.47,1.48-.09.63.64-1.69.64-2.74,2.83-1.27-.09-2.11.27-3.8-.91-.84-1.74-2.53-.82-1.69.64-2.11.09,1.05,2.19,3.52.57Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.16,23.29l2.32.37,2.32,1.19.42,1.19.84,1.46,1.9,2.01,3.8.73-.21,1.46.84,1.28,1.9.73.63-.73-1.9-.91.84-1.37,2.53.46.42,1.55-.84.64,1.9.82-.21,2.74h4.01l1.9.37.21,2.01-2.11.37-3.59,1.55-1.48,1.37-.84-.09-.63-1.01-1.05.27,1.27,1.55-.42,1.1-1.48-.55-.63.18.84,1.01-1.69,1.37-2.11-1.92-.21-.64-1.27-.27-.42.73,1.9,1.55-2.32-.55v.82l-.84.73-5.27-1.1v-.73l-2.11-1.1-1.69-1.92,1.69.18-.21-.64-2.53-.73,2.74-1.83,3.8.73,3.38-.37-4.64-.46,3.59-.37.21-.37-2.95-.18-1.05-.64-5.27.64-2.95-.18-.21-.91,3.59-.27.63-1.01-2.11.55-2.53-.09-1.27-1.01-.63-2.29,1.05-.18,1.69.82,3.59.18v-.91l-2.74-.09-4.22-1.65h3.8v-.55l-1.48-.55v-.64l2.53-.09,2.74.55.84-.37-4.01-1.65.63-1.55,1.05.09.84.82,1.27-.46-1.48-.91,3.59-.46-1.05-.64h-3.16l-.21-.91,2.32-.37h1.68Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.83,28.41l1.05.18-.84.18h-1.69v-.46l1.48.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.7,33.62l-.84,2.83-1.05-.55-.63-.82-1.48-.27,1.69-1.19h2.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.7,49.98l-.21,1.55,2.32.82.84-.64-.84-1.19-2.11-.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.64,51.99l.84-.09.63.46-.63.18-.84-.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.15,41.57l1.27-.73,2.32-.55.84.27-1.9.91-2.53.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.66,51.26l-.63-.27.63-.27,1.69.18v.46l-1.69-.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.87,51.17l.84-.27,1.05.09.42.46-1.27.27-1.05-.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.42,275.58l1.58-.53,5.17-.21,4.54,2.11,4.11,2.53,1.69.32,6.33.11,2.74-.74.63-1.79,2.74.11,2.95.63,2.74,2.64h1.05l1.05,1.05.21,2.64,2.32,2.21,2,.74.63-.42-.32-1.48,1.9-1.48,4.43,2.21,3.9,6.22.42,1.9,3.38,2.64,2.85.53v-1.26l-.21-2.11.84-1.27.42-1.27,2.95-3.58,2.95-.84,1.48-1.05,2.11-1.27h1.69l2.95.63,1.48-.42,2.74,2.11,1.48-.42,2.11,1.05h1.34l.14-.98-1.27-1.41.14-1.55,2.11-.28,2.81-.84.7.56,2.81-.56,1.83.14,1.69.84.7,1.27,1.27.28.56-.98,1.41-.28,1.69.84,1.41,2.11,1.12,1.27v.98l-.42.56.14,2.81.98,1.27.28,2.25,1.83,1.97.98,2.53.98.14,1.69-.7.56-4.5-1.27-5.06-1.41-4.5-1.12-2.39v-3.24l1.83-3.09.28-1.41,1.27-.14,4.36-4.22,2.25-.42,1.41-1.97,1.27-.98.56-1.83,1.83-1.12.28-.98-1.12-1.27.7-.98-.14-1.27-.98-1.69v-4.08l-1.12-2.39.84-1.97,1.69-.14-.42,2.25.42,3.09.56,1.97.7.42,1.27-2.53.28-2.67-.98-1.55.56-.56,1.12.98,1.55-1.41.42-1.69,1.42-1.83-.28-1.41-.56-.42,1.27-.56.56-1.55,1.12-.14,1.27.7,1.55-.42,1.55-1.12.98,1.12,1.55-.42,1.13-1.12-1.55-.56v-1.27l-.98-.98,1.4-2.11.28-1.12,1.12-1.55.14-1.12h2.53l.56-.7.42-1.27.42-.28.56.56,1.27-.14,2.78-1.62-.31-2.95-1.9-2.95v-3.8l-3.59-1.48-1.69.84-4.01,7.59-5.27,1.05-1.69-.42h-2.74l-1.69,1.48-3.8,3.16-7.81,2.74-1.05,2.53-8.44,4.01-.97-2.74,1.6-4.85-.21-3.8-5.49-5.69-2.11-4.22-9.28-4.85-5.7.42-2.32-.63-3.59.21-2.74-1.27-3.38-.63-2.53-1.69h-82.27l.28,2.67.77,1.97-.42,1.9h-1.05l.42-3.37-3.16.21-1.9-.63h-1.48l-.42,1.05,2.11,3.8.42,3.37-.63,3.58.21,5.48-1.48,4.22.42,2.53,1.05,4.01-.21,2.74-.42,2.11,1.05,1.69.21,2.32,2.11,1.69.63,2.53,1.9.28.56.56-.56,1.41.42,1.83.98.98.14,1.69,1.12,1.41,1.97,2.25.56,2.81h1.55l1.69.56,1.27,1.55.84.14h.99l2.25,1.27.99,2.38.84,1.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.59,211.48h82.07l2.53,1.69,3.38.63,2.74,1.27,3.59-.21,2.32.63,5.7-.42,9.28,4.85,2.11,4.22,5.48,5.69.21,3.8-1.6,4.85.97,2.74,8.44-4.01,1.05-2.53,7.81-2.74,3.8-3.16,1.69-1.48h2.74l1.69.42,5.27-1.05,4.01-7.59,1.69-.84,3.59,1.48v3.8l1.9,2.95.32,2.95,1.16-.63.98-1.41,1.83-.42,1.83-1.12,1.55-.98.42.42-.28.98.7.28.56-.28.28.56-1.13,1.12h-1.27l-1.97,2.25-.98.28-.7,2.53,1.27,1.12,1.69-.14,1.27-1.12.42-.84,2.53-2.81.84.84.84.14.7-.7,1.55-.28,1.41-.14,1.69-1.55v-1.55l-1.12.14-.42-1.12-1.55.7-2.11-.14-1.41-.98-.84-.98-3.1-2.25-.42-2.81.7-.84v-1.41l-1.97.42-1.27-.84-1.83-.56-.14-.7,1.27-.84,2.11.42,1.27.7,2.67-2.25-.56-1.27-.56-.28-2.25-1.83-3.38.28-1.41,1.55-2.95.84-1.97,2.11-.56.14-3.1,3.23-.14,1.12-1.41.56-1.55,1.82-.7-.28.56-2.81,2.39-1.83.56-.98,1.97-1.83,1.69-2.95,3.94-.7.14-1.41,1.27-.84,1.83-2.11,1.97.14.42.42,4.5-.42,2.39-.56,1.55.84,2.67-.42,1.83.42h3.1l2.11-1.12,1.97-3.65,2.11-1.12,3.52-.7,2.39-1.97.56-.14.56-1.27-1.13-2.25.99-1.55-.7-2.81-2.53-.98-1.97,1.27-.14-.84.56-2.11-1.69-.14-2.67,1.55-.28.7h-.84l-2.39,1.97-1.41-.14-.42-1.83,1.27.28,1.97-1.13,3.38-1.97,2.95-.98.28-1.12-2.39-.56-1.27-.98-2.25-.84-1.27.42-1.69-1.12-.14-1.27-1.41-2.39-1.27-.56-.14-.56-1.69-.7-.14-2.53,1.41-.84-.28-1.27-1.27-.42-.56-3.23-1.97-1.69.28-1.83-1.55-.84v-2.81h-1.13l-.7-3.37-1.41-1.26-.56-2.67-.98-.42-.98,1.69v1.26l-1.13.84.28,2.39-1.41,3.37-.84.84-.14-.84-.84-.14-1.13.28v1.55l-1.41.84-.98,1.12-1.41-.98v-1.41l-2.67-2.67-1.55,1.41-1.69.42-.14-.56,1.97-1.27.56-.98-.84-.56h-.98s-.7-.98-.28-.84,1.27-.7,1.27-.7l-.14-1.41-1.12-1.12,1.12-1.12-.14-2.67.98-.84v-1.55l-1.14-.28-.84.42-.7-.84-3.52-.14-.84-1.41.28-1.55-1.27-.42-.84-2.11-1.55-.56-.7-.98-1.55-.98-2.67.28-.7,1.26-1.41-.14-2.53-.14-2.25-1.41-.7-.7h-1.83l-.98.7v3.66l1.69,1.97-.14,2.11-1.13.84-.84.14.42,1.12,1.13,1.41.42,2.25.7,1.41-.56,2.11-1.55,1.83-.14,1.12-1.13,1.55.14,1.69,2.39,2.25,2.25,2.11,1.27,5.34-.84,4.92-1.83,1.55-.56.98-1.55,1.55-1.55.7-.28,1.13-1.83.14-.56,1.12,1.41,1.69.42,2.67v3.37l.7,1.69.84,1.27-.07,1.33-1.27,1.9-.42,1.69-1.27-1.27-.84,1.9-.84-.42-1.48.21.21-1.27-1.69-2.53-1.48-.42v-1.05l-1.9-1.69v-1.05l.63-.84.21-4.01-.63-1.9.21-4.22-1.48-1.05-2.53.42-2.53-.21-1.27-.84-2.32-.21-1.69-1.9-2.96-.42-1.69-1.05-.42-2.11-.63-.21h-.85l-1.69-1.27-3.38-2.11h-1.26l-.84-.42h-2.32l-2.74,1.05-.21-.63.63-2.32-1.27-2.11-.84-4.22-1.48-.42-1.9-.21-1.9-2.11v-3.16l.21-.63.21-4.85,1.48-2.32.84-3.37,1.27-1.27.21-1.69,1.27-.21.84-1.9,1.69-.84-.63-2.32.84-.84.63.63h1.05l2.53-.84v-1.26l-1.05-1.48-1.69-1.27,1.27-.42,1.05.42,1.9-.21,1.48-2.11,1.05,1.05,2.11-.21,1.48-2.11,1.69-1.69.21-1.27.63-2.32-.63-1.26-.84-.63-2.95-.21-2.95-2.74-1.27-.84.84-.63,2.53.84,2.32,2.11,2.74.42,1.69-1.9,2.53-1.9.21-2.11-1.48-.21-.84-.84.21-1.05,2.32-.21.84,1.48,1.27.63,1.27.21,1.9-.84-.21-1.05-1.9-1.4-.63-.51.84-.51,1.27.25.84.63,1.05,1.32,1.69.21,1.27-.84,2.32-.94.21-1.01,1.69-2.15-1.69-1.9-1.27-.51-.84-1.52.84-.25,1.69-.13.42-1.26-1.27-.89,1.05-1.14-.21-1.01h-1.48l-1.05-.51-.42-.76.84-.38-.84-.51h-2.74l-1.48-.25-1.27-.63-2.11.25-.42.38-.21,3.04.84.38-.21.76-1.48.89-.21,1.39-.84,1.9-1.27,1.65-.63,1.01-1.48.38-.21,1.14h-.63l-2.74-2.4.21-2.78,1.69-.13-.21-1.01-.84-1.14-2.74-1.52-.63-.63-1.69.89v1.27l-.42,1.64-1.05.38-.84-.51v-2.53l-2.11-1.39.42-.51h1.69l-.21-.51-1.69-1.14-2.11.51-2.32-1.14.84-1.14-.21-.63.63-.13,1.69.13v-1.14l-3.59-2.66-.21-2.66-.63-.51-.42-1.39-1.27-.38-1.48-.13-.84-.76-1.26-.13-.63.89h-1.05l-.84.89,1.05.63-1.05.63-.84-.13-.63.25-1.05,3.04,1.05.76h.84v.63l-1.27-.13-.63,2.15,1.27,1.01,1.69.89,1.48.13,1.05.13.21.88,1.69.25,1.27-.38.21.76-2.11.76-1.05,2.15,1.05.51,1.05-.51.63-.51.63.88-.42,1.27-1.27.89-1.27.88h-1.48l-1.69.76-.21.76,1.69,1.52-.63.89-2.53-.51-.42-1.64.84-.63v-1.14l-1.26-.25-2.11-.89-1.47-.51-.84.38-1.9.13-.84,3.04-1.48-.13-1.69-.51-3.38.63-1.48-.38-1.2.51-2.81-.51-1.05-1.14h-2.74l-1.27-.13-2.32-1.52-.21-.51-.63-.13-1.05.25-.21.63-2.32,1.52-2.74.13-.42,1.52,1.05,1.9,1.27.89-1.05.76v1.45l-1.9-.94-.84-.88,1.05-1.01-1.69-1.27-.63-.13-1.27-1.01-1.48-.51-1.05-.38-4.01,1.14-2.32.13-4.85-.13-1.48-.38-2.95-.13-.42-.76.63-.63,1.27-.38.42-.51,2.32-.51-4.43-3.04-1.9.13-.42.38h-1.69l-1.9-.38h-1.48l-2.74-1.27-2.95-.63h-1.27l-4.85-2.53-3.17.25v1.27l-1.9,1.26-2.32-.13-.21-.38,1.05-1.01-1.69-.63.42-.63.63-.25-.42-1.14-2.32.63.21,2.02h-.63l-.21,1.52-1.9-.38-2.32-1.77v-1.77l-3.8-2.53v1.01l.84.63-.21.38h-1.05v1.14l-2.11,1.01.21-.76-1.48.38-2.95.89-1.9,1.52-.63-.25-3.38,1.77-.84,1.14-1.9.38-.21-1.01,1.06-.51-.21-.38,1.9-.51.21-.89,2.53-1.01h1.48l4.01-1.77v-.76l-1.48.25-.63-.25-1.69,1.01h-1.06l-1.69,1.01h-1.48l-2.32,1.01-.21.63h-2.11l.42-.63-2.11-.38-1.69,1.52h-1.05l-1.48.89.42.89,2.11.63v.63l-.84.13-2.74-.38-1.9-.89-2.32-.25-2.53-1.14-2.32-1.52h-3.37l-.84-.25h-.82v55.16l3.28,2.25.56-1.97,1.12-.84,1.41,1.69,4.5,6.75h1.41l2.25-2.53,2.25-.56,2.25,1.69,2.25,3.94,1.97,1.41,3.66,8.44,2.25,2.25,3.94,2.54-.56,2.81.28,2.25-.77,1.05-.21,1.9.42,2.53.63,1.69,1.27.84.63-.84.84-.21.21,2.11-.84.63v1.48l1.48.42,1.48-.42.42,1.48.63,1.27-.21,2.32.42,2.32,1.48.84,2.74.63,1.05,1.69h2.11l1.27.63,1.05,1.9,1.69.42.63,1.69h1.05l1.69,2.32,1.48.84h.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.9,198.68l-3.23.7-1.83,3.23-1.97,3.51-.7,3.09-1.12.98-.14,1.27-2.67,1.27.28.84,1.41-.14-1.83,1.83,1.69,1.69,3.94-.42,1.83.56,2.25-.84.84,1.12,1.97-.98.28,2.25,1.27.14,1.83-1.97.42,1.69-.56,1.27,1.41.28.56,1.12h1.97l.42-5.2-2.11-1.12,1.41-.42.42-2.11-3.38.7.56-3.8-2.53-.56-2.25.84v-1.12l-1.69-.28.28-1.83-1.41-.28-1.55,1.83-.28-1.12,4.21-8Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.45,224.69l-.56-1.69,1.27-1.69.84-2.11,1.12.28-.28,1.97-1.41,2.11-.99,1.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.86,225.39l.28-.84.84-1.55h1.55v1.12l-1.55,1.27h-1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.78,221.73l-4.36.28-.7-1.12-.14-1.41-1.12-.14v2.11l2.95,1.83,2.67.14.7-1.68Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.49,218.36l.42-1.41.84-.7h.84l-.14.7-.98.28-.42,1.12h-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.58,207.25l1.27-1.12,1.27.28,4.64,3.37-.84.7-2.95-.14-2.39-1.41-.98-1.68Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.38,246.92l1.39-2.78,3.94-1.39,2.41-4.07,1.27.14v2.11s2.39-.13,2.39-.13l1.13-1.12-.55-2.39,2.25.15,2.97-3.08,3.78-1.14.42-3.37-1.27-3.8,2.53-1.05,2.32.63,2.53-1.05,1.48-6.54,2.32-1.69,1.05-5.69-1.27-.42-3.38,2.11-2.95.21-1.48.84-2.32.21-1.27-4.22-3.59-3.58-2.74-1.05-2.74-.21-.63-4.22-2.11-4.43-.21-2.32-2.74-5.27-3.16-.63-4.64-1.48-6.75.84-2.95,4.85,2.11-.21-.21,2.32-2.11,1.69-1.27,4.22-1.48.84.21,2.53-4.64,3.16-1.58-1.69-.53,1.05-1.9,4.43-1.48,1.69-.21,1.9,1.69,1.05,1.05-1.27,2.32,1.27,1.27-1.9,4.85,1.48,1.27,3.37-1.27.84-1.9-.63-2.53.21.21,1.69-1.9.63-1.05-1.48-1.68.64-1.05,4.01-1.9.42-1.48-1.48-3.59,3.58-4.43-1.27-2.11,3.37,1.9,1.48-1.05,2.11-2.74.63-2.32,2.74-3.8,1.69-2.74.42-2.53-1.05-4.65,2.53-1.9.63-2.53-1.27-3.38-.21-3.16-2.74-5.06-.42-3.8.84-1.69-.84-.84.42-1.05,1.05-2.95-.21-2.11-2.53.42-3.37-10.13-4.43-3.59-.84-2.11-2.74,1.9-2.32-4.64-6.75h-3.37l-3.38-4.85h-.84l-5.49,4.43,1.05,4.01-1.69,1.69-2.32-1.05-3.59.21-2.32,5.48.26,1.75-1.32,1.41-1.48-1.9-5.91,2.11,1.9,2.11.21,3.16.63,1.9-1.05,2.95-2.32,2.74-3.38.63-2.53,1.9-1.9.21-.42,2.53-1.9.21-1.69-1.48-4.43,2.53-.84,1.9.63,2.95,2.74.42.63,2.11-1.48,2.95.63,1.05,1.71.69,1.05,1.58.74,2.42,2.32,1.58,1.98,1.95-.29-.16,2-1.53,2-.11,1.21,1.05.32,1.69-.58,1.85.1,1.16.74,2,.32.95-.84.42-.84.63-.98-.37-.63.63,1.69,1.48-.21,2.74,1.48.84h2.32l2.32,2.32,3.59-.42,3.8,2.95,3.8,1.48,3.38,2.53,6.96,1.48,1.48-.42,1.9.84,2.11-2.11h1.9l1.27,1.27,2.53-.42,1.48,1.05,4.85-3.58,6.75-2.11,1.27,1.05-.21,1.05,2.32,2.11,2.11-.21,1.69,3.58.63,4.01-2.74,2.95v3.37l1.9.21,2.53,2.95v2.74h2.53l.21,1.05,2.32.84.84,1.48,1.69.21-.63-3.16.84-1.9,1.69.63,1.27-1.27,1.69.42,3.59.21,1.48-2.53,1.69,1.48h3.16l.42,1.05-.42,1.9,1.69,1.48,1.9-.21.84.77,2.67.14,1.55.56-.14,1.69.56.84.98.14.28-1.41,1.97-.56.84-.84,1.12-.14,1.12-.7h1.55l1.97-1.55.7-2.11,1.12-.42.84.42v1.12l1.27.7,2.25-1.41h1.55l1.41-1.41,1.69-.14.56-1.41,3.09-1.41.14-1.55,1.55-1.27,1.12-.14.56-1.27,1.69-.84.14-3.09,1.27-.42v-1.69l1.97-1.97.14-.98,1.41-.98.42-.84-.14-1.41,1.27-1.55-.28-2.25-.98-.7-1.41.7-.56-.28.14-1.12,1.69-1.12,1.27-.56-.42-1.41-1.12-1.12h1.41v-.98l-1.12-1.41-1.41-1.27-.14-2.53-.98-.98-.28-2.25-1.97-.56-1.83-1.69.42-1.55,1.69-1.41v-.56l1.27-1.27.56.7h1.13l1.55-1.41.14-.7,1.27-.42h1.55l.56-.84-.42-1.27-3.8-.28-.98-.7-.98.14-3.09,1.83-1.69-.14.14-2.11-2.25-.28-1.55-2.39.84-1.69,2.11-.28.84-.42v-.7l1.12-1.12.42-1.41,2.25-.84,2.53-2.11,2.53.28.14,1.83-2.25,2.81,1.41.7-.14,1.41,2.11-.84,3.23-1.97,2.25-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.19,259.7l.14,3.09.42.98-.28,2.53-2.25,3.23v1.97l2.25,2.53,1.55,1.83,2.25,5.34h.98l1.55-1.27.14-3.37,2.11-.28,1.27-1.12-.14-2.57-2.25-1.02-1.27-1.05-.42-1.9,2.53-2.11v-2.11l-1.27-1.9v-1.47l1.12-1.2-.56-.84h-1.41l-.98-.84-2.11.28-1.12.98-2.25.29Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.8,290.09l1.56-1.29,1.55-.98,1.83-2.11,1.12-2.11-.14-4.36.84-2.25.42-1.83.42-.84,3.23-2.39,1.97-.7,1.83-1.12.14-1.55,2.25-2.53v-1.55l1.41-.98.98.56.14.7,1.12.42.7.56,2.11.28,3.09-.14.98.42,1.97.28,1.13,5.76.42,1.41-1.12,3.37-2.25.42-2.39-.14-.7,2.95-1.41.28-1.55.84h-1.12l-1.13,1.27-.28.98-7.31,1.97-2.81,2.11.21,2.27h-9.22Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.77,311.56h12.11l-.14-3.78,1.12-2.81,2.53-.14-.42-8.43h9.85l.56-4.22-.36-2.09h-9.22l-.69.4-1.55.14-1.69.84-2.11,3.37-.56.98-.84.28-1.55,1.83-.84,2.67-1.97,2.67-2.39,4.08-1.85,4.2Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.21,203.89l-.53.84-.11,1.27.11,1.69-2.21-1.69-1.9-.84-1.27-.42-2.74-1.9-2.11-2.18,1.41-.98.42-.56,1.44.56,1.58-.5,1.27-.66.95.21,1.58.11.21,1.69.74.95.21-.63.84.95.11,2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615.93,274.96l-1.05,3.8-.91-.98.77-.7-.63-1.05.42-1.62,1.41.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m559.59,463.48l.63,1.69,1.48,3.16,2.53,3.58,1.48,4.22-.21,2.32-.63,1.05.21,1.48,4.85,4.43,1.9-.42,1.48-1.27,3.59-.63,2.95-.42,5.7.21,1.05-.63,2.32-.42,3.17-2.32,4.01-2.95,1.48-1.9,2.95-3.37.63-2.53,3.17-4.22,2.11-2.32v-2.11l.84-1.48.07-1.27-2.39-.14-.7-3.94.42-3.23-1.27-7.45-4.36-1.05-1.69.84h-2.11l-3.38,2.95-.84,1.27-2.95,1.05-.42,3.58-2.11,2.32-2.53.21-1.48-1.05-1.69.21-3.59,4.22h-2.74l-1.05-5.06-1.93-2.12-.39,13.5-3.38.84-2.11-.63-1.48-.84-.84-.84h-1.06l-1.69,1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.65,243.85l2-1.05.84-.95.53.21v1.48l.74.74-.21,3.9-.42.84-.53.84-1.16.21-.53.63-.95-.42-.11-2.32.11-3.06-.31-1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.81,234.89v1.05l.21,1.16-.74,3.37-.74.53-.74-.84-.11-2.32.32-1.05,1.21-.79.16-1.21.42.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.22,264.31l.11-.53h1.9l.53.53,1.27-.11.63.32.63-.32.95.11,1.05.53v.63l-.74.11-.63.42-2.32-.11-1.37-.63-1.9-.21-.11-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1040.86,84.49l.56-.08,2.53.76,2.67-.42,2.25-.08,1.27,1.01h1.41l.28.42-.28.93-1.69,1.01-4.78-.17-2.53-.93-2.39-1.43.7-1.01Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1012.16,94.95l-1.69-.17-1.97-.93.7-.93,1.12-.42,2.53.93.14,1.1-.84.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m943.66,81.28l.28-.51,1.97-.42.42.42-.84,1.43-1.12.42v-.59l.98-.76h-1.69Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m929.88,70.65l3.66.08.28.59,2.11,1.18,1.41,1.1-.56,1.43-4.08-.25-2.11-.34-.84-.51-2.11-.08-.14-.42,1.12-.68.14-.93,1.13-1.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m929.6,69.3l-.28.76-1.41.84-1.69-1.01.28-1.35,1.55-.76,1.41.51-.28.93.42.08Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m922.28,57.39l-1.97.67v.24l-1.97.12v.24l.56.79-1.27.24-.14.24.28,1.46-.98.61,1.41,1.8h1.12l.98.51-.28.76,3.94,1.1.84-.68-.28-1.43.84-.34.7.17.14.76h2.53l2.25-1.26,1.55.17.14,1.1,1.83.34,2.39-1.26-1.69-.08-2.25-.84-.56-1.58,1.27-1.22h.98l.14.67-.84.37v1.1l1.55.75,1.83-.17,1.12.42,2.25-1.43-.84-.43,1.97-.43-.42-.67-2.39-.24-2.11-1.04-.7.18h-1.97l-1.55-.67-.7-.73-.84-.49-.98.06-.98,1.1-.14,2.07h-1.69l-.7-.37v-.55l-1.83-.43.14-.43.98-.37-3.66-.93Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945.35,60.38l.98.24,1.55.67h3.94l.84.49,2.53.24,2.95.62.84.76-.56,1.01-2.95.76-2.81-.09-3.09-1.43-1.83-.68-.28-.89-1.83-1.04-.28-.67Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m917.5,84.57l.7.51h1.69l-.28-.68-1.69-.08-.42.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m921.02,82.71h1.12v.42l-1.27.08.14-.51Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m878.54,71.24l.98-.17.98.25-.56-.68h-.98l-.42.59Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m883.88,73.1v-.51l.84-.68-1.41.34-.28.68.84.17Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m887.54,73.44l.7-.34-.28-.25-.98.08.57.51Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842.81,67.02l1.97-.08,2.25.17.14.34-1.27.68v.84l-1.97.59-1.69-1.18-.84-.25.7-.68.71-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855.05,67.53l-.98.51-.7.68.14.51h.98v-.68l1.41-.93-.85-.08Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842.95,54.89l1.12.18.98.79-.84.06-1.55-.85.28-.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m846.19,55.74l.7.3-.98.12.28-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m822.7,44.22l.21-1.37-1.48-.91v-.82l-1.9-1.01-.42-.82-1.48-.09-.63.82-1.27.46-.21-1.28,1.05-.46-.21-.73-1.69-.18-.42,1.1h-.62l-.21-.73-1.27-.27-.42.37.84.64-1.69.18-.63.55.21.37-.63.82.21.91-2.11.18-.21,1.74-.63.37.63.82-2.53,1.1v.64l1.69.91,1.48-.91,2.95-.46,1.9-.46h1.69l.63.64,1.69-.55h1.9l3.58-1.57Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m803.5,33.16l1.48.18,2.32,1.92-.84,2.83-1.05.46-1.9-.27v.82l3.38,1.46v.73l-6.54.82-1.05-.09-.42-.73-5.28-1.19-1.27.09-1.69-.64-.63-.91.21-1.28h-1.26l-1.69-.82.63-.37.63-.91,1.69-.18.21-1.28,1.27-.82,1.05.18,2.74-.64,4.22-.18,1.48.91-1.27.91.42.55,1.69-.46,1.48-1.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m800.76,28.23l-2.11,1.19-.21,1.28.42.82-5.7.18-2.11.46-.63.64-3.16.27-3.38-.82v-.82h-1.9l-1.05-.55,1.69-.82,2.11-.18,1.27-.91-1.69-1.1,2.11-1.1,5.49-1.65.63-1.28,1.69-.27,1.9.91,1.05,2.1,2.95,1.19.64.47Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.68,34.17l-1.05-.46-1.27-.09-2.32-.64h-2.74l.21.37,1.05.46v1.28l1.48.09,1.27.27-1.05.37.63.27,1.9-.82,1.9-1.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.75,35.75v.24l-1.55.06v-.24l1.55-.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m786.41,36.55l.56.55-.56.18-.42-.49.42-.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m778.53,36.42l1.12.12,1.13.37-1.41-.06-.84-.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m781.06,37.22h.84l.14.3h-.84l-.14-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m783.46,37.4l1.83-.12.28.24-1.69.12-.42-.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m825.09,45.08l.28-.18,1.27.24-.7.37-.85-.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m826.78,44.47l.84-.24.7.24-.14.37-1.27-.06-.14-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m826.5,50.01l1.27-.06.14.43-1.41-.06v-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.47,51.17l.7-.43.84.18-.28.85-1.41-.12.14-.49Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.02,52.27l3.66-.49-.14.73-2.39.73-1.27-.43.14-.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m790.77,54.35l.14.49-.84.12-.42.37-.56-.37,1.69-.61Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m791.9,54.28v.49h.84v-.55l-.84.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.3,54.16l.7.43.28-.55-.98.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m794.57,54.89l.56-.3.84.12-.14.49-1.27-.31Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m792.74,57.14l2.67.37.56-.12.14-.73-1.27.24h-1.83l-.28.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m797.38,57.94l.98-.3.14.18-.28.37-.84-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m767.28,64.66l.56-.51-1.12-.34-.7.17.14.51,1.12.17Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.04,69.47l1.27.08-.7.34-1.41-.17.84-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m756.73,69.3l.98.59.98-.51-1.97-.08Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m759.4,70.23l1.12-.08.28.42-1.12.08-.28-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m763.76,69.22l.84-.17.84.34-1.83.25.14-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m743.51,77.23l1.55-.76,1.12.17.28.76-.98.84-1.55-.17-.42-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.99,79.25l.98.25v.51l-1.69.93-1.83-.17.14-.59,2.39-.93Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m734.51,74.36l.42-1.26,1.69.17-.14.34-1.97.76Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m736.2,74.78l1.97.25-.56.51-1.12-.34-.28-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m730.99,76.73l1.41-.17.14-.59-1.41-.17-.7.25.56.68Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m719.31,76.47l1.27-.51,1.83-1.1-1.97-1.26-2.39,1.26v.93l1.27.68Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700.19,22.53l-.42.79-1.83.18-1.27.85.28.49-1.27,1.1,1.27.55.56.79.98.06,1.12-.85.28-.67,2.95-.06v-.73l-1.27-1.22.84-.67-.7-.61h-1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m694,26.92l.14.85-2.39.12-.14.67,1.12.98-.56.67-4.64-.18-1.27-.49v-.91l.98-.55v-.91h4.5l.98-.24h1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m691.89,25.27l.84.49-1.27.61-2.25-.18.14-.67,2.53-.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m695.12,19.36l1.69.67,1.27-.06-.14-.79-2.81.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.43,18.51l.28.85-1.55.43-2.25-.24.7-.85,1.27-.18h1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.21,21.25l2.25.61-1.83.55-2.67-.24.28-.43,1.97-.49Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677.26,22.59l1.27-.06,2.11.43v.43l-2.95.49h-2.81l-.7-.55,1.12-.12.84.18,1.12-.79Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m683.03,22.65l.14-.3,1.27-.37.84.37-.7.3h-1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m689.22,23.14l1.83-.18.14.24-1.27.3-.7-.36Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676.13,25.21l2.67.06.98.24,1.69.85-.28.55-1.27-.24-2.11-.85-1.69-.61Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m672.34,25.09l1.97.43,1.27.18,1.27.55,2.25.61,1.83.55-.42.49-1.55.37-1.27-.85-1.83-.06-1.69-.61-.28-.37-2.11-.55-.28-.67.84-.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m669.66,23.14h1.27l.42.3-1.41.3-.28-.6Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m678.67,24.3l1.12-.37h1.69v.49l-1.69.3-1.12-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m681.34,25.76l.28-.43,1.13.18.7.55-1.41.06-.7-.37Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682.32,27.1l1.12-.55.84.49-.84.49-1.12-.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m679.65,28.87l.56-.18,2.25.06-1.41.55-1.41-.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.18,26.79l.56.37-.28.37-1.69.24-1.41-.55-.14-.73,1.55.06,1.41.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m674.02,28.5l1.41-.61,1.83.12.42.37-1.41.3-2.25-.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m681.9,30.02h-2.25l.28.55-.14,1.04.42.79.98.12v-.85l2.25-.85h1.68l-.28-.37-1.69-.18-1.26-.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m685.84,32.77l-1.97.18-.14.37.84.55,1.12.3,1.12-.43-.28-.67-.7-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677.68,30.57l.42.43-.28,1.4-2.25.12-.28-.61.56-1.16,1.83-.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m681.06,34.23l1.12-.24,1.55.06v.3l-1.83.06-.84-.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m666.85,30.57h.7l.7.55-.14.79-1.97.18-1.69-.73,2.4-.79Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m669.81,28.68l-.56.18v.73l.84.18.56-.43-.84-.67Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m671.91,29.35l.14.43-.84.3v.24l1.55-.12.56-.49-.84-.37h-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.32,31.3l-.98-.06.14-.3.98-.12.84-.18-.14.37-.84.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m669.24,30.94l.14.67.56.24v-.55l-.28-.43-.42.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.24,26.18l.56.37-1.83.79.14.37,2.67-.12.14.55v.79l-.7.49-2.25-.06-1.12.37.28.37.84.24-.42.37-4.36.12.42.67-.56.85-2.25,1.28-1.27-.06v-.49l1.12-.49-.56-.3-2.11-.12-1.27-.73.7-.73,1.83-.55-2.67-1.22.14-.3,7.31-.18.42-.73,1.27-.49h1.12l-1.12-.73.56-.24,2.95-.07Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.33,27.71l-1.12-.85-2.39-.24h-3.8l-.7-.12-1.27.55-3.66.67-.84.43v.43l.28.37v.37l1.55.12,1.41.49.28-.18,1.69.37,1.12-.43-.56-.67-1.27.06.14-.67,2.95-1.28,2.81.06.28.61,1.27.18,1.83-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m656.86,32.1v.73l.28.24,1.97-.12-.84-1.16-1.41.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.13,33.56c.69.2,1.4.37,2.11.49l1.41.18-.14-1.04-.7-.24-.7.37-1.98.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.61,33.74l.42-.55.7-.3,1.12.37-2.25.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.8,25.45l-.7-.24.14-.37.84-.06.42.37-.71.31Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.94,31.24l-.42-.85.98-.18,1.12.43v.73l3.23.18.28.3-.42.61.84,1.04.84.12.7-.73-.14-1.04-.42-1.16,1.83-.67.7.37v.79l-.84.3.7.3.28.55,1.55.12,1.12-.37.28-.85,3.38.06,1.69.61,2.39.3,1.97.24-1.27.55-.14,1.77-.98.49-.14.43-1.83.73-.42.85-2.25.98-2.67-.24h-2.24l-3.66-.12-4.08.06-1.27-.67-.84-.12-1.69-.67.42-.24,2.67.12.28.18,1.12-.18-.56-.43.98-.37,1.41.06.84-.43-1.41-.49-3.66.06-2.95.49-1.83-.18-1.27-.79,2.81-1.16-.7-.24-1.97.06-.84-1.1,1.83-.24.98.49,1.55.37.56-.43-1.27-.73-.42-.79,1.12-.06.28.55,1.27.55.57-.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593.57,32.04l-1.27.06v.67l1.12-.18.14-.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.75,30.27l.7-.12.28.3-.84.12-.14-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.75,29.72l.7-.24-.42-.3-.42.06.14.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.2,28.25l-.14-.37.98-.06.56.43h-1.41Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.61,28.56l.14.3,1.27.18-.14-.43-1.27-.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.19,28.87v.43l-.98-.12.98-.31Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.4,29.54l.98.12-.14.43h-.7l-.56-.24.42-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.31,31.18l.14-.49.84-.18.7.37-.56.43-1.12-.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.09,37.46l1.55.61h-2.11l-.14-.43.7-.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.52,38.68l.28-.24.84.06-.28.37-.84.12v-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.42,39.23l1.97.18.7.91,1.27.37,3.8.67-.98.61-2.11.61-3.23.73-1.27.98-.14,2.01-1.69.55.28.73-.7,2.19-2.11.79v1.95l-.98.73-.84,1.22v.67l-.84.06-2.11-.85-.14-.55,1.12-.49-.84-.37-.84.12-.14.24-1.27-.06-.7-.55v-.37l-1.83-.36-.42-1.1-1.27-.79.56-.67,1.41-.06.98.43,2.39.06-.14-.37-2.11-.3.42-.24,1.69-.12,1.55-.37,1.83-.24.28-.43-1.41-.3-1.55.55-1.83-.06-1.69.43-.7-.06-1.27.55-1.12-.3.98-.73-.7-.49v-.67l1.97-.12.84-.73,1.55.06.56-.37-.42-.49.84-.12,2.39-.06,2.11-.43.42-.37h-1.14l-.98.18-.84-.18,1.27-.61,1.12-.61-.98-.18-.7.37-1.69.73h-.98v-.85l.84-.61-1.12-.37-.84.43h-1.12l-.56.43.56.67v1.16l-.84.12-2.81.67-1.55-.12-.28-.37-1.69-.61.7-.49,1.83.12-.14-.3-1.83-.18-1.27-.06-.7-.91.56-.43-1.27-.43.28-.49.98-.12.7-.12v-.3l-.98-.12-.14-1.22.56-.61-.84-.24-.7.24.14.55-.84.43-.98-.12.42-.55-.98-.55.14-1.95,1.41-.43-.42-.37-.84-.3,1.27-.24h1.41l-.42.43,1.83.06v-.61h3.1l.98-.18.98.12-.42.67-.98.37-2.67.37v.43h1.83l.28.3v.49l1.27.3.28.73,1.27.79.42-.85-.7-.55-.84-.79.98-.85.7-.49.14-.43,1.41.06.56.79.56.49.14.79.28.55.14,1.52.98.55.28.61.98.43.7-.18-.28-1.04-1.69-1.34.42-1.71-.28-.3-.56-2.62.84-.24.56-.49,1.69.12.42.37-.14.55,2.11.18,1.12.98-.7.55v.61l-.42.43.56.24,1.27-.79,1.12.18.84,1.22.14,1.16.27.16Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.84,43.13h-1.55l-1.27.55-.84.06-.56.43.98,1.1,3.52-.24-.28-1.89Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.23,45.32l-.84.24-2.81.12-.42.37h-1.82l-.28.49,2.39.67-.98.55v1.65l-1.27.61v.61l.7.3,3.52-.98,1.69.06-.28.3-.98.49.42.73,1.97-.55.98-.55v-.85l1.41-.73,2.39-.18-.14-.37-2.11-.61-.28.3-1.41-.06-.42-.67-.98-.3.84-1.22-1.27-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570.64,40.2l-.14-.43.7-.06.98.3-.28.49-1.26-.3Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m542.65,43.67l-.56-1.34-.7-.55.98-.3,1.27.49.42,1.52,1.83,1.1.7.55-.7.73-1.27-.37-.56-.85-1.12-.49-.28-.5Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.92,92.16l3.38,1.52-.21,1.14h-1.05l-2.74-1.14-.63-1.01,1.27-.51Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m710.45,53l3.8.73.42,1.37-1.27.82.21,1.01-2.96.37-3.8,1.37-4.01.46-1.27.46-3.17.37-.42.64-2.53.64-1.48.46-1.27.91-3.59,1.22v1.14l-1.27.25-.21,1.01h-2.74l-.42,1.01h-1.27v1.39l-1.05.89-1.27.13-.21,2.02-2.96,3.42-2.32-.63-.63-.38-3.38.13-.42-.89,1.27-.76,1.69-.38-.21-.38-3.38.51-1.9-.88.84-.63,1.69-.13.63-1.14.84-.38c.57.07,1.14.2,1.69.38.44.12.91.03,1.27-.25l-1.48-1.01.42-1.01,1.9-.25-1.27-.76.84-.51.84-.38-1.69-.51-.21-1.26-.84-.51,1.27-.38,1.69.38,1.9-.64v-.64h2.74l.84-1.65h1.05v-.73l2.74-.27,1.69-1.1,1.69-.09v.55l1.9-.27-1.27-.55.84-.73,3.38-.09.21.55,3.16-.73,7.39-1.37.42-1.37,2.32-.27,2.53-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676.91,76.34l-2.53-1.26-6.12.13-1.05,1.77-1.05.25-.84,1.01,1.05.89-.21,1.65-1.05,1.01-1.9.25-.84,2.28.63,1.01,1.27.51,1.26-1.01.21.89,2.11.51,1.9.38-1.27,1.77.21,1.39,2.53.13,2.74,1.26,3.16-.63,2.32-.38.42-1.14-5.27-3.29-.84-1.77.21-4.81,1.69-.13,1.27-2.66Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m665.51,86.34l2.11,1.01-.21.76-3.16-1.64,1.27-.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.85,96.59l2.53-.25,1.27,1.14,1.9.38-.42,1.52-2.53.89-3.8-.38.21-1.26.85-2.03Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.97,87.86l.56.59,1.12-.17-.42-.68-1.27.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m584.56,87.86l.42.51-1.55-.08,1.12-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m582.31,88.03l.14.42-.7.51-.98-.34.84-.59h.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.75,90.31h0l-.28-.25.56-.34.7.17-.42.34-.56.08Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.07,91.15v-.34l.7-.17.42.42-.56.34-.56-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.38,92.24l-.42-.42.56-.34.42.17v.51l-.56.08Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m575.42,90.39l.42.59.84.08,2.53-.93.28-.76-.98.17-1.27.59-1.83.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.2,93l-.14.34.84.09.42-.59-.14-.51-.99.67Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.37,92.24l.28.42v.59l-.7.25-.42-.68.84-.59Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.97,92.41l.14.68h-1.55v-.43l1.41-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.28,94.52l-.28-.42.42-.51h1.69l.28.76-2.11.17Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m563.47,96.12l.56-.76,1.27-.34,1.12.08v.59l-1.12.68-1.83-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.48,96.54l1.27.17-.98.84-.7.84-1.12.25-.84-.34.56-1.01,1.83-.76Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.11,97.56l-.98.17-1.83.68-.56.42.98.42.84-.42,1.55-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557,99.83l-.14,1.18-.7.84.56.51.98-.51.98-1.18,1.27-.59-.84-.25-1.12.25-.99-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.62,100.26l.42-.51h1.27v.59l-1.27.25-.42-.34Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.76,102.62l-.14-.42.56-.51.84-.08-.14.42-1.12.59Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.79,102.62h-.98l-1.83,1.01-.14,1.01.56-.68,1.41-.51,1.12-.59-.14-.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.93,152.44l-.63-.42v-.84h.84l-.21,1.26Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.29,167.62l-.14-1.12.7-.98,1.12.28-.14,2.39-.98.56-.56-1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.92,162.56l-.42-.7-1.69-.56-1.83,1.26.42,2.11.84-.14.56-.84,2.11-1.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.67,158.62l.84.14.14.7-1.41.7-.56-.98.98-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m561.07,170.15l-.7.28s.28-.98-.28,1.12c-.14.84-.43,1.65-.84,2.39l.7-.28,1.12-3.51Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.19,172.96l1.55-1.26,1.41-.42.98-.98,2.53-.14.42-1.26v-2.11l-1.83.56-.98,1.12-1.27.98-1.27.42-1.41,1.41-.14,1.69Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.04,176.9l-1.41.28-.28.7.98,1.41.7.7h.98l.42.7,1.12-.7.42-.98-.56-.98.28-1.41-1.27-.42-1.4.71Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546.73,181.68l1.12-.84h.7l-.28.42-1.12.84-.42-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.77,181.68l.42-.56,1.27.56.14.84-1.41-.14-.42-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.11,178.73l.98-.42,1.69.14.42.98-.84,1.12-1.69-.42-.56-1.41Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.48,185.76l1.05-.63-.84-.1-.21.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.53,162.14l-1.48.53h-3.8l-.95,1.16-.53,2.21-1.48,1.26v1.37l.63.63v1.58l-1.37,1.26-.42,1.37.21,1.48.21.63.84-.84.11-1.16.95-.84.32.53-.11.74-.84,1.58-.21,1.26v1.9l.42,1.05.42-.74.21-1.48,1.16-.63.32.63.11,1.05.42.84-.11,1.05-.95.84-.21,1.58.53.32,3.17-.1,1.37-.74-.21,2,.42,1.37.53,1.05.63.42.21,1.48-.63.95-1.58.74-2,.42-.42,1.37.74.21-.42,3.58-1.16.21-1.05.53-.32.84.42.63,3.17.11.84.74,1.27.21.42-.32h.84l-.43,1.06-1.37.32-1.9.32-.21,1.16-1.16.32-.53,1.48-1.58,1.58.11.63,1.16-.21.84-1.16,3.38-.11.21-.95,2.11-.74.63.53,4.11-1.27,1.37.42,2.43-.11,2.64-1.79-.11-.84-1.58-.11-1.27-.11.32-.53,1.27-.21,1.48-1.58.63-1.69-.21-2.85-2.64.32-1.16-.74-.32-4.96-.53-.95-2.11-2.53-1.05-.53-.42-3.48-1.37-2.64-1.48-.74-1.79.74-.21-.84,1.16-.95-.11-2.43,2.32-4.11-.21-1.58-2.85-.21-2.85.21.53-2.21,1.79-1.58.32-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498.62,187.23l-.42-.42v-.74l.95-.53-.11.74-.42.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.77,177.43l-.21,1.16-.84.1.32-1.26h.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.77,167.62l-.42,1.37-1.16.1.21-1.26.53-.21h.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.92,163.19l.11,1.48-1.05.95-1.16.53-.11-.95,1.37-1.48.84-.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.59,251.45l1.05,1.05,1.27,1.05.32,1.05.53.11-.11-1.58-1.69-2.32h-1.16l-.21.64Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m584.28,244.38h.63l.32.42-.95.32v-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.86,247.86l-.32-.42.32-.53.84.11v.53l-.84.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.18,252.5l.21-.32-.11-1.16-.21-.63-.63.32v.95l.74.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.18,249.34l.74-.11.21.42-.42.42-.53-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m589.45,255.35l.42-.53.53.32.11.53-.53.32-.53-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.18,256.09l.32-.42.84.42-.21.42-.63.21-.32-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.75,258.09l.53-.42.74.21.11.42-.95.21-.42-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m590.82,263.15l.53-.32.53.21.11.53-.74.32-.42-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606.12,265.57l1.48-.84,2.74-.63.74-.63h.63l-.74,1.05-.53,1.37-2,.84-2.21-.21-.11-.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.99,252.82v.84l-.42-.32.42-.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m655.87,411.4l.7-.28.7,1.12.28,3.09,1.69,5.48-.28,1.83-1.55.28-.14,4.22-.56.98-2.25,7.73-1.26,4.36-1.41,3.52-.98,6.19-1.83,2.53-2.39.28-2.11,1.55-2.25-.98-1.69-1.97-.7-4.36-1.41-1.83v-3.09l2.53-3.8.7-5.34-1.12-1.97.84-4.92.98-1.41,1.55-.7.7-.7,1.55-.28,1.98-1.41,1.83-.56.84-1.27,1.27-.98v-1.83l1.55-.7,1.55-2.95.7-1.83Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.91,365.85l-.21-.53.32-.63.74.21v.42l-.84.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m533.64,370.8l.21-.53.74.21.11.42-.74.32-.32-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.69,373.65l-.11-.42.42-.32.42.53-.21.42-.53-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m750.25,347.85l-.7-.98h-.98l-.98,1.12-.14,1.41-.28,1.41.98,5.62.98,1.27h1.82l2.81-2.95-.14-1.12-.56-.7-.14-2.11-2.39-1.69-.28-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m789.78,336.33l-.63,1.05-.21,2.53-.21,1.48h.63l.21-3.37.21-1.69Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788.72,343.71v-.84l.49.49-.14.42-.35-.07Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m918.91,180.56v-.84l.56-.7,1.12.14.7.7-.98,1.26-1.4-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m918.06,179.58l-.84-.14-.98.42.7.28.56-.14.57-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m935.36,183.94l-.56-.84h-1.13l-.14.7.7,2.95-.42.7-.84-.28-1.4.57.56,1.55-.56,2.95.7.7-.7.98.56,3.23.84.98v5.48l.42,1.69-.56,2.11-.56,3.09.56,1.55-.14,2.67-.28,1.97-.14,4.5.7-.14.56-1.41.98-.7.84.56.98,1.41.7-.84v-1.69l-1.41-1.41-1.12-1.41v-2.67l.56-1.12v-.98l.42-.7.28-3.09.7-.56,1.27.42,1.55,1.55.28.56.56.14.28-.7-.28-1.27-1.27-1.69-.7-3.8-.84-3.09-.84-5.2-.14-2.53v-3.09l-.56-2.81-.41-.99Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m931,225.55l.28-1.27h1.83l.7.98.84,2.25,1.12.84,1.12.28,1.27.98,1.27.7,1.41-.42,1.27-1.12v2.39l.98.28.28,1.12-1.27,1.41-1.97.14-1.55.28-1.69,1.97v1.12l-1.12.28-1.27-1.41-1.83-.28-.7-.42-.98.7-1.97-.42h-1.12l-.84.56,1.41,1.27v.98l-1.83.84-.56-2.11-1.12-.28.98-1.27,1.69-1.27v-1.25l.84-.84,1.12.7.98-.42.14-.98.84-2.11.14-3.8-.7-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930.4,243.02l.11-2.74-.74-.63-1.05.84.42,1.05.53,1.16-.84.11-.84-1.16-.84.21-1.05,1.79v5.48l-1.27,2.95-2.22,3.06-1.37.84-.63,1.16-1.69.84-.95-.53.63-1.69-.84-.21-.74.53-.1,1.48-3.48,4.53-2.11-.21-1.58.84-2,.11-1.48-.53-1.37.11-.63,1.37-2.53,1.9-1.05.32-1.05.74.21,1.16,1.9-.11.21.74,1.48-.95,3.06-.63.95-1.16,3.27-.84,1.9.84.21,1.37-.42.84.42,1.37,1.16.63,1.16-.63.32-1.58,1.48-.11-.11-.84v-.73l-.53-.95.53-.95h1.37l-.1,1.37,2.74-.11.84-1.16.84-.21.1,1.48,1.05-.21.32-2,1.48-1.37.84.63-.1,1.05-.54.52.95.42,1.9-2.74-.42-1.27.21-1.16,1.48-3.27-.95-1.37.42-1.48.95-.74.74.21.11-2.32,1.27-2.64.1-2.32-.32-.21-.63-1.37-1.05-.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m922.7,252.4l-.42,1.16-1.16,1.05-.32-.63.84-1.16v-.74l1.05.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m910.36,267.58l-1.16-.63-1.16.21-1.37,1.48-2.11.32-1.05,1.05.74,2.32,1.48-.11.63-1.48,1.16-1.05,1.05.42,1.16-.21.63-2.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m898.76,268.53l2.53,1.26.42,1.05,1.16,1.79-1.9,2-.21,3.06-2,.63.1-1.79-.53-.11-.74,1.16-.63-.32.32-2.85c.69-.08,1.2-.68,1.16-1.37,0-1.27-.32-1.48-.32-1.48l-1.27,1.05-1.27-1.05-.1-1.37,1.69-.63,1.58-1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m894.96,266v1.16l-1.05.11v-.53l1.05-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m885.89,270.64l-.21-.53.74-.21.84-.42.63.53-.74.63h-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m892.95,273.07l.53-.11.11-.42-.74-.11.1.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m893.8,271.59l.42-.42.42.32-.1.32-.42.11-.32-.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m895.7,269.27l.21-.63h.42l.11.63h-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m899.7,279.5l-.42.84v.74l.42-.11.74-1.37-.74-.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m898.02,280.76l.42.21-.1.42-.74.32-.1-.63.53-.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m943.17,229.94l1.69-2.21,1.16-.11v1.05l-.53.21-.53-.11-1.26,1.37-.53-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m946.86,228.36l.32-1.16,2.43-3.06.32.63.95-1.05,2.32-.21-1.79,1.79-2.32,1.05-1.58,2h-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945.91,230.89l.11-.53h1.05l-.63.63-.53-.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m954.35,222.88l2.22-2.21,1.37-.11v.42l-2.11,1.9-.95.21-.53-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m961.1,217.71l1.48-1.37.63.11.1.63-1.27,1.27-.95.11v-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m973.76,200.84l.53.1-.53,2-2,.63-.53-.84,1.27-.84,1.26-1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m970.81,205.27l.21.84-.63.84-.74.11.21-1.69.95-.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m967.96,208.85l.53-.63.84.11v.53l-.84.74h-.53v-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m965.54,212.23l.1-.53.63-.53.21.84-.53.42-.42-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m869.81,298.51l.7-.56,1.83.42v3.94l-1.54,1.69-.84,3.23-1.12.28-.84-1.41-.14-3.23,1.97-2.95v-1.4Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m840.73,314.71l-1.69-.74-1.05.11-1.9.74-.63-.32-1.79,1.9v2.42l1.79,1.05,1.9-.21,1.58-1.48.84-2.42.95-1.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m895.77,287.12h-1.2l-.98.91v.49h1.41l.77-1.05v-.35Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m893.52,289.37l.7-.07.21.7-.77.21-.49-.42.35-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m890.21,293.87l.56-.98.98.14-.49.84-1.27,1.05-.35-.84.56-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m881.91,299l.49-.63.77.21.21.42-.77.35-.7-.35Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.38,300.06l.49-.77.35.35-.07,1.05-.49-.07-.28-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.48,300.69l.56-.21.84.14v.35h-.98l-.42-.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.58,358.4l2.11.7,3.94.14.98.28,1.27,1.83.56,1.12.7.42,1.97,1.83,1.83.84,2.39,2.67h.98l2.81,2.53.7,1.41,2.11,1.69,2.25.14.28.98v1.55l1.83,1.55.98,3.09,1.27.14,2.25,2.67v6.89l-1.12.28-2.81-1.69-2.67-.7-5.06-4.08-3.09-4.64-.56-1.97-3.52-3.8-1.27-.14-1.12-4.36-1.41-1.83-1.97-.84-.42-1.83-1.83-1.41-1.41-.14-3.09-3.94.15-1.4Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823.26,379.91l.84.28,2.39,2.95,1.41-.56-2.67-3.8-1.83.14-.14.99Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m829.87,382.86l.98-1.41.98.42.7.84-.28.7-1.55.56-.84-1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m849.98,397.91l-.7-.84-1.27.28-3.38-.84-.14-1.83-4.92-1.27-.56.56-.42.98-5.49-.85-.56-1.55h-2.81l-.84.42-2.39-1.27-1.69,2.25,1.55,2.25,4.92.42.98.42h3.95l3.09,1.41h5.49l3.23,1.12h2.11l-.15-1.68Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m845.9,395.09v.7l4.08-.28.42-.84-4.5.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m851.11,398.04l.14,1.41,1.27.56,1.27-.28-.28-1.55-2.39-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855.47,384.13l-.14,1.27h.7l.14-1.97-.7.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855.18,399.59l.84-.98,1.27.84,2.11-.42,1.13.28.42-.42,3.52-.28.56.84-.98.84-5.34.84-3.09-.7-.42-.85Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866.16,399.87l2.81-.98,4.08.14.42.84-.56.56-6.19.14-.56-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m864.05,402.26l.56-.56,2.81.56,2.11,1.97-.7.42-2.67-.84-2.11-1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m887.96,398.89l.28.84-.7.84-2.67.84-1.83.42-1.12,1.55-2.53,1.12-1.55-.14-.14-.98,1.41-1.41,1.12-.56,2.39-1.69,5.34-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.1,399.73l.14-.7,1.41-.56,1.55-.28v.7l-1.55.7-1.55.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m876.42,399.31l.7-.84,1.27-.28v.56l-1.55.98-.42-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m874.03,399.45l1.55-1.55.84.56-1.55,1.27-.84-.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m884.58,397.2l2.25-.84.28.42-.56.7-1.83.42-.14-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880.64,369.36l-.84,1.69-2.11.56-3.66.14-3.23-1.41h-.84l-.98,1.55-.84-.14-.98.42-.7,2.53-.84,1.55-.42,1.55.28,2.39-.7,1.55-.56.14-.42,2.53,1.69.14.7.98.28,2.67-.98,1.97v.84l1.41-.14.84-2.39.28-4.64-.7-.84.56-.56.98.14.28-.98,1.27.7-.14,2.81,1.55,1.69-.28,1.97,1.27.28.7-2.11,1.12-.14-.14-.84-.84-1.83v-2.53l-2.39-.84-.42-.98.56-.42,1.69.28,2.11-2.11,1.83-.14.84-.7-1.55-.84-2.67.28-2.67.98-1.12,1.41-2.67-2.39.28-1.69,1.12-1.27h7.74l1.83.56,2.67-1.12,1.27-3.23h-1.41Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m870.24,319.04l1.41.7,1.69-1.12.84.56-.42,2.95.98,1.12-.14,1.83-2.81,2.25-.42,1.27.84,2.53.42.84-.56,1.41-.56.7-1.83-1.12-.14-2.39-1.82-.83-1.27-3.09.42-.98.98-.14.7-4.36.7-.84v-1.12l.99-.15Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m869.81,334.08l1.55,1.27.28,1.69-.56.7-1.27-.28-.56-1.97-1.27-.98.42-.56,1.41.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.91,332.95l1.12-.98h1.12l.98,1.12,1.12-.7.98,1.27.42,1.83.98.42-.42.84-2.67-1.41-1.55-1.41-.56.84-1.55-1.83Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880.36,337.59l.98-.28,1.41.42.84,1.27-.28,2.25-1.27-.7-.56-1.41-1.12-.98v-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.24,333.66l-.28-.42.28-.84.98.28v.84l-.98.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m876.57,339.14l.14-1.55.84.14,1.13.7v.56l-1.27-.56-.84.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m873.75,340.26l-.28,3.1,2.11-1.27.42-1.41-.98-.42h-1.26Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.83,342.65l-.28,2.39-.84,1.41-.98.56-1.55-.98.28-1.12,2.11-.56-.7-.7.42-1.41,1.54.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m878.68,341.81l-.56,4.08.7-.28.42-1.12-.56-2.67Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.66,341.25h1.55l.98,1.41.42,1.27-1.41.14-.14-1.41-1.41-1.41Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.38,345.89l.84-1.27.42-.14.84.14-.98,1.41-1.12-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m878.82,352.07l1.12.84-.7,1.55v.84l2.25,1.97.84-.56.56-.28-.14.98.7.56.42-.42v-1.83l-.7-.84.14-.98.7-.28,1.41.98.84-.98.28-1.83-.84-1.27.14-1.41-.56-1.69-2.11-1.27.56,1.27-.56.84-.42-.42h-.84l-.42,1.12-.98.14-.28,1.41-.98.28-.42-1.27-1.55-.98-2.25,2.39-.98.28-.84,1.41v.98l.7-.28.56-.42v-.7l.98-.7.84,1.12.84-.56h1.69,0Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m884.44,344.48l-.56.28-.7-.42.14-.98,1.27-.14-.14,1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m889.79,372.32l.42,1.83.84,1.41h.84l-.7-1.41-.28-1.27h2.67l-.7-.98h-.98l.28-.56,1.41-.42.14-.84h-1.41l-1.27,1.12-1.26,1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m889.79,371.19l.7-.98-.28-1.41-.7.14.28,2.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m891.9,367.68l.56-.84.7.7-.7.84-.56-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886.83,361.63l.84-1.41.42.56-.42.98-.42.28-.42-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m889.5,374.85l.56.7.42.42-.42.56-.84-.56-.28-.7.56-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m885.85,383.56l.42-.98,1.83.14.7.98-.42.84-1.55-.14-.98-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m890.91,383.42l2.39-.98,3.23-.14,1.27.84,1.41.14.84.7v1.41l-.56.28-2.53-1.69-2.25-.28-1.97.14-1.12.7-.7-1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880.93,380.05l-.98-.56v-.56l1.12-.28.84.42.84.28h2.11l-.14.56-3.8.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m876.56,387.78l-.56-.7-.7.56.56.98-.7,1.41-.56.7.56.28.98-1.12.42-2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875.16,388.91l-.84.28v.42h-.7l.42-1.27.7-.14.42.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904.84,391.86l-.7-1.12.7-.28.98.14.42.7-1.41.57Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m900.05,397.9v-.84l1.55-1.55.28.84-.42,1.12-1.41.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m895.84,397.62l-.14-.56h1.27v1.12l-.7.14-.43-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.2,393.97l-.14-1.27.7-.28.56.98-1.12.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.9,391.16l.14-.84h.98l.14,1.69-1.27-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m929.35,381.68l2.91,1.32,4.64,1.41,1.83.7,2.53,1.97,1.97.84.42,2.53,4.78,1.83.98.7-.28,1.12-1.83.42v.7l1.55,2.11,1.83.14-.14,1.55,1.41,2.11,2.25.84,3.66,2.11.42,1.41-.84.14-2.39-.7-2.53-.84h-2.67l-1.83-.98-.7-1.97-1.41-.7-1.12-2.11-1.55-.28-3.09-1.41-1.97.28.42,1.55h-2.68l-.42.84,1.55,1.27-1.27.84h-5.49l-.42-6.05-.84-1.27-.14-1.12.98-1.27-.52-10.04Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m922.56,395.51l.56,1.12.14,1.97-3.38.28-.14-.84,1.27-2.25,1.55-.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m889.79,378.78l1.13.14.14-.7-1.27-.14-.56.42.56.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m896.68,379.63l-.14-.56.42-.84,1.69.14v.7l-.84.7-1.12-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m912.57,375.69l2.39,2.25,1.27-.56-1.83-1.55-1.83-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m961.1,386.52l-.28,1.41-2.81,2.39h-2.81c-.76-.08-1.51-.22-2.25-.42-.69-.17-1.4-.22-2.11-.14l.56,1.27,2.11,1.27,3.23-.14,5.2-1.97.7.14-.14-2.53.42-.84-1.13-1.12-.7.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m957.16,380.89l1.27.56,1.69.28,1.83,1.12,1.55,1.69,1.41.84.28,1.83-.98.56-1.27-2.81-.98-.28-1.12-1.55-2.39-.7-2.25-.7-.14-.84h1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m970.1,390.88l.14-.84,2.53,2.25.28.7v1.41c-.46-.48-.98-.91-1.55-1.27-.42-.14-1.41-2.25-1.41-2.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m975.17,394.11l.28-.98,1.41.42,1.12,1.41-.84.56-1.97-1.41Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m981.07,397.2l-.28-.98.84-.42,2.67,1.27,1.27,1.69h-.98l-3.52-1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m987.82,400.58l-.56-.98.56-.7.98.28,1.97,2.81-.14.7-.98-.28-1.83-1.83Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.76,406.2l-1.55-1.12-.28-.84h1.27l1.12.56.14,1.27-.7.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m986,408.73l-.42-.42v-.7l.84-.28.98,1.12-1.41.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m986.42,402.69l-1.41-.98v-.42h1.41l1.27.84-1.27.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m958.29,403.25l.56.56.14.98h.7l-.14-.98-.7-1.12-.56.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m963.49,405.92v-.56l1.12-.14.56.7-.7.42-.99-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.25,421.1l.84-.84v-1.41l-1.27-.56-.28.98v1.12l.7.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.95,421.8l.28-.42,1.55.98-.14.56-1.69-1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1012.16,430.24l-.14-.7.84-.28.7,1.27-.7.28-.7-.57Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1012.86,432.77v-.98h.7v.7l-.7.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.81,437.13l.14-.7.42-.28.56.56-.42.56-.7-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1005.41,435.86v-.56l-.56.14v.56l.56-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m998.8,435.02l.84.7.84.14,1.97,1.55.84.56,2.53,1.69.28.84-.56.42-1.69-.56-3.23-1.83-.84-.42-1.55-1.55-.14-.7v-1.12l.7.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1038.32,428.48l2.11-.21v-1.27l-.63-1.05-2.53.21-.21,1.48,1.27.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041.49,424.05l3.16-1.69-.84-.63-1.05.42-2.53,1.48,1.27.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024.82,483.94l-1.05-1.27v-1.48l3.16,2.74h.84l1.48,1.48v1.48l1.27,2.74,1.05,1.05.42-.63-.21-1.48,1.27,1.48.63,2.53,2.11,1.27,2.32-.42.84-1.48,1.69-.42v2.32l-.84,1.27-.42,3.58-1.48-.63h-1.9l-.21.84.63,1.27-1.05,1.27-2.53,5.27-1.9.63-1.9-.84,1.69-1.69.21-2.32-1.9-2.11-2.11-.63v-1.48l2.53-.63.63-2.53-1.05-4.22-1.27-2.53-2.95-4.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024.39,505.03v1.69h1.05l.63-1.05,1.48.21-.42,4.43-1.69,2.53-1.05,1.48-.63,2.11-2.74.84-1.48,1.9-2.32,5.01-4.01,3.76-4.85-1.61h-2.32l-.42-1.61,1.69-3.65,1.9-2.11,3.38-1.9,2.53-2.53,3.59-2.11,1.05-1.9v-1.48l1.9-2.53.21-1.9,1.69-.63.84,1.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1009.83,528.65v1.26l-1.27.36.42-1.79.84.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m948.44,496.17l1.12-1.41,1.83-.42,4.78-1.27.14-1.55-.14-2.81,2.39-4.64-.28-1.13,2.11-3.23v-1.27l3.09-3.8.98-1.41v-1.12l1.27-1.69v-.84l-.28-2.11.84-2.53v-3.8l.7-1.97-1.41-1.69-.41-1.82.56-4.5-.28-.56-.84,1.12-1.41-2.11-1.55-2.67-1.41-.84-1.98-1.97-.28-1.97-.99.14-1.27.28-1.83-1.69.14-2.81-1.41-1.83-.28-1.55-.56-.84-2.11-.28-1.27-1.69-2.39-.28-.42-2.25-.7-1.26-.7-3.66-1.55-1.69-.28-5.2-1.13-.42-1.41-.98-.84-.14-.56.98-.56-2.67-1.55-2.95-.14-1.83-.98-1.12-.14-1.97-.98-.84-.56.42-.42,1.97-.43,1.12-.98.7-.42,1.12.98,1.12-.56.56-.7.84v1.69l.84,1.12-.28,1.27-.84,3.09-.84,4.64-1.69,1.55-2.53-.14-1.69-1.4-.99-.84-2.39-.84-2.25-1.83-.28-.7-1.83-.14-.42-.7-1.41-.84-1.12-.56.42-1.27.84-.7v-2.53l1.69-.7.7-.7.14-1.41v-1.41l-.84-.14-1.12.42-.7-.56h-2.67l-1.69-.84-3.09-.14-1.55-1.12-2.81-.14v.7l2.25,1.27-.42,1.27-3.8-.14-1.69.14-1.55,1.69v1.12l-.84.42-1.27,3.09,1.55,1.55.14,1.27-.42.56-.7-1.12-1.27.14h-.7l-.14-.98h-.7l-.98.98-2.11-4.5-1.27.28-.99.7h-1.12l-1.13,1.27-1.12-.28-1.55,1.27v1.55l-1.83.14-.56,3.38h-1.12l-.98.14-.28.56.7.84-1.55.14-1.69-1.69-.98,1.26-.7,1.97-.42,1.55.98.56-1.83,2.25-.7.84-2.81,1.83-.84.56-3.09.14-.84.98-1.83.28-1.69,1.55-1.41.14-.84-.7-1.41.28-2.39,2.25-.56.28-1.83.7-1.41,1.83-.42-.98-.56-.42-.42.7-1.41,6.75.7,2.25,1.41,3.51-.14,1.12-.42.14-.98-1.69h-.56l.28.84.84,1.69-.56.42-2.11-3.37-.56-.14v.56l2.67,4.22.28,1.27.98,1.55.14.98,1.83,2.25.14.98.14,4.92,1.41,1.83.42,1.55.7,2.53-.56,1.12-.42,3.38-1.13.28-.42,1.41.56,1.55,2.67.7,1.12,1.27,2.81.42h3.23l.56-.42.14-1.41,1.97-.42.98-.98,2.81-.84.84-.7,4.64.14.7.42h2.11l1.55-1.12v-.98l2.53-1.69,1.83.14,2.39-2.11,4.08-.28,4.22-1.69,6.47-.56,3.38,2.39,1.69-.56,2.95.98,1.55,2.95,1.69,1.55.28,1.97-.7.84.7.84,2.25.98,1.55-1.12-.28-1.4,2.53-2.95.98-.7.14-1.12,1.55.14-.14,2.11-1.27,1.69-.28,2.11-.98.84-.7.56v1.26h1.69l1.41-1.41v-1.26l1.55.14.84,1.41-1.83.84.56,1.27,2.67.7.56,1.27,1.13,1.26-.56,1.97,1.41,1.12.56,1.69,1.41.84,1.69.42.84.84c.36-.15.74-.2,1.13-.14.42.14,5.48,2.11,5.48,2.11l-.14-1.69,1.55-.84.99-1.97,2.53.42-.28,1.83,1.41,1.41,2.39-.28,1.97-.84.28-1.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m937.78,502.39v-.53l.32-.21.53.63-.53.84-.32-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m950.02,502.6l.32-.74.63.11.42,1.48-.84.21-.53-.74v-.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951.5,506.08l-1.05-.32-.95.11-1.69,1.37-1.69.53-2.53-.95-2.11-1.16-.95-.11-.63.84.74,1.9,1.05,1.16.21,3.27,1.27,1.58.95,2,.74.84,2.74-.32.63-1.48h1.16l.63-2,1.05-1.27.42-3.16v-2.85Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.8,202.63l.84-.21.53.42-.74.11-.63-.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m995.49,160.46l.11-.84.84-.63.21-1.37,2.32-1.16.21,2.32-2.53,1.79-1.16-.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m675.85,294.15v.42l1.97-.98-.28-.42-1.69.98Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.39,294.15l.84-.42.7.42-.84.7-.7-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.25,421.1l.84-.84v-1.41l-1.27-.56-.28.98v1.12l.7.7Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.95,421.8l.28-.42,1.55.98-.14.56-1.69-1.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1012.16,430.24l-.14-.7.84-.28.7,1.27-.7.28-.7-.57Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1012.86,432.77v-.98h.7v.7l-.7.28Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.81,437.13l.14-.7.42-.28.56.56-.42.56-.7-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1005.41,435.86v-.56l-.56.14v.56l.56-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m998.8,435.02l.84.7.84.14,1.97,1.55.84.56,2.53,1.69.28.84-.56.42-1.69-.56-3.23-1.83-.84-.42-1.55-1.55-.14-.7v-1.12l.7.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1038.32,428.48l2.11-.21v-1.27l-.63-1.05-2.53.21-.21,1.48,1.27.84Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041.49,424.05l3.16-1.69-.84-.63-1.05.42-2.53,1.48,1.27.42Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024.82,483.94l-1.05-1.27v-1.48l3.16,2.74h.84l1.48,1.48v1.48l1.27,2.74,1.05,1.05.42-.63-.21-1.48,1.27,1.48.63,2.53,2.11,1.27,2.32-.42.84-1.48,1.69-.42v2.32l-.84,1.27-.42,3.58-1.48-.63h-1.9l-.21.84.63,1.27-1.05,1.27-2.53,5.27-1.9.63-1.9-.84,1.69-1.69.21-2.32-1.9-2.11-2.11-.63v-1.48l2.53-.63.63-2.53-1.05-4.22-1.27-2.53-2.95-4.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024.39,505.03v1.69h1.05l.63-1.05,1.48.21-.42,4.43-1.69,2.53-1.05,1.48-.63,2.11-2.74.84-1.48,1.9-2.32,5.01-4.01,3.76-4.85-1.61h-2.32l-.42-1.61,1.69-3.65,1.9-2.11,3.38-1.9,2.53-2.53,3.59-2.11,1.05-1.9v-1.48l1.9-2.53.21-1.9,1.69-.63.84,1.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1009.83,528.65v1.26l-1.27.36.42-1.79.84.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.18,113.43l-.21-2.74h2.53l.63,1.26h1.69l1.05-.42.21.84-1.27.84.63,1.26-.21,2.11,1.05.21.63,1.26h1.26l.63,2.11-1.48,3.16-2.32,1.69-.84,2.11-2.74.21-1.9,2.11-2.32.42-2.11,2.32-5.49.21-3.38-2.32-3.17-.42-1.69-.63.21-1.05h2.11l.21-1.69-1.27-1.69v-1.05l-1.27-.42-3.38.42.21-1.26,1.9-.42,2.32-.21,1.69.21.63-.63-2.74-1.26,1.27-.84-.63-1.05h-4.01l-1.9.21-.21-1.05,2.74-3.37.63.42.42.84,1.48-.42-1.05-1.48-.84-1.9h2.11l2.74,2.32-.42,2.11.84,2.74,1.05.63.63-.63-.42-.84,1.69-.42.63-1.05-1.27-.84.84-.63,1.05.21,1.27,1.48v-1.9l2.53-.63.84,1.69.84-.42-.42-1.26,1.69-.42,1.48,1.05,2.54-1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m649.27,249.44l-2.95-2.95-1.05-1.9-1.05-1.69-3.17-1.05-3.59-1.27,2.11,2.95.42,2.32,1.69,1.05.63,1.05,1.69-.21,3.54,2.12,1.74-.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624.93,271.73l.56-1.34,6.19-4.08,1.12-3.51-1.41-2.81,3.53-2.48,2.1-1.46,2.25.42,1.12,1.41,1.9-.42",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618.31,261.14l.15-1.71,4.36-.98,1.55.42,3.52-.56,3.66-1.26,2.67-.42.71.9",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m711.43,256.75l.14-2.53.7-2.25-.98-1.41-.98-3.37,2.25-.56,2.53-.56.14-2.81,3.38-.98,1.97.7-1.27,1.27-.28,1.69,2.95-.56,2.95-1.83v-1.55l-2.39-.14-.7-1.83-2.95-.14-2.2-.43,1.27-1.16,1.69-.11.8-1.68-3.8.84-1.97,1.97-.4,1.63-1.43.48-1.41,1.12-1.12.14-1.7-1.82-1.12-.14-1.97-5.06-1.83.56-1.41-3.09-2.39-1.55-1.41.14-2.95-.28-1.97.28-2.22-2.64-8.23-5.59-8.54,4.57.56,10.96,4.87,1.13.84-3.09,1.83-.98.84.14.28-.7h.98l1.69.84.84.98.33,1.54-.42,1.27,4.08,1.69,2.11.56,1.69,2.11,1.12,3.94,2.39,2.81,2.67,1.12,2.67,1.41,1.97.42,1.12,1.69,4.37.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.15,179.99l2.11.7,1.48.84,1.02,2.4,1.08-.08.63,1.05,2.11,1.05,1.05-1.05.21-1.05,2.53-1.05,1.27-2.32,1.69-2.74-2.74-3.37-5.27-1.05h-6.54l-1.48,1.48.85,5.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.32,194.83l-2.95.63-.63,1.9-1.69.42-4.64-1.48-1.27.42-2.11-.63-1.69.21-1.9-1.05-2.11.21-2.95,2.95-.42-2.53-2.11-2.32,2.11-2.32-1.48-3.16v-3.16l2.11,1.05,1.05-1.05.21-1.05,2.53-1.05,1.27-2.32,1.69-2.74h1.48l2.53-2.95,1.9.21,1.69,1.48,1.48-.42,2.11.21,1.05,1.69.42,4.64,1.48,2.74,3.17,2.95-.63,2.11h-1.27l-1.27-.84h-1.47l.42,1.9,1.27,1.26.63,2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.38,218.87l-2.53.63-3.17,1.9-2.11-.84-2.74-.84h-1.05l-.84-.63h-1.48l-1.05.84h-2.95l-1.69-.63-.14-1.72.35-.39,2.53.21,3.17-.63,1.9-1.05,2.11.42.84-1.05-.42-1.9,1.69-1.27.42-1.27,4.22-.63,2.74,1.05.63,1.9,1.2.09.28,2.02-1.48.84.21,1.9-.64,1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.69,223.72l.42-1.48-1.27-.21-1.05.84-.63-.84,1.05-1.48.63-1.27,1.05-.42v-1.27l.63-1.27,1.69.21,1.27-.84,1.9-.42,1.9,1.48,1.69.42-.35.39-.49.56.63,1.16,1.69.63-.84,1.69-3.38-.42-1.05-.84-1.27.42-.42,2.53-.84.42-1.48-.21-1.48.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.76,219.29l-.14-1.72-.49.56.63,1.16Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.66,236.37l.14-.56.7-.14.42.42-.28.56-.98-.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.34,180.49v2.11l-1.79,1.69v.84l1.48,1.26,1.37-.74,1.58.53,1.16.63,1.69-1.05.74-2-.84-.32-1.37-2.43-2-.21-.32-.42-1.69.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.13,186.81l-1.16-.63-1.58-.53-1.37.74-1.48-1.26v-.84l1.79-1.69v-2.11l-2.43.32-.63.84-.63,2.11.63,1.16-1.48.84-1.48-.53-1.27.42-.74,1.26,1.16,1.48-.11.84-.84.63.63.63,1.16-.63.84.42-.84,1.79-.11,1.37.84.42.11.32-2.64.95-.95.84.32,1.79.95.42.32.84,1.27.42,1.58-.84,2.43-1.16,2.85-1.16,1.9-.42.74-3.48.42-1.79-.21-1.16v-2.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m731.34,256.19l1.48-2.95-.63-2.11-2.74-.42-.63-2.95-2.74.84h-2.53l-.14-1.12-2.67.14-.84.42h-1.69l-1.55.7-.56-1.12,2.95-1.69.28-1.69,1.27-1.27-1.97-.7-3.38.98-.14,2.81-2.53.56-2.25.56.98,3.37.98,1.41-.7,2.25-.14,2.53,2.11.28,4.36-1.83,1.27-1.97,1.69-1.97,1.41,1.27.42,2.95-.42,2.67,3.52-.28,2.81-2.25h1.68l1.05.56h0Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m728.81,247.76l.84-1.9,4.43-2.53,1.69,1.48,1.9-.21.42-2.53,1.9-.21,2.53-1.9,3.38-.63,2.32-2.74-1.48-1.2-3.94-1.12-4.92-.84-4.22,1.41-1.27-1.83-1.55-.7-3.09,1.83.7,1.83-3.38.42-1.41-1.27h-2.11l-1.12,1.41-.8,1.68-1.69.11-1.26,1.16,2.2.43,2.95.14.7,1.83,2.39.14v1.55l-2.95,1.83-2.95.56-2.95,1.69.56,1.12,1.55-.7h1.69l.84-.42,2.67-.14.14,1.12h2.53l2.75-.85Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m690.62,283.18l3.8.21,1.48.21,6.33.63,4.22-1.05v-2.95l.42-2.11,2.53-.42,2.11-1.69,3.59.63v-3.16l2.74-4.85,2.53.42,2.53-4.43-1.05-3.8,6.89-2.95h2.11l1.12-.63-.63-1.05-1.05-.56h-1.69l-2.81,2.25-3.52.28.42-2.67-.42-2.95-1.41-1.27-1.69,1.97-1.27,1.97-4.36,1.83-2.11-.28-4.36-.84-3.59.28-1.27,2.95-5.7,3.37-.63,1.9-1.69-1.27-2.53-.63v2.74l-2.32,3.16.84,4.85-.21,2.53.84,1.69,1.27-1.05,1.27,1.9-1.69,2.53-1.05,2.32h0Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m744.76,272.8l.84-.42-.32-.95-.74-2-.1-1.16.58-1.85-.32-1.69-1.21-1.05-2,.11-2,1.53.29.16.45.37,1.05,1.05,1.37.74.53,2.21,1.48,2,.1.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m811.09,310.81l1.69.21-.63-3.16.84-1.9,1.69.63.42,1.34,1.12.98.14,2.53,3.09.28,2.53,1.69-.28,4.64,2.11,3.52,3.66,3.52.42,1.27,1.97.7-.14,5.34-1.12-.14-1.41-1.83-1.12.7-.42,1.55-3.09-.42,1.12-3.94-.42-1.69-2.81-3.51-.84-3.52-1.55-.28-1.41,1.41h-1.41l-.98-.98h-1.55l-2.11,2.11-.98-1.12.28-1.12.56-3.51-1.97-.84-.56-2.39,1.83-2.25.98-.28.35.5Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m771.42,289.09l-6.96-1.48-3.38-2.53-3.8-1.48-3.8-2.95-3.59.42-.77,2.11-.84,1.97.7,2.25,1.97.84,1.41.84,5.34,1.12,3.09.28,3.52,2.67,3.38,1.12,3.38-.56.98-2.25-.63-2.39Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m784.08,289.3l-1.48-1.05-2.53.42-1.27-1.27h-1.9l-2.11,2.11h0l.49,1.69,1.27,1.69,7.46-.56.07-3.02Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.82,239.74l-.56,1.12.42,1.55.56,1.97-.42,2.67-.7.7-.28,1.55-.84.98.14,2.95h.98l.28,1.12-.14,2.81-.28,1.69,1.69.14,1.41.28,1.41-.84.14-1.69.98-1.55.56-3.37-.84-2.81.84-1.12.14-3.09.84-1.27.42-2.53-1.12-1.55-1.27.56-2.81.28-1.55-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m612.2,277.91l-.91,1.05.35.84.91-1.05-.35-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.29,
    y1: 278.97,
    x2: 611.64,
    y2: 279.81,
    style: {
      fill: "none",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.98,300.62l-6.53.11,3.59,28.42-10.55.21-.84-.63-1.27.84-2.11-.21-1.69,1.27-1.27-1.48-1.27.21-.63,2.11.63,4.64,1.9,1.48v2.11l3.17,1.48,2.11-.21.84-1.05,1.48,1.48,2.11,4.43,2.74-.42,1.69-1.69,1.69,1.48,1.9.21.42-3.58,1.05-.63-.21-1.48,2.74-2.53.42-1.27,2.11.42,2.74-3.58h1.48l1.27-1.9,3.38-.21.84.84,4.43-.21,1.69-.84,3.17-.42,3.91-11.95-4.96.42-.14-1.41-.14-1.69-1.55-.42-2.11.14-1.27-2.25-16.96-12.22h0Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.91,331.47l.21,2.11,1.27,1.48h1.48l.42,2.11,2.53,1.9.52,1.17.33.73-5.06,2.74-1.9-.63-1.9-.63-1.48.21-2.11-.84-1.9.42-1.48,4.01h-3.17l-1.69,1.27-2.32-2.11.42-3.58,1.05-.63-.21-1.48,2.74-2.53.42-1.27,2.11.42,2.74-3.58h1.48l1.27-1.9,3.38-.21.85.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546.09,391.15l3.45-1.55.56.14.14.98h0l-.42.98-2.36.81-1.37-1.37Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.21,426.86l1.9.77,3.38.21,1.9.42.98.98h2.81l1.55-2.11,1.69-.56,2.11-1.41.28-1.55.98-.98,2.81-.56.42-2.11,1.41-.56,2.11-1.27,1.97.14,2.39-1.12.56-5.34.84-.84-.28-5.34-1.83-2.67-2.95-1.27-2.53-2.25-3.09,1.12-1.69.7-1.27,1.41-1.41,7.03,1.55,1.83,1.27.14.98-1.27.98.56-.14,4.08-1.41.84-6.89-6.33-1.27-.42-.42,1.41h-1.27l-.7-1.12-1.27-.84-.7.56-1.12-.14-.98.42-.56,4.36-5.48.14.28,10.96,2.1,1.97Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.22,379.2l1.69-.56.98-.84,1.12.28,1.12,1.27-.42,1.12-.98.42-.28,1.41h-1.12l-.42.42h-.7l-.14-.7h-.98l.14-2.82Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607.21,402.96l1.83,2.67.28,5.34-.84.84-.56,5.34,1.41.14.98,1.12,1.69.28.14,2.39v2.39l.28,1.83,1.97,1.41.7-.28-.56-2.53,1.27-2.25v-3.37l-1.12-2.39-1.83-2.11.42-3.94-.42-3.65-1.27-2.67-1.97-.56h-2.39Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.95,457.23l-.84,2.39h-2.39l-.84-1.55.56-4.78,1.12-.28,1.69.28.7,3.94Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.92,463.83l.28,2.53-2.39,1.97-.42,1.12-2.81.98-2.11-2.53v-1.41l3.23-3.09,4.22.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607.35,457.36l.14-1.48-.63-1.05,1.48-2.11,5.7-1.69,1.05-4.01-.42-5.9-1.69-5.06v-1.9l2.95-2.11,1.27-.56,1.48-1.76,2.74-2.32,5.06-1.69,4.01-5.27.21-6.33-.63-2.95-.21-5.27-1.69.7-.84,1.12-1.83.84-1.55,1.27-2.53.42-1.97.56-1.97-.7-4.22-.28-.42,3.94,1.83,2.11,1.12,2.39v3.37l-1.27,2.25.56,2.53-.7.28-1.97-1.41-.28-1.83v-2.39l-.14-2.39-1.69-.28-.98-1.12-1.41-.14-2.39,1.12-1.97-.14-2.11,1.27-1.41.56-.42,2.11,6.75,2.39,1.27,1.55.28,4.36-.84.84v1.83l1.41,1.97-.42.98-2.67,1.83-.42,3.37-1.55,1.41,1.27,7.45-.42,3.23.7,3.94,2.39.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.9,388.62l1.27-2.95.63-2.32,2.11-.63v-1.27l1.48-.63,1.47-1.82-1.66-1.21v-12.88l1.88-1.59-5.06-.42-2.74,1.69-3.17-.42-5.06-2.32-1.9-.42-5.49.63.77,2.11,2.53,4.22v2.39l-2.81,2.25-.42,4.64,4.36,2.95,6.33,2.39.14,1.12-.28,1.69,5.63,2.81Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.07,339.28l-.42,2.32,1.05,1.27,1.9.21,1.9-1.05-1.9-1.48,2.32-1.27-.63-1.27-.84-.84h-1.05l-1.05,1.69-1.27.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.83,278.97l1.27-.56,2.39.14,3.09.7,3.38.98,1.97-.14,1.27-.98.84-.14,1.12-.84,1.83.14,1.97,1.41.74-.18.14.11.15-.19.66-.17,1.41.28,3.23-.56.35.84.56,1.83.77,2.53-.84,3.8v1.69l-1.27.49-1.9-2.11-1.48-2.11-.21-2.74-.74-.74-.15.04-.37,1.12.42,3.58,2.53,2.32.42,1.69,1.69,2.74,1.48,3.58,2.11,4.22.63,3.8-1.9,1.69-2.67.7v1.97l-1.69-.42-.98-.98-13.92.7-8.58-.7.14-7.31.14-13.07-1.55-6.05,1.27-.98.28-2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.55,308.49l-.42,6.47-2.67.56-22.65-11.53-4.5,2.81-8.3-2.25-1.83-3.65-2.95.42-2.67-3.52-.42-3.23,1.83-2.11v-2.81l-.7-1.97.14-1.41-1.12-5.06h.98l1.55-1.27.14-3.37,2.11-.28,1.27-1.12-.14-2.57,3.23,1.51h4.22l1.9.63,1.48.21,1.9,4.01,4.85.84,5.27,2.95,2.31-1.26,1.05-1.48-1.05-1.69.21-2.32,3.8-2.11,2.53-.42,2.88.56.28,1.55,2.25.98,2.25.7,1.27,1.69-.28,2.11-1.27.98,1.55,6.05-.14,13.07-.14,7.31Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m582.45,315.52l2.67-.56.42-6.47,8.58.7,13.92-.7.98.98,1.69.42v-1.97l2.67-.7,1.9-1.69,3.17,2.53,1.27,2.32.21,5.06v2.11l4.43,4.22-4.64,2.74-1.69,3.16-.42,5.06-.42,5.9-2.95.63-.42,3.16-2.53,1.27-.21,4.01-2.11,2.95,3.59,5.06,1.27,3.16,2.32,2.53-5.49.63-1.9,2.32-4.22.21-2.11-.63-1.27.63-2.32-2.74-1.48.21-1.9-.63-.63.63h-1.48l-1.12-1.86-.78-1.3-3.17-2.11-.21-2.11-2.32-2.32-1.48-.42-1.05-1.69-1.69-.63.21-3.58-1.69-2.32.42-.84-.21-1.05-2.11-1.48v-1.69l-1.48-1.48.63-1.05.84-4.22.63-1.05-.21-2.11,3.8-.63.07-12.58Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.39,337.17l-1.05,1.69-1.27.42-2.74-4.22-3.38-1.9-2.53-1.05-7.81.63.42-5.06,1.69-3.16,4.64-2.74,1.05,3.8,1.9,4.01,1.48.63,3.8,2.53,3.79,4.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m616.14,361.42l-2.32-2.53-1.27-3.16-3.59-5.06,2.11-2.95.21-4.01,2.53-1.27.42-3.16,2.95-.63.42-5.9,7.81-.63,2.53,1.05,3.38,1.9,2.74,4.22-.42,2.32,1.05,1.27,1.9.21.21,2.74,1.9,2.11,1.48.21,3.38,1.69,7.17,1.05,2.32-.21-.84,2.32-9.49,7.17-6.33,1.48-2.32,1.69-5.06-.42-2.75,1.69-3.17-.42-5.06-2.32-1.9-.43Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m633.85,379l2.96-3.45,1.48-2.11,3.38-2.53,3.59-2.74,2.74-1.27,2.32-2.74,2.95-4.22,1.05-1.9,1.27-2.32.63-1.69,3.8-5.06.84-3.37.42-5.06-.84-1.05h-.85l-1.69,1.05-4.01,1.05-.84.63h-2.32l-2.32,1.05-4.22.84-1.48.63-1.9-.42-2.32-2.32-1.9,1.05.21,2.74,1.9,2.11,1.48.21,3.38,1.69,7.17,1.05,2.32-.21-.84,2.32-9.49,7.17-6.33,1.48-2.32,1.69-1.88,1.59v12.88l1.66,1.21",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.27,281.21l-2.25-5.34-1.55-1.83-2.25-2.53v-1.97l2.25-3.23.28-2.53-.42-.98-.14-3.09-2.25-.7-3.38.56-2.11.28h-1.97l-1.41-.28-3.38.28-1.41.7-2.95.14-2.11.7-1.55.84-2.11,1.83-1.12.42-1.97.98-1.12,1.12,1.12,5.76.42,1.41-1.12,3.37-2.25.42-2.39-.14-.7,2.95-1.41.28-1.55.84h-1.12l-1.12,1.27-.28.98-7.31,1.97-2.81,2.11.21,2.27.36,2.09,11.59,8.45,16.96,12.22,1.27,2.25,2.11-.14,1.55.42.14,1.69.14,1.41,4.96-.42,3.34-.14,18.57-13.36-1.83-3.65-2.95.42-2.67-3.52-.42-3.23,1.83-2.11v-2.81l-.7-1.97.14-1.41-1.14-5.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m547.01,304.55l-18.57,13.35-3.34.14-3.91,11.95-3.17.42-1.69.84-4.43.21.21,2.11,1.27,1.48h1.48l.42,2.11,2.53,1.9.52,1.17,2.46-.31,1.03-.22,1.48-3.8,2.11-1.69,4.64.42,2.32,2.53h2.95l2.53.63,2.11-.42,1.48-1.9,5.7,1.05,4.43-1.69.63-3.8,5.27-5.9.21-8.43,1.48-2.53-2.53-3.16-1.34-4.22-8.3-2.25",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.12,336.95l.42-1.48-.37-.66,5.49-.42,2.53.63,1.05,1.48-1.27.63-2.95-.63-4.91.45Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.7,338.43l.42-1.48,4.91-.45,2.95.63,1.27-.63-1.05-1.48-2.53-.63-5.49.42-.69-1.23-.42-2.11,1.05-1.9,1.05-3.8,2.11-.84c1.13.07,2.26.22,3.38.42.83.48,1.61,1.04,2.32,1.69l1.27,1.69,3.16,2.74.63,4.64,1.9,1.48v2.11l-4.43-1.05-2.74.21-4.43-.42-3.59,1.27-1.05-1.27.42-1.48",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.38,292.18l-.56,4.22h-9.85l.42,8.43-2.53.14-1.12,2.81.14,3.78h-12.11l.51,1.35.63.63,1.05,2.11-.21,2.11,1.27,4.22v.84l-.84,2.95,2.11-.84c1.13.07,2.26.22,3.38.42.83.48,1.61,1.04,2.32,1.69l1.27,1.69,3.16,2.74.63-2.11,1.26-.21,1.27,1.48,1.69-1.27,2.11.21,1.27-.84.84.63,10.55-.21-3.59-28.42,6.53-.11-11.59-8.45Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.55,342.65l-.84-1.48-1.9-1.05-1.05-.42,3.59-1.27,4.43.42-.21,2.74-2.11.42-1.9.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.61,348.34l-4.43-4.85-.63-.84,1.9-.63,2.11-.42.21-2.74,2.74-.21,4.43,1.05,3.17,1.48,2.11-.21.84-1.05,1.48,1.48,2.11,4.43.63,3.8-.84,3.16-.84,1.27-2.74-.63-.84-.84-2.11-1.05-.42-1.05-1.48.42-.63-1.27.42-1.9-1.48-.84-2.95.21-2.74,1.26Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.15,355.51l-4.43-1.69-.84-2.95-1.27-2.53,2.74-1.27,2.95-.21,1.48.84-.42,1.9.63,1.27,1.48-.42.42,1.05-2.74,4.01Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m551.58,334.85l1.27,1.27.21,1.48.42,4.64-1.48.84-2.32,4.22-1.9,1.9-1.26,5.49-1.69,1.69-1.69-1.9h-2.11l-3.59,4.43-1.05,3.8-6.54-.22-1.69-.42-.84-1.9-3.8-3.16h-3.37l-.42-7.73,2.11-2.39.28-4.22-1.31-2.73,1.03-.22,1.48-3.8,2.11-1.69,4.64.42,2.32,2.53h2.95l2.53.63,2.11-.42,1.48-1.9,5.7,1.05,4.42-1.68Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.6,343.7l5.06-2.74-.33-.73,2.46-.31,1.31,2.73-.28,4.22-2.11,2.39.42,7.73-3.59.42.07-8.15-1.41-2.53-1.27-1.41-.35-1.62Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.6,343.7l.35,1.62,1.27,1.41,1.41,2.53-.07,8.15-3.13,1.02-.46-2v-3.1l-.84-1.41-.28-5.34-.14-3.52,1.9.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.7,343.07l.14,3.52.28,5.34.84,1.41v3.09l.46,2-1.93.67-6.33,2.32-1.48-.63-1.12-2.25-.42-1.97,2.39-4.64v-1.27l-1.68-4.43,1.48-4.01,1.9-.42,2.11.84,1.48-.21,1.9.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.68,360.78l-1.12-2.25-.42-1.97,2.39-4.64v-1.27l-1.69-4.43h-3.17l-1.69,1.27-2.32-2.11-1.9-.21-1.69-1.48-1.69,1.69-2.74.42.63,3.8-.84,3.16-.84,1.27v3.37l2.53,1.27.21,1.69-.84,2.53,3.38-.42,4.01-1.05,3.59-.63h4.22Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.39,362.68l2.32,1.69,1.68,2.11v2.74l4.58-.03,4.42-.06,4.36-.05,1.55,1.12,2.18-2.67-3.38-6.96v-1.9l3.38-5.27-1.9-3.37-2.74-1.9.42-1.9,3.17-.84.21-5.48-2.74-3.58-1.05-.21.21,1.48.42,4.64-1.48.84-2.32,4.22-1.9,1.9-1.27,5.48-1.69,1.69-1.69-1.9h-2.11l-3.59,4.43-1.05,3.8Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.48,367.53l-3.38-6.96v-1.9l3.38-5.27,8.86-1.48,1.69-3.16h3.59l4.01-4.22.84-3.16,1.69-1.05,2.11,1.48.21,1.05-.42.84,1.69,2.32-.21,3.58,1.69.63,1.05,1.69,1.48.42,2.32,2.32.21,2.11,3.17,2.11.78,1.3-5.21-.25-7.17,2.74-2.74.84-4.01-.84-2.53-1.9-4.64.84-.21,2.95-1.9.21-2.95-.21-1.9.84-1.47,2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.48,353.4l-1.9-3.37-2.74-1.9.42-1.9,3.16-.84.21-5.48-2.74-3.58-1.05-.21-1.27-1.27.63-3.8,5.27-5.9.21-8.43,1.48-2.53-2.53-3.16-1.34-4.22,4.5-2.81,22.65,11.53-.07,12.58-3.8.63.21,2.11-.63,1.05-.84,4.22-.63,1.05,1.48,1.48v1.69l-1.69,1.05-.84,3.17-4.01,4.22h-3.59l-1.69,3.16-8.86,1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.46,389.25l-3.17-4.85-2.32-2.32-1.9-3.37,1.48-3.58-.21-1.69.37-1.62,5.37-.05-.1-2.58,4.42-.06-.7,2.06,2.53,1.97,2.25-.98.56.42.28,2.11-1.69,1.27-.63,1.9.63.84.84.21-.85,5.48-2.11-1.27-1.27-1.9-2.11-.42-.21,1.27-.63,1.69-1.05-.42.42,1.48,2.32,2.39-2.53,2.04Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546.3,427.63l-.21-2.74.42-2.74,2.53-7.38,1.69-1.05,1.69-3.37-.84-2.95-.84-2.53v-5.48l-1.05-1.69-1.05-2.32.21-1.48,11.96-.35,1.83,2.53,1.41,3.23,4.78-.42.14-2.53,2.95-.42,1.97,1.12,2.53.56.42,8.01,1.27,2.95h4.36l.42.84-.56,4.36-5.48.14.28,10.96,2.11,1.97-2.39,1.69-3.23.14-3.23.7-2.67-.84-2.67-1.69-8.86-.14-3.09,1.12-1.27-1.27h-3.23l-2.25,1.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601.72,399.45l-3.09,1.12-1.69.7-1.27,1.41-1.41,7.03,1.55,1.83,1.27.14.98-1.27.98.56-.14,4.08-1.41.84-6.89-6.33-1.27-.42-.42,1.41h-1.27l-.7-1.12-1.27-.84-.7.56-1.12-.14-.98.42-.42-.84h-4.36l-1.27-2.95-.42-8.01-2.53-.56-1.97-1.12-2.95.42-.14,2.53-4.78.42-1.41-3.23-1.83-2.53-11.96.35-1.37-1.37,2.36-.81.42-.98,1.27-1.55.98-.14.14,1.55,5.2-2.53,1.97-7.45,2.25-1.27,1.55-4.08.28-5.06,1.83-2.11v-3.52l.21-2.95,4.64-.84,2.53,1.9,4.01.84,2.74-.84,7.17-2.74,5.21.25,1.12,1.86h1.48l.63-.63,1.9.63,1.48-.21,2.32,2.74.84,3.09-.7,2.67-3.23,5.06-.84,3.8-.14,2.81.42,2.53,1.01,1.06.12,2.31-.42,1.69v.42l.28,3.52,2.53,3.52.69,2.38Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.24,390.73l1.27-1.55.98-.14.14,1.55,5.2-2.53,1.97-7.45,2.25-1.27,1.55-4.08.28-5.06,1.83-2.11v-3.51l-1.9.21-2.95-.21-1.9.84-1.48,2.11-2.18,2.67-1.55-1.12-4.36.05-.7,2.06,2.53,1.97,2.25-.98.56.42.28,2.11-1.69,1.27-.63,1.9.63.84.84.21-.84,5.48-2.11-1.27-1.27-1.9-2.11-.42-.21,1.27-.63,1.69-1.05-.42.42,1.48,2.32,2.39-2.53,2.04.63,1.9,3.45-1.55.56.14.14.98Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.9,388.62l-5.63-2.81.28-1.69-.14-1.12-6.33-2.39-4.36-2.95-8.44-.14-1.27.56,1.12,1.27-.42,1.12-.98.42-.28,1.41,1.12,1.12-.28,1.83-1.27.56-.28,1.27-1.12.84-.42,1.69v.42l.28,3.52,2.53,3.51.7,2.39,2.53,2.25,2.95,1.27h2.39l1.97.56,1.27,2.67.42,3.65,4.22.28,1.97.7,1.97-.56,2.53-.42,1.55-1.27,1.83-.84.84-1.12,1.69-.7-3.38-3.58-.21-3.8.63-3.16-1.9-1.69-.21-1.48,2.11-3.58Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610.72,377.66l-8.44-.14-1.27.56-1.12-.28-.98.84-1.69.56.84-3.8,3.23-5.06.7-2.67-.84-3.09,1.27-.63,2.11.63,4.22-.21,1.9-2.32.77,2.11,2.53,4.22v2.39l-2.81,2.25-.42,4.64Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.59,463.48l-1.48-2.11-1.27-2.74-1.48-4.43-1.05-3.8-1.05-5.9-.42-2.11-4.43-8.01-.21-1.27-1.27-1.9-.63-3.58,2.25-1.05h3.23l1.27,1.27,3.09-1.12,8.86.14,2.67,1.69,2.67.84,3.23-.7,3.23-.14,2.39-1.69,1.9.77,3.38.21,1.9.42.98.98-2.46-.14-3.17,1.27-2.32-.84-5.49,1.9-.21,9.7-2.95.42-.24,8.43-.39,13.5-3.38.84-2.11-.63-1.48-.84-.84-.84h-1.05l-1.69,1.47Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.25,442.39l-1.27-1.9-1.69-4.01-.42-1.9-4.43-3.37-.07-1.97-2.46-.14-3.17,1.27-2.32-.84-5.49,1.9-.21,9.7-2.95.42-.24,8.43,1.93,2.12,1.05,5.06h2.74l3.59-4.22,1.69-.21,1.48,1.05,2.53-.21,2.11-2.32.42-3.58,2.95-1.05.84-1.27,3.38-2.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.81,423.63l-.28,1.55-2.11,1.41-1.69.56-1.55,2.11h-2.81l.07,1.97,4.43,3.37.42,1.9,1.69,4.01,1.27,1.9h2.11l1.69-.84,4.36,1.05,1.55-1.41.42-3.37,2.67-1.83.42-.98-1.41-1.97v-1.83l.84-.84-.28-4.36-1.27-1.55-6.76-2.39-2.81.56-.98.98Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.39,369.22l-.69,2.6,5.37-.05-.1-2.58-4.58.03Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.59,354.04v3.37l2.53,1.27.21,1.69-.84,2.53-4.01-1.48-3.38-3.16-2.95-2.74,2.74-4.01,2.11,1.05.84.84,2.74.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.08,382.01h.98l.14.7h.7l.42-.42h1.12l1.12,1.12-.28,1.83-1.27.56-.28,1.27-1.12.84-.12-2.31-1.01-1.06-.42-2.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.77,183.94l-4.4.34-2.53-.42-1.48-.35.28-.98-.56-.84.28-.84,3.23-.14.56-.7,2.11.7,1.48.84,1.03,2.4Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.2,186.46l1.76-1.02,2.18-.25,2.39-1.83,2.11-.7,1.12-1.12,3.09.56.14,1.97,1.97.42,1.69-1.12.7.14,1.48.35,2.53.42,4.4-.34,1.08-.08.63,1.05v3.16l1.48,3.16-2.11,2.32,2.11,2.32.42,2.53.42,3.8-4.01,4.43.21,1.05-1.48,1.27-1.9-1.69-5.91.84-2.2-1-1.6-.06-4.43-4.01-2.11.42-1.9-2.95-1.69-.42-2.53-7.8.42-3.59-.49-2.26Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.53,208.95l-1.9-1.69-5.91.84-2.2-1-.55,1.63-1.9.21-.84,1.27-1.69,1.48-.42,1.48,1.48.21.84.42h2.74l2.32-.63,1.48-1.9,3.38-.42,1.48.84,1.05-.21.63-2.52Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576.9,211.48l-1.05.21-1.48-.84-3.38.42-1.48,1.9-2.32.63h-2.74l-.84-.42-1.48-.21-1.12-.12.28,2.02-1.48.84.21,1.9-.63,1.05.63,1.05,1.48.42,1.27,2.74,4.22.42.42-.84,3.38-1.05.84.21,2.32-.63.84-3.37,2.32-2.74,2.32-1.48-2.53-2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.13,213.17l-1.12-.12-1.2-.09-.63-1.9-2.74-1.05-4.22.63-4.22-3.37-.63-3.16,4.64-2.53.84-1.26,2.95-.21,1.69.42,1.9,2.95,2.11-.42,4.43,4.01,1.6.06-.55,1.63-1.9.21-.84,1.27-1.69,1.48-.42,1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677.26,298.01l.25-1.89-.61-.39-.6.14-.9,1.04,1.85,1.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677.26,298.01l-1.85-1.1-1.39,1.6-2.95,2.25-1.41,1.69-2.67.42h-1.41l-1.83-.28-.56,1.27,2.11,2.11,7.81,1.05.21-2.53,2.74-2.74-.84-2.53,1.9-.14.14-1.06Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.66,299.63l.7-1.55-.56-1.69.56-.98,1.41.28.42,3.37-.56,2.39-1.48-.42-.49-1.41Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m649.26,285.5l-.42-1.47,1.05-1.27,2.54.76-.93.93v.84l1.12,1.48h-1.9l-1.48-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.78,265.47l-3.8.63-3.16-.63-2.81.28-.28,5.62,2.11.7,2.11,2.25-.56,1.41-2.11,1.69-.42,3.09-1.97.98-.7,2.81-5.91,5.62-2.25.14-1.12-.98-1.55,3.8,3.38,5.76-.28,2.53-4.36-.56-2.39,1.27-1.55,1.69h0l-1.55-.7-.28-.84-1.12-.7-.42-1.97-.56-.7-2.39-.14-1.27.42-3.94-.28-1.27.28-4.22.28-1.27-.56-.49-.28.21-2.74,4.01-1.69v-2.11l-1.9-.21.21-2.11-5.28-4.43v-1.9l3.8.21,1.48.21,6.33.63,4.22-1.05v-2.95l.42-2.11,2.53-.42,2.11-1.69,3.59.63v-3.16l2.74-4.85,2.53.42,2.53-4.43-1.05-3.8,6.89-2.95h2.11l1.12-.63,1.71.69,1.05,1.58.74,2.42,2.32,1.58,1.97,1.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785.42,309.76l-1.55,1.69-.7-1.41-.14-2.39-2.25-2.39-1.12.14-.28.84.14,1.69-2.81,1.41-1.83.28-.56-.84v-4.22l-.7-1.41-.14-2.67-1.41-1.55.14-.98h2.25l-.28-1.41-.84-1.12-1.12-.28,1.27-1.12,2.39.14,1.83,1.97,5.06-.42,1.12,1.55-.14,1.27-1.97,1.69.56,2.25,2.11.56.7,2.95.56,2.11-.28,1.69Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m807.92,312.85l-3.8.98-.7,1.97-1.41.14-1.41.84.28,3.8,2.11,1.97.7,4.5-1.27,1.69,2.39,4.92v4.36l-.28,2.95-.56,1.83-.98,2.25.28-3.23.14-3.8v-1.83l-.42-1.27-1.69-2.11-.42-3.09-.42-3.65-1.12-.84-.84-1.12-1.41,1.41-1.55,1.83-3.38.7-1.69-.42.28-1.69-.7-2.39v-3.8l-1.83-1.83-.7-2.81-2.95-1.83-.7-1.83,1.55-1.69.28-1.69,2.11-1.12-.56-3.94,1.27-.28.42-1.69,1.55-.28,3.09-9.14,4.08-1.69,1.41-2.11h0l2.11-.21,1.69,3.58.63,4.01-2.74,2.95v3.37l1.9.21,2.53,2.95v2.74h2.53l.21,1.05,2.32.84.49.98-.98.28-1.84,2.26Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m815.24,358.12l1.97,3.65.28,4.22,1.12,1.27,1.27,2.25.56,2.95-1.83-.56-1.97-.7-2.11-2.25-.7-.14-1.69-1.12-1.41-1.97-.42-2.11-1.83-3.23v-2.39l-.56-1.55,1.69-.28,1.13,1.55,1.83.7,2.67-.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m829.73,332.39l.7,3.23-1.27,3.37h-3.51l-.98.84.28,1.97-2.53,1.41-1.27.56-.28.84h-1.97l-1.97-1.27-.84-2.11-.98-1.97.56-2.81-1.12-.84.14-1.41,1.12-.98.56-1.69,1.97-.56,4.22,1.27,3.09.42.42-1.55,1.12-.7,1.41,1.83,1.12.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m831.98,309.9l-1.12.98-2.25.7-1.97,2.81-.98.42-1.12,1.41.28,3.37,1.27.84,2.95,4.22,1.41.7,1.83,2.25,2.39,3.09.56,5.76-.56,2.95-.28,2.11-2.95,2.11-2.81.84-.7,1.12-1.27,1.69-1.41.28-2.81,2.53-.84-.42.28-4.22-.98-.84.28-.84,1.27-.56,2.53-1.41-.28-1.97.98-.84h3.52l1.27-3.37-.7-3.23.14-5.34-1.97-.7-.42-1.27-3.66-3.52-2.11-3.52.28-4.64-2.53-1.69-3.09-.28-.14-2.53-1.12-.98-.43-1.34,1.27-1.27,1.69.42,3.59.21,1.48-2.53,1.69,1.48h3.16l.42,1.05-.42,1.9,1.69,1.48,1.9-.21.84.77Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m898.93,235.95l-.91-.63-1.46-.97-2.97,3.08-2.25-.15.55,2.39-1.13,1.12-2.39.13v-2.11s-1.26-.14-1.26-.14l-2.41,4.07-3.94,1.39-1.39,2.78.98.7.98.28,1.27.42-.14,1.55.42,1.55-1.97,1.97,1.12,1.41h1.41l1.69-.42.22.17,2.15-2.34,4.66-1.2-1.97-1.55-1.12-.28v-1.97l.56-.98,1.97-.28,2.53-1.83,2.11-2.53-.14-1.83.84-1.83,1.97-1.97h0Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m596.31,97.73l-.21-2.91-2.74-1.39-2.53.13-2.74,1.26-.21,3.42-2.11,1.65h-.84l-1.27-.76h-1.69l-1.9.89-2.11-.38-2.74-2.4-1.69-.13-1.48.89-1.48.13-.63,2.4-1.69.38-1.69-.38-1.69.13-.63,1.77-2.53.76-.84,1.39-2.32,1.77,1.05.63-.2,1.27-3.38,3.3-1.69.63-1.05,1.69.84,1.9-.63,5.69-1.9,2.95,1.69,2.53-1.69,1.69-2.95-.42-1.69,1.69v5.06l.63,7.38,1.27,1.69v2.53l-1.69.63-.21,1.05,1.27,1.69-.42,1.9-1.05,1.26-.63,5.69-.21,1.48-.84,2.6-.56-1.69v-1.97l-1.55-1.41.42-1.69-.7-.42-.84.7v1.69l-1.27,1.12-1.41.14.14-.56-1.12.84v.84l-1.97,2.81-1.27.7-1.69.98-1.97.84-.98-1.55.98-1.41-.84-.14-.56.56h-1.41v-1.55l-.7-.14-.98-1.26.28-.98,1.41-.28v-1.26l.84-1.12-.98-.14-.42.7-1.27.28-.14-1.26.42-.98,1.27-.56.42-1.26,1.55-1.69.14-1.26-.7.28-1.12,1.41h-1.12l-.7-.56.84-.98-.28-.84-.84-.42-.14-1.12,1.83-.42.98.14,1.12-.42.98-.28,1.27-.42.14-.84-1.12.28-.98.42h-2.67l-.7.56-1.41-.28.28-2.11-.28-1.83.42-.56.14-.84.56-.84,1.12-.28.98-1.69,2.53-.14-.14-.7-.84-.28.28-.84,1.12-.14v-1.12l1.41-1.12h1.25l.28-.84,1.83-1.12,1.12.28.42-.84.7-.7.56-2.39,4.08-3.65v-1.27l2.53-3.09,1.41-.28.84-1.26-1.12.28v-.7l.84-1.12.7-2.39.14-1.97,1.97-.14.98-.98-.84-.56-1.55.42v-1.55l.84-.42,1.83-1.86,1.55-.84,1.12.08,1.12-.76-1.41-.17v-.34l1.27-.34h1.27l.28-.76-2.11.08,2.53-2.28.84.76.98-.25-.13-1.52h2.25l.14-.68-1.12.08-1.69.08,1.27-1.18,1.69.09.98-.76-.14-.68.84-1.18,1.41-.42.42.68.84-.59.14-.84,1.12.42.7-.25-.56-.42-.56-.42.42-.76h.98l.42.76.7-1.43.7-.51.84.34-.56.76-.28,1.1.14.76.98-.17.7-.68v-1.26l.84-.68,1.69-.08.42.42.98.08.28-.68-2.53-1.1.28-.59,1.12-.34,1.55.25,1.55,1.1.42.68,2.11-.17-.56-1.18,1.12-.93,1.41-.25.56-.76.84-.42-.84-.76.42-.68.84-.08,2.32.13.42.63-1.27.76-1.05,1.14-.42,1.65,2.32-1.14.63-1.01,1.05-1.65h1.49l-.63.76.63.51,1.05-1.39-.42-1.14,2.74.25,1.27.89-1.27.76,1.05.63,1.05-1.01,1.27-.25,4.22,2.4-2.11,1.52-3.17-.51-.21.51,2.53,1.01v.63l.84.25,1.69-.63,1.27.51-4.01,1.52-.21.63-1.48.76Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.69,208.11l2.74.21,2.32.63-1.48,3.8-1.05,3.8,1.27-.84,1.9-.42,1.9,1.48,1.69.42,2.53.21,3.17-.63,1.9-1.05,2.11.42.84-1.05-.42-1.9,1.69-1.27.42-1.27-4.22-3.37-.63-3.16,4.64-2.53.84-1.27,2.95-.21-2.53-7.8.42-3.59-.49-2.25-1.27-1.41-.77-.39-.21-1.76-3.38.88-1.41,1.41-2.39-.14-.7-.7-1.97-.28-1.07-1.78h-.15s-2.05-.16-2.05-.16l-1.17.29-.06.11.71,2.24-.14,1.97-1.12.84-.84.56-.98-.42h-1.55l-1.12,1.41.74.84-.84,1.9.42.95-.21,1.79-2.43,1.79-.42.84.53.84-.84,1.79-.21.95.84.95.11,2.11.95,1.48.52,2.73Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.88,182.28l-2.05-.15-1.17.29-.06.11-.14-.43-.14-2.11-1.27-1.41-.42-2.53.14-2.25,2.25-1.41,1.12.28,1.27-1.69,1.27-.14,1.12,2.25,1.27.14.84.56-.56.98-1.97.42-.28,1.26-1.97,1.55-.14,1.97.84,1.97.2.33-.16-.02Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.79,197.25l.42-.84,2.43-1.79.21-1.79-.42-.95.84-1.9-.74-.84-2.95.14-1.55.98-.14,1.12,1.12.84-.14,1.12-1.41.98-.42-.98.7-.98-.42-.56-1.27.28-.98,2.53-1.27,1.69-.14,1.26.14.56-.42.7h-.84l-1.27.28,1.44.56,1.58-.5,1.27-.66.95.21,1.58.11.21,1.69.74.95.21-.63.21-.95.84-1.79-.52-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.69,208.11l-.53-2.74-.95-1.48-.53.84-.11,1.27.11,1.69,2,.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.38,218.86l.63,1.05-1.27.63-.21,1.27-1.27,2.11-4.85.21v-.84l-.84-1.05v-1.69l2.11.84,3.17-1.9,2.53-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.43,237.49l-1.97-.7-.7-1.55-2.67-1.41-2.25-1.41-1.55-1.69-.28-1.55-.98-.98-.84-1.83-1.13.7-.42,1.12-1.13-2.11.7-1.12.21-.84,4.85-.21,1.27-2.11.21-1.27,1.27-.63,1.48.42,1.27,2.74,4.22.42.84,2.95-3.59.42-2.53-1.48-1.05.42-.42,1.48-1.05-.21-.84.63.63,2.53,2.11,2.11,2.74,2.53.21,1.27,1.48.63-.07.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.51,236.79l-1.48-.63-.21-1.27-2.74-2.53-2.11-2.11-.63-2.53.84-.63,1.05.21.42-1.48,1.05-.42,2.53,1.48,3.59-.42.63,2.32.21,3.8-2.32,2.95-.84,1.26Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.62,221.82l-.84-.21-3.38,1.05-.42.84.84,2.95.63,2.32.21,3.8-2.32,2.95-.84,1.27-.07.7,2.39,1.41.84-1.48,1.05-.84,2.11.63,1.05,1.9,2.32-1.48,3.17-1.05,1.27-2.53-1.69-1.69,1.05-2.11-1.69-1.9-4.01-.63-.21-3.37-1.48-2.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.89,239.11l-1.05-1.9-2.11-.63-1.05.84-.84,1.48,1.12,1.41.14,1.41-.42,1.83.42,2.53,1.83,2.25,1.55-1.2,1.27-2.11-.42-1.69-1.05-2.11.63-2.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.89,239.11l-.63,2.11,1.05,2.11h3.59l1.27-1.48h1.48l-.21-2.53-1.05-2.74-3.17,1.05-2.32,1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.64,241.85l1.9-.63,1.48-.63,2.11.42,1.48.84,1.48-.21.84-2.32,1.9-.63,1.9.35.7-1.41.14-3.23,1.27-.84.14-1.69-3.94-1.62h-1.48l-2.32,1.69-3.17.42-3.17-.84-1.9-1.27-1.05,2.11,1.69,1.69-1.27,2.53,1.05,2.74.21,2.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.92,239.32l1.9-.63,1.9.35,3.38,3.23-.14,1.12h-1.69l-1.83-.28-.42.98-2.25.42-1.41,1.55-.14-.7.7-.84-.77-.32,1.4-1.72.42-1.69-1.05-1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.15,244.2l1.4-1.72.42-1.69-1.06-1.48-.84,2.32-1.48.21-1.48-.84-2.11-.42-1.47.63-1.9.63h-1.48l-1.27,1.48h-3.59l.42,1.69-1.27,2.11-1.55,1.2.42,1.27,1.12,1.12.56,1.69,1.41,1.27,1.69-.42,2.39.14.56.98-2.81-.15-1.83.42v1.12l1.12,1.12-.42,1.55.42.56,1.27.14.7.84h1.12l1.12.28-.14-2.11-.84-.84.28-.42,1.27.28.28-1.69,1.69-.14v-1.27l-1.41-1.41-1.97-.7.42-2.67-1.83-2.39.14-1.41.98-.42.7.42.14.84.98,1.12.42-.14-.28-.98.56-.14.28,1.12h.42l-.14-.84.84.28.28-.56-1.27-.7v-1.27l1.55-.28,1.12-.28.84.28,1.41-.42,1.63.67Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.01,230.25l1.9,1.27,3.17.84,3.17-.42,2.32-1.69h1.48l3.94,1.62.7-2.81,2.81-2.95-.42-1.27-1.55.14-1.48-.42v-1.9l-1.05-1.27-1.27-4.85-1.69-2.53-1.9-.42-2.11,1.05-2.74.63-2.74-1.27-2.11-.42-2.32,1.48-2.32,2.74-.84,3.37-2.32.63,1.48,2.53.21,3.37,4.01.63,1.69,1.9Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m589.13,213.59l1.9.42,1.69,2.53,1.27,4.85,1.05,1.27v1.9l1.48.42.21-2.53,1.05-1.9,1.27.21.42-1.27-1.27-1.27-.84-3.8-1.69-2.11h-4.43l-2.11,1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m617.26,270.32l-.84-.14-.49,1.05-.83-.3-.07-.09.2-.74.56-1.27.42-5.76,2.1-1.94.91.97-.34,2.73.1,2.28-1.08,1.03.04,1.22-.68.96Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m612.2,277.91l.84-1.69.35-1.2.84-1.55.42-1.27.37-1.37.07.09.83.3.49-1.05.84.14-1.23,4.13-.11.51-1.41-.56-.42,1.62.63,1.05-.77.7.91.98-.35,2.46-1.12,3.02-.42-.07-.77-2.53-.56-1.83.91-1.05-.35-.84",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.43,213.59l-2.53-2.11.63-2.53,1.48-1.27-.21-1.05,4.01-4.43-.42-3.8,2.95-2.95,2.11-.21,1.9,1.05,1.69-.21,2.11.63,1.27-.42,4.64,1.48,1.69-.42.63-1.9,2.95-.63,2.11-1.05,4.01.42,1.27,4.85,2.11.42.21,1.69,1.27,1.48,4.85-.21,2.32,1.9h1.9l1.67,1.5,2.55,2.3-1.69,2.11-.42,3.58-1.27-.21-2.11,2.11-1.83,3.23-1.97-.14-1.27,1.27-3.66.14-.14.98-.56.7-3.23.42.28.7,2.11.84.84,1.12,2.67.28.98.14v1.12l-1.97.14-1.69.7-2.11,1.55h-1.97l-.56-1.41.14-1.55-2.11-.7v-.84l.7-.14,1.83-1.12v-.7l-1.41-.56-1.97-.14-1.41-.28-.84-1.27-.84-.14-.98.98-1.83.14v1.41l-2.25,2.25-1.55.14.21-2.53,1.05-1.9,1.27.21.42-1.27-1.27-1.27-.84-3.8-1.69-2.11h-4.43l-2.11,1.27-2.11,1.05-2.74.63-2.74-1.27-2.11-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.89,114.76l-.35-2.39.21-3.01-.21-2.15-1.9-1.39,1.27-2.02-4.22-2.78-1.9-.13-2.11-1.39-.63-1.52-1.48.13-.63,2.4-1.69.38-1.69-.38-1.69.13-.63,1.77-2.53.76-.84,1.39-2.32,1.77,1.05.63-.21,1.26-3.38,3.3-1.69.63-1.05,1.69.84,1.9-.63,5.69-1.9,2.95,1.69,2.53-1.69,1.69-2.95-.42-1.69,1.69v5.06l.63,7.38,1.27,1.69v2.53l-1.69.63-.21,1.05,1.27,1.7-.42,1.9-1.05,1.26-.63,5.69-.21,1.48-.84,2.6,1.55,1.26-.28,4.08.98,1.41.42,1.69,1.27,1.41v2.67l.98,1.83,1.27,1.12.98-.28.98-.14,1.83-2.81,1.97-.14,1.41-.98,1.27-3.8.98-3.23-.28-4.64,1.12-1.55,1.12.28-.14-1.26,1.12-.7,1.12.14,1.97-2.81-.14-4.22-2.11-2.53-2.39-1.69.14-4.22.7-1.26-.42-.7v-2.53l1.69-1.12.56-3.65,1.97-.98,1.41-1.97,2.11-1.55,2.39-2.39,1.97-3.09-.42-1.41-.28-.84,1.41-2.67v-1.41l1.69-1.41.42-1.41,1.97.42,2.54-.99Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.97,148.92l.7-3.02,3.16-4.43,5.27-6.33-2.32-3.16-2.11-.63-.42-1.69,1.05-1.9v-1.9l-1.27-2.32.84-1.48-1.48-1.05.84-2.74-.63-2.32.42-3.59-2.95-4.4,2.11-2.28-1.26-2.65-2.53-1.39v-1.64l1.9-2.28-.21-2.91-2.74-1.39-2.53.13-2.74,1.26-.21,3.42-2.11,1.65h-.84l-1.27-.76h-1.69l-1.9.89-2.11-.38-2.74-2.4-1.69-.13-1.48.89.63,1.52,2.11,1.39,1.9.13,4.22,2.78-1.27,2.02,1.9,1.39.21,2.15-.21,3.01.35,2.39,1.97.56,2.67,2.53-.28,1.27.28,1.12-.98,1.41h-1.27l-1.13,3.65-1.69,2.25-1.27.42-.7,1.83-.98.28-1.13,1.12-.7,1.69-1.27.28-.14,1.26-1.69,1.69c0,.99.04,1.97.14,2.95.14.7.84,3.37.84,3.37l.7,2.39-.84.84.56,4.64,1.41.14.56,1.13h1.69l.28,1.69.98.28,1.55-.56.84-.56,1.13.14,1.69-.84h1.97l.42-.98,2.81-.56.7-.7,1.41.7,2.53-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m592.51,166.15l-3.38.21-1.48-.63-1.05-1.27-1.48-.21-1.97.28-.7-1.12-1.41-.56.14-2.39-1.27-.98.14-.56,3.23-2.67,2.39.28,1.69-.84,1.27.28,3.66.56-.84,4.78,1.05,2.53v2.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593.35,174.79l.21-3.8-1.27-1.69.21-3.16-3.38.21-1.48-.63-1.05-1.27-1.48-.21-1.97.28.06.41.22,1.42-.7,3.51-1.83.42-1.97-2.39-.84-1.83-1.97.84-1.97.56.14,2.95-1.41,1.55-.42,1.55.84,1.26,1.48-1.48h6.54l5.27,1.05,2.74,3.37h1.48l2.53-2.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m770.16,208.32l3.38,4.85h3.38l4.64,6.75-1.9,2.32,2.11,2.74,3.59.84,10.13,4.43-.42,3.37,2.11,2.53,2.95.21,1.05-1.05.84-.42,1.69.84,3.8-.84,5.06.42,3.16,2.74,3.38.21,2.53,1.27,1.9-.63,4.64-2.53,2.53,1.05,2.74-.42,3.8-1.69,2.32-2.74,2.74-.63,1.05-2.11-1.9-1.48,2.11-3.37,4.43,1.27,3.59-3.58,1.48,1.48,1.9-.42,1.05-4.01,1.69-.63,1.05,1.48,1.9-.63-.22-1.68,2.53-.21,1.9.63,1.27-.84-1.27-3.37-4.85-1.48-1.27,1.9-2.32-1.27-1.05,1.27-1.69-1.05.21-1.9,1.48-1.69,1.9-4.43.53-1.05-3.48.42-3.16-2.53-2.53-.42-1.49,2.53-3.59,2.32-3.16-.21-4.43.84-1.26-1.05-3.8-1.48-.63-1.69-7.81-2.32-5.7,2.11-5.06-6.96-7.39-2.11-1.69,2.32-2.32,2.11,1.27,2.74-.42,3.16-3.8.42-.21-1.48h-2.31l-.63,1.69h-1.05l-3.59-3.58-2.74.21-2.53-1.69h-1.69l-2.32,2.11-1.69.21-2.32,3.16-5.06,1.05-1.05,1.69Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m637.45,240.59h-2.11l-2.15-.64.18-1.05-.84-1.55-.28-1.27-.84-.98-1.55-.28-2.25-1.97,3.94.98,4.43.63,1.48-.42,4.01,1.9,4.01,2.32h.84l1.48,1.69,1.05,2.32-.21.84-4.43-.21-3.17-1.05-3.59-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.3,247.97l-1.48,1.27,1.69,5.9-.21,2.32-1.9.42-1.12-1.41-2.25-.42-2.1,1.46-.71-.9-2.67.42-3.66,1.27-3.52.56-1.55-.42-4.36.98-.15,1.71-2.1,1.94.28-1.12v-2.67h-3.1l-.84.56-1.27.42-.98.56-2.39.56-1.69-.14-3.09-2.25-.98-.7-1.41.84.14.98-1.55.14-2.25.84-.84-1.41-.84-.28-.98.98-.56.98-1.41.56-.14-.7.98-1.12.14-1.12-.7-.7-1.12.7-.84.28.14-.98.98-.42.42-.56-1.12-.42v-1.83l-.7-.98-1.12.14-.84-.84.14-.7,1.41.14.28-.7-.14-.84-.28-1.55.42-.84h-1.41l-.28-.7,1.12-1.83,1.41-.98h1.69l1.69-.56,1.83.42,1.69-.7.28-.7-1.55-.56.14-1.27,1.12-.28h2.81l1.27.42,2.67-1.69,3.8-1.41,3.23.28,1.41-.42,1.27,1.69,2.25-.28,2.53,2.11,1.27-.14,2.67.98,1.83-.7,2.25.56,2.11-.14,3.52-1.69.24-1.34,2.15.64h2.11l2.11,2.95.42,2.32,1.69,1.05.63,1.04Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m692.44,298.79l-.84-.56-1.83-.14-1.83-.28-2.11.28-1.83-.56-2.81-.7-1.41-.84-.14-1.12-.56-2.11-1.12-.84-.84.14-1.69,1.55-5.91-.14-.84-.56-1.41-.28-1.97-2.25-1.27-.14-2.11-1.55-.28-1.41-.84-1.55-1.83-2.11-.28-1.55-3.66-.28-1.55.56-1.69-2.11.21-3.59-2.11-3.16-2.32-.42-3.16-4.22,2.95-5.69-.84-1.27h-1.69l-2.53-4.43.21-2.32-1.69-5.9,1.48-1.27,3.59,2.32,1.64-.41,1.74-.43,3.16-1.05.42.84-.21,2.95,1.88,1.39c.74,1.49,2.22,2.46,3.88,2.53-.08,1.77,2.02,2.45,3.12,3.37,1.71.23,3.45.03,5.06-.59,1.18-.34,3.29.51,3.8-1.01l.08-1.89,3.27.42,1.48-2.95,7.17.84,1.05,1.05,2.32.21,5.49,3.8.42,3.16v2.74l-2.32,3.16.84,4.85-.21,2.53.84,1.69,1.27-1.05,1.27,1.9-1.69,2.53-1.05,2.32h0v1.9l5.27,4.43-.21,2.11,1.9.21v2.11l-4.02,1.67-.21,2.74-.91.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m675.15,239.04l-2.81.28-1.83-1.83-1.83-.84-1.41.28-1.09.94c-.11.56-.09,1.15.07,1.7.42-.42.59-1.43,1.35-1.69.89-.04,1.78.2,2.53.67.51.51.51,1.27.76,1.86.76.76,1.94,1.43,1.69,2.45-1.38,1.22-3.28,1.66-5.06,1.18-.67.17-.59,1.01-.67,1.6.51,1.01,1.35-.51,2.03.42.52.47.65,1.23.34,1.86-.34.25-.93-.08-.93.34.51.67,1.77,1.01,2.03,1.94l.17,5.79,3.27.42,1.48-2.95,7.17.84,1.05,1.05,2.32.21,5.49,3.8.42,3.16,2.53.63,1.69,1.27.63-1.9,5.7-3.37,1.27-2.95,3.59-.28-1.13-1.69-1.97-.42-2.67-1.41-2.67-1.12-2.39-2.81-1.13-3.94-1.69-2.11-2.11-.56-4.09-1.69.42-1.27-.33-1.54-.84-.98-1.69-.84h-.98l-.28.7-.84-.14-1.83.98-.84,3.09-4.87-1.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m714.27,240.96l.4-1.63,1.97-1.97,3.8-.84,1.13-1.41h2.11l1.41,1.27,3.38-.42-.7-1.83,3.09-1.83,1.55.7,1.27,1.83,4.22-1.41,4.92.84,3.94,1.12,1.48,1.2,1.05-2.95-.63-1.9-.21-3.16-1.9-2.11,5.91-2.11,1.48,1.9,1.32-1.41-.26-1.75,2.32-5.48,3.59-.21,2.32,1.05,1.69-1.69-1.05-4.01,5.49-4.43h0l-.42-1.48-5.91-1.69-4.64-5.48h-10.97l-2.74-4.85-1.48-3.59-4.43-2.74-1.05-3.16v-2.11l-3.8-.42-1.48,1.69-.84,1.9-3.59.63-.42-2.53-4.01-1.69-2.32.63-1.27-3.8-2.11-.84-4.01-.42-3.8.42-3.38,2.74-8.02,3.37-4.64,1.27-3.8.63v2.32l2.74-.21v.84l-2.53.84-.42,1.27,1.27,1.05-.42,1.27-1.69.42-.21,2.11,2.11,1.48.21,2.32-1.48,1.05-1.27-1.9-.84.21-.21,1.69-4.01-.84-1.48-1.27h-5.28l-1.69,1.69h-1.05l-1.27-1.27-1.69.21-1.69-2.32-2.74.21-1.27-1.05h-2.95l-1.48-1.69-6.33,4.22v3.17l-1.9.21-1.05-1.48-1.69.42-.84,12.02,4.01.84,1.9,2.32-.63,2.95,1.49.83c1.31-.25,2.58-.67,3.78-1.26,1.52.34,0-2.53,4.62-1.86.67,1.77,3.21-.34,3.54,1.86.67.93-.42,1.69-.25,2.61-.17.93.42,2.28-.51,2.78-1.69-.11-3.38.24-4.9,1.01-.22.47-.28,1.01-.17,1.52.3.15.42.5.28.8,0,.01-.01.03-.02.04-1.01.76-1.6-.93-2.7-.76-.34,1.6,1.52,2.53,2.19,3.71.42,1.1.42,2.45,1.52,3.12,1.35-.51,1.86,1.01,3.04,1.1.19.8.17,1.65-.07,2.44l1.09-.94,1.41-.28,1.83.84,1.83,1.83,2.81-.28-.56-10.97,8.54-4.57,8.23,5.59,2.22,2.64,1.97-.28,2.95.28,1.41-.14,2.39,1.55,1.42,3.09,1.83-.56,1.97,5.06,1.13.14,1.69,1.83,1.13-.14,1.41-1.12,1.42-.47Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m649.26,249.44l3.16-1.05.42.84-.21,2.95,1.88,1.39c.08-1.52-.93-3.12.34-4.39.34-.25,3.1-2.4,3.27-2.9.34-1.86-.13-2.15-1.48-3.58,0-1.71-1.86-2.6-3.12-3.79l-.04,2.31-1.9.63-3.8-1.9,1.05,2.32-.21.84-4.43-.21,1.05,1.69,1.05,1.9,2.96,2.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.3,247.97l1.69-.21,3.54,2.12-1.64.41-3.59-2.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m614.87,278.75l1.05-3.8.11-.51,2.49.16,3.59-2.32,2.81-.56,1.76,2.88-1.34,1.41-5.42.07,2.18,5.69-.63.84-2.6.28-1.9,2.18-3.59.56v-1.41l1.12-3.02.35-2.45Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.11,307.01l-7.81-1.05-2.11-2.11.56-1.27-1.12-1.12-1.48-.42-.49-1.41-2.53-3.09.28-2.53-.98-.56-1.69-3.65-1.55-.7-.28-1.27-1.27-1.05h-1.9l-1.48-1.27-5.49.63-5.06-2.32v-3.16l-3.38-2.11-4.64-2.74-4.01-1.2-1.34,1.41-5.42.07,2.18,5.69-.63.84-2.6.28-1.9,2.18-3.59.56v.21l-.14,3.94,1.69.42.28.7,1.83,3.52.56,1.69,1.97,1.83.14,2.67,1.55,1.97,1.55.98,1.55,1.41,1.27,1.83v3.52l1.12,2.25,1.69,2.11,1.97.98.42,1.27,1.55,3.94,1.69,1.27,1.97,2.67,2.67-1.55,6.47,1.55,2.53,3.09,6.47-7.31,10.69-2.25,6.89-3.09h2.11l1.55-6.75-2.32-1.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m669.24,324.66l-1.12-1.12-1.55-.84-.84-.7.56-.56-1.41-3.09-10.69,2.25-6.47,7.31-2.53-3.09-6.47-1.55-2.67,1.55v1.69l.42,2.81-.14,1.27,1.55,3.09.14,2.81,1.41.84.56.7,4.08-.84,1.12-1.41h2.25l1.41-.7,5.49-1.69.42-.98,1.55-.7.98-.56,2.53-.42,1.69-.84,2.39-.56,1.12-1.12v-.56l1.76-2.11,2.46-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m669.24,324.66l4.36-.42.7-1.83,2.39-.56,1.27-.7v-1.27l2.67-2.25.42-1.83,1.41-1.83,1.27-.56,2.67-2.81,1.41-2.25-.7-1.41-1.27-.28-1.97-2.11-.56-1.12-2.25-.28-2.53-1.12-.84-1.41-.56-1.55-1.9.14.84,2.53-2.74,2.74-.21,2.53,2.32,1.48-1.55,6.75h-2.11l-6.89,3.09,1.41,3.09-.56.56.84.7,1.55.84,1.13,1.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624.93,271.73l-2.81.56-3.59,2.32-2.49-.16,1.23-4.13.67-.96-.04-1.22,1.08-1.03-.1-2.28.34-2.73-.91-.97.15-1.71,4.36-.98,1.55.42,3.52-.56,3.66-1.26,2.67-.42.71.9-3.53,2.48,1.41,2.81-1.12,3.51-6.19,4.08-.56,1.33Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.44,283.52l-2.54-.76-1.05,1.27.42,1.48-5.49.63-5.06-2.32v-3.16l-3.38-2.11-4.64-2.74-4.01-1.2-1.76-2.88.56-1.34,6.19-4.08,1.12-3.51-1.41-2.81,3.53-2.48,2.1-1.46,2.25.42,1.13,1.41,1.9-.42,2.53,4.42h1.69l.84,1.27-2.95,5.69,3.17,4.22,2.32.42,2.11,3.16-.21,3.58,1.69,2.11-1.04,1.18Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m749.9,281.08l-.77,2.11-.84,1.97.7,2.25,1.97.84,1.41.84,5.34,1.12,3.09.28,3.52,2.67,3.38,1.12,3.38-.56.98-2.25-.63-2.39,1.48-.42,1.9.84.49,1.69,1.27,1.69,7.46-.56.07-3.02,4.85-3.58,6.75-2.11,1.27,1.05-.21,1.05,2.32,2.11h0l-1.41,2.11-4.08,1.69-3.09,9.14-1.55.28-.42,1.69-1.27.28.56,3.94-2.11,1.12-.56-2.11-.7-2.95-2.11-.56-.56-2.25,1.97-1.69.14-1.27-1.13-1.55-5.06.42-1.83-1.97-2.39-.14-1.27,1.12,1.12.28.84,1.12.28,1.41h-2.25l-.14.98,1.41,1.55.14,2.67.7,1.41v4.22l-4.92,1.54-1.12,1.55.56,1.27-.56,1.27-2.11.98-2.39.84-1.83,1.69-.42,1.55-1.83.98-.7.84-1.83,1.12-2.25,2.39-1.12,2.11h-1.41l-1.83,1.69-1.41.14-.84,1.12.14,3.09.14,1.41-.28,4.08-.98,1.97.28,4.08-.98.14-.98,1.12-.14,1.41-1.55,1.12-.84.98-.56.84-1.69,1.69-1.97-.84-1.27-1.55-.98-3.65-1.12-2.67-1.12-2.53-1.69-2.39-.29-1.41-.56-1.69-.42-1.69-1.97-4.78-1.12-1.69-1.55-5.2-.7-4.5-.14-4.78-.42-.7.14-2.67-1.12-1.12-.56,2.67v.84l-.84,1.27-3.09.42-1.97-1.12-2.95-2.95-.14-1.55,1.27.28,1.41-.28,1.12-1.41-2.11.56h-2.11l-.84-.84-.14-1.27-.84-.28-.56-.7h0l1.55-1.69,2.39-1.27,4.36.56.28-2.53-3.38-5.76,1.55-3.8,1.12.98,2.25-.14,5.91-5.62.7-2.81,1.97-.98.42-3.09,2.11-1.69.56-1.41-2.11-2.25-2.11-.7.28-5.62,2.81-.28,3.16.63,3.8-.63.45.37,1.05,1.05,1.37.74.53,2.21,1.48,2,.1.95-.84.63-.98-.37-.63.63,1.69,1.48-.21,2.74,1.48.84h2.32l2.32,2.32h0Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m807.93,312.85l-3.8.98-.7,1.97-1.41.14-1.41.84.28,3.8,2.11,1.97.7,4.5-1.27,1.69,2.39,4.92v4.36l-.28,2.95-.56,1.83-.98,2.25.14,1.55-.42,1.69.14,3.09,1.27.14,1.69,2.53,2.11,2.39,1.69-.28,1.12,1.55,1.83.7,2.67-.28-1.27-.98-1.97-1.83-1.83-.84-1.83-2.25-1.12-3.52-1.41-.42-.84-2.67.84-3.8,1.83-2.53.14-2.95,1.41-1.12,1.27.14.84,2.25,2.39.7,1.41.98.56-2.81-1.12-.84.14-1.41,1.12-.98.56-1.69,1.97-.56,4.22,1.27,1.12-3.94-.42-1.69-2.81-3.51-.84-3.52-1.54-.27-1.41,1.4h-1.41l-.98-.98h-1.55l-2.11,2.11-.98-1.12.28-1.12.56-3.51-1.97-.84-.56-2.39Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853.78,360.23l-1.97-.14-.94.39-.18,1.86.84.14.28-1.12,1.27.87.42-.73.28-1.26Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m859.69,362.62v2.25l1.55,1.55-.14,2.81,2.25.84.7,1.55-2.11.14-.56-.84-1.83,1.83.56,2.67-2.39,3.09-1.55.56.28,2.95-2.67,2.81-2.25.84-.14-.7-1.69-1.27-1.41.42-.7-.7-1.69-.28-2.11,1.12-1.27-1.27-3.94-.7-1.41-4.78-1.97-1.69-.7-5.9,1.41-.98.98.42-.28-.14.56.98.98,1.69h4.08l2.11-1.27,1.55-.28,1.41.7,2.67-.7,2.67-3.23,1.41-3.94.98-1.27,3.66-.14.98.83Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m836.9,369.36l3.94-.14.42-3.09,2.25-.14,1.27-.98,3.09-1.12,1.55-2.81,1.45-.6-.18,1.86.84.14.28-1.12,1.27.87.42-.73.28-1.27.42-2.81,4.78-4.64,1.12,3.23,2.67.42,1.83,2.11-2.67.84.7,1.41-1.54.56-1.41,1.27-.98-.84-3.66.14-.98,1.27-1.41,3.94-2.67,3.23-2.67.7-1.41-.7-1.55.28-2.11,1.27h-4.08l-.98-1.69-.56-.98.28.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930.3,401.42l-.42-6.05-.84-1.27-.14-1.12.98-1.27-.52-10.04-.18-.08-2.25-.14-2.95-2.11-5.06-.7-1.69.7-.14.98-4.36,3.94-1.41-1.13-.42-1.55-1.41-.98v-2.39l-.7-1.55h-2.39l-1.69-.98h-1.12l-1.27.84h-.98l-.84,1.83,1.83.42,1.27,1.83.98.42h2.81l.7.42-.7,1.12-4.36-.42.14.56,1.27,1.12.7,2.25,1.69.84.56-1.12,1.12-.28,2.67,1.27,2.81,1.12,2.39.42,2.25.7,2.95,2.39.42,2.53,1.12.98.56,1.41.28,2.25,2.67-.14,1.55,1.55,2.11,1.41Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m885.37,254.54l2.15-2.34,4.66-1.2.56,1.55,1.55,2.95v2.11l.84,3.65-.42,1.12-.42,1.12-.56.7-1.12.42-.98.84-1.27.14-1.97.7-.84.56h-1.12l-1.12-1.83.7-.7.14-1.55.28-1.27-.42-2.53-.42-1.27.84-.7.14-1.55-1.41-1.12.22.17Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.52,196.77l3.15,3.11.84-.21,1.27,1.9,1.48-1.05-.21-2.32-2.11-1.48.21-2.11,1.69-.42.42-1.27-1.27-1.05.42-1.27,2.53-.84v-.84l-2.74.21v-2.32l3.8-.63,4.64-1.27,8.02-3.37,3.38-2.74,3.8-.42,4.01.42,2.11.84,1.27,3.8,2.32-.63,4.01,1.69.42,2.53,3.59-.63.84-1.9,1.48-1.69,3.8.42v2.11l1.05,3.16,4.43,2.74,1.48,3.59,2.74,4.85h10.96l4.64,5.48,5.91,1.69.42,1.48h.84l1.05-1.69,5.06-1.05,2.32-3.16,1.69-.21,2.32-2.11h1.69l2.53,1.69,2.74-.21,3.59,3.58h1.05l.63-1.69h2.32l.21,1.48,3.8-.42.42-3.16-1.27-2.74,2.32-2.11,1.69-2.32,7.39,2.11,5.06,6.96,5.7-2.11,7.81,2.32.63,1.69,3.8,1.48,1.27,1.05,4.43-.84,3.16.21,3.59-2.32,1.48-2.53,2.53.42,3.16,2.53,3.48-.42,1.58,1.69,4.64-3.16-.21-2.53,1.48-.84,1.26-4.22,2.11-1.69.21-2.32-2.11.21,2.95-4.85,6.75-.84,4.64,1.48,3.16.63,2.74,5.27.21,2.32,2.11,4.43.63,4.22,2.74.21,2.74,1.05,3.59,3.58,1.27,4.22,2.32-.21,1.48-.84,2.96-.21,3.38-2.11,1.26.42-1.05,5.69-2.32,1.69-1.48,6.54-2.53,1.05-2.32-.63-2.53,1.05,1.27,3.8-.42,3.38-3.78,1.14,1.46.96.91.63h0l2.11-.56.42-1.27.98-.7,1.41.7.42.7,1.83.14.98.56,1.41-1.55,3.23-1.12,3.09-5.06,2.53-2.67,2.67-2.53.42-3.37,1.55-2.81,2.95-3.09.84-1.12,1.54-4.22v-1.55l.42-3.09-.42-1.55.42-3.37,2.39-3.65v-2.53l-1.69-1.41-.14-.98,1.27.7.14-1.12-1.12-1.97-1.41-1.41-.98-1.97-3.52-.7-.7,2.81-1.27.14-1.41.7-.28-.56.56-1.41-.7-1.55-1.27.84-.98,1.12-.14-3.65-2.25-.56-1.13.28-1.55-.98.28-.98,1.97-.7,1.69-1.69,2.53-1.83.84-1.27,2.25-2.67.14-1.41,3.38-2.39,2.67-3.09.56-1.69,3.23-2.81.56-1.69,2.53-1.97,2.67-.56,2.39.14,1.55-.56,2.95.14-.84.98.7.98,1.41-.42,1.27-1.41,1.12.84,3.24-.28,1.12.28,1.55-2.39,2.11-.14,1.69.28,3.52.14.7,1.55-1.12.7-.7.98.99.7,1.55-.84,1.83.56,2.11-1.69,1.27,1.55,1.12.14.28-1.27,2.25-.42v-1.68l-1.27-.7-1.41.56-.14-1.83,1.12-.98,1.13-1.69,2.25-1.69v-1.13l2.95-2.53-.42-1.97.57-.42,1.54-1.13,3.66-.14,1.27-1.12,1.69,1.26.56-.42.7-.84,1.13.98s-.12.83-.2,1.41h5.54l2.53-.14.42-1.26-.7-.98,1.55-3.94,2.81-1.27,1.83,1.83-1.97.7-.7,2.53-.56,1.41-.14,1.13h28.63l.34-.42,1.69-.28,2.11-2.11,3.8-.84,1.12-1.83,3.38-.56,1.69.98,2.81.56.14-1.26.84-2.11-.84-.7-.29-2.68-1.13-.98v-3.65l-1.12-.84.14-1.27-.98-.42-.42,1.26-1.69-1.41-.98-.7-1.83-.42-.84-1.97,1.41.14.7.98.56-.56-1.27-1.13,1.27-.7,1.41,1.55.7,1.41,3.94-.28,1.27-1.55.84-.56,2.25-2.67-.56-1.83-1.12-3.09,1.69-1.12.7.28,1.55-.7.14,1.41-.28,1.26-.14,2.25.98,1.13,2.11-.14,1.97-.28,2.25.84.56.84.42,3.51,2.39-.42,1.55.84,1.41,2.11,1.69.98,2.67-1.13-1.41-1.26.14-1.69,1.97-1.55-1.12-1.26.7-.56.42-.98,3.8-.84.98-1.12.28-1.55,1.9-.21.42-1.48-3.59-1.91-3.59-2.53-1.69.25-1.69-.38h-2.95l.63,1.26-.21.89.84.63-.63.76-2.74-1.77,1.27-1.01-.42-1.77-2.74-1.9-1.48.25v-1.01l-1.48-.25v-.63l-1.9-.38-4.22-2.02v-.64l-1.48-.89h-1.9l-.21-.76-2.74-1.64-1.9-.25-2.11-1.01h-1.48l-3.59-1.14-.84.25-1.27-.38-1.9-.13-2.32-.25-1.27.38-1.69-.25-6.54-1.26-.84.89,1.05.63-.63.51-.84.13-.42.63,3.38,1.9-.63,1.77-4.22-.13-.42-1.39-2.74-.13-1.27-2.02-1.05-.63-1.9,1.39-6.12-.38-2.74-1.14-1.48.51-1.9-.38-1.9.76-1.05-.13-.63.25-1.05-.13-.63.25-.63-.51-1.05.13-1.9-.76-.42-1.52,1.26-1.14-.63-1.77-3.59-2.02-2.53-.25-2.74-.63-3.38.13-5.06,1.52-3.8.38-2.11-.76-.21-1.01-2.32-1.39-3.17-1.27-2.74-.51-.21-.89,1.27.13,1.27.25.21-1.64-1.27-.13-2.32-1.01h-4.64l-1.48,1.9-2.53,1.14-3.17.63-.42-1.65h2.11l.42-1.39-3.59.25-.84-.63,1.27-1.01h2.74l2.74.38-5.48-1.65-2.96-.25-3.8-.51-2.32.13-.42-.63-.84-.25-.42.63.63.63-2.32,1.14-1.69.13-1.27-.25-.42,1.39,2.74-.13-.84.76-.21,1.9,1.05,1.52-2.74.51-.21-.89-1.48-.38-1.05.89-.42,1.39-1.48.13-2.53-1.64-3.59-.38-2.95,1.14-2.32-.13-2.53-1.65-.84-1.01-1.69,2.03-1.05,3.04-1.23,1.14-6.33-3.54-.42-1.14.84-.51-1.05-1.01-.84.51-1.27-.89-.21-1.26,2.11.63,1.27.13.21-1.65-2.32-.38-.84-.38v-.63l2.11.38,1.27-1.01-1.69-.63v-1.01l-2.96-2.78-1.48-.25-1.9,1.01-1.9-1.26-1.69.63-1.48-.76.21-.76-2.95-.51-.84.38-1.05-.25-.63.51.21,1.01.63.63v1.64l-1.48.25h-1.05l-1.05.89h-1.9l-2.53-.63-1.69-.13-.84.38-5.91-1.52.21-1.14.84-.25,1.69-.13-.42-.63-2.74-.25-4.85-.25-2.32-.38-5.06,1.01-.21,1.01-1.69.25-.42-.89,1.05-.63.63-1.01-.84-.76-1.48-.38v1.39l-1.9.13-2.74-.51.21-1.39-2.32.25-1.48-.25-1.69,1.14.42.76h1.48l1.48-.25-2.32,2.02-1.9-.13-.84.51h-1.48l-1.48.76-.42.63-3.38.13-.42,1.14-2.74,1.14-1.9.13,2.53-1.52v-1.64l1.27-.63h1.27l.21-1.39,1.48-.51h1.69l1.9-1.9,2.74-1.27,1.27-.13.21-1.01,4.01-2.28h2.32l.21-1.27,2.95-1.64,1.27-1.61-2.95-1.19-.63-.73.21-.37h.63l1.27.82,2.32.55v-1.74l-1.05-.18.21-1.65-1.05-.18-1.69,1.1-.63-.18.63-1.01-3.16-1.55-1.48-.18-.84-.46-8.65.37-.63.73-2.74.27-1.69-.55,2.32-.91.42-1.28-2.11-.37-1.48.64-1.27-.09v-.82l-3.17-.09v-.46l3.59-.27,1.48-1.19-1.05-.91-1.9.09-3.16-.82-4.01,1.01-.84.64-2.74,1.28-.21.91-1.69.73.63.91,1.05.37-.84.18.84.82,1.69.09,1.48.46,3.38-.27.42.37-2.96.46-2.74-.37-1.48-.18-1.9-.37-2.74.27-2.11-.55-.63.37.84.46,2.95,1.1.63.73-.42,1.28-2.32.46-.63-1.01,1.27-.82-2.95-1.01-1.48.55-1.27.82-3.17,1.01v-.73l-1.48.09-1.27.64-.84-.18,1.9-1.1-3.16-.55-1.9.27-3.38.09-1.48.37.63.55,1.27.18,1.69-.09-.42.46-2.74.27-4.22.18-1.05.64-1.69-.18-2.32.55-2.95.27-2.32,1.42-1.69.05-1.48-.05-.63.51,1.05.13,1.48.13-.42.63-1.27.76-1.05,1.01-1.9-.76-1.05.89.63.89,1.48-.13,1.48.51-.21.51-2.32-.13-.42.89,1.48.13,1.27.76-.21.89,1.05.88-.21,1.14-1.27-.89h-2.74l-1.27.76h-2.11l-1.27-.25-3.16.51-4.85.63h-1.48l-1.69,1.77,1.05.88-.21,2.4,1.05.76-.21,1.14,4.22,1.14v1.39l3.16.76.63,1.65-1.05,1.65v1.52l2.11,2.15-.42,1.27-1.9.76,3.8,2.53.63.51-1.05.51-1.27-.25-1.05-1.27-2.95-2.15,2.11-1.52-.21-2.02-2.53.63-.21-1.77-1.05-.51,1.27-.76,1.27-.13,1.05-1.39-.42-.51-3.38.38-3.8-2.15-4.43-1.9h-2.74l-2.53,1.01v.63h1.05l1.27-.25v1.64h-1.69l-1.69-1.14-1.69.25-1.05,1.01,1.48,1.52,3.38,1.14,1.48-.13v.76l1.27.88,1.48.25-.21.76-2.11-.25-1.69-1.01h-2.32l-4.64-1.27,1.05-1.64-1.27-.63v-1.14l1.48-1.39-.21-2.66-1.9-1.52-1.27-.25-.63.25,1.48,1.01.42,1.27.42.63-.21,1.64-4.64,1.77-1.27,2.4,2.74,2.15.84,2.28-1.27,1.26-1.48,1.27-.21,1.52.84,1.64.42,1.52,3.16.63,1.9-.88,3.59.63,1.05,1.14,1.48.51,1.9,2.28-2.11,1.26.21,1.01,1.48,1.14,1.27-.25,1.27.51-1.69.38-2.74-.38-1.27-.76.84-3.29-1.69-1.77-.63-.89-2.11-.13-5.28,1.9.84.76,1.69,2.66-.63,1.52-1.69.89-1.9,2.53-2.74,1.52-1.27,2.08-1.05-.84-5.48-.21-2.11-1.66-2.11-.13-.63-.63.84-.38h2.11l1.48-.38,1.27.51,1.69,1.39,2.32-1.01v-.89l1.27-.76-.21-.76,2.53-1.52,1.27-2.15-.63-.89,2.32-1.65-2.11-.38-1.9-1.77,1.05-1.64-1.05-.76v-3.8l1.9-1.26-1.48-.63-.21-3.54-2.53-.38.21-1.39,3.38-2.53.21-1.39-.63-.25.42-2.28-2.95-1.52-3.17.25-1.9-.63-2.32.51-1.48,5.06-2.32,3.04-2.74,2.4-.84,1.77.63.38-.21,3.54-.63.25.63,2.15,1.05-.51,1.9,1.14-.42,1.01,2.11,1.52,1.69.13-.21,1.77-2.74,1.65-.84-.51-.21-1.27-1.9-1.14h-1.48l-1.69-1.01-1.9-.38-1.69-1.01-3.38-1.52h0l-8.23-1.01-2.11,1.39,1.27,1.14-.21,2.28-2.53.63.21.89-1.27.5-1.27-.63.21-1.52-1.69-.63-1.69,1.01-1.69.13-1.69,1.01h-2.32l-.21-.38h-1.68l-1.48,1.01.21.89h-1.69l-.63-.38-1.69.63-.84-.76,1.69-1.01-.63-1.01,1.05-.89-2.11.13-1.69.88-1.27.38.21.89-1.27.51-.21-.76-1.05-.25-2.95.76-1.69,1.39-1.9,1.14h-2.32v1.14l-.84.13-1.27-.76-.84.25.21,1.39-.21,1.64-2.74.89-3.59-.89-.21-.89-1.69-1.14,1.27-.63.21-.63,4.01-.76-1.9-2.15-3.59-1.01-3.8-.51-1.27.13-.21.76,1.9,1.01,1.05.76v2.4l-1.05.76v1.01l2.11,1.01-1.48,4.82-3.59-2.42-2.95-.25-.21,2.25-2.53,1.48-3.8,3.16,2.32,4.64-.84,1.69-3.16.21-4.22-1.9-1.05-1.67-1.48-.21-.84,2.53,2.11,2.95,1.27.42,1.27,1.05-.63,1.27-3.8.42-2.74-2.95-2.32.63-.21-1.69.42-3.58-1.69-1.9,1.69-2.32-.42-2.11-3.38-3.58-3.8-2.42.21-1.39,3.59,2.15,1.9-.13,2.74,1.27,3.8,1.36,4.22,1.48,3.59.21,6.12-4.32v-3.92l-1.27-.88-1.69-1.01h-1.27l-1.05-.89-1.69-.63-3.59-1.27-4.22-2.4-4.43-1.14-2.95.51-1.27-.76-1.9-.25-.84-.76,2.11-.25v-.76l-2.32-.76-1.69.13v.76h-1.48l-4.01,1.52-.21.63-1.48.76-1.9,2.28v1.64l2.53,1.39,1.27,2.66-2.11,2.28,2.95,4.4-.42,3.59.63,2.32-.84,2.74,1.47,1.05-.84,1.48,1.27,2.32v1.9l-1.05,1.9.42,1.69,2.11.63,2.32,3.16-5.27,6.32-3.16,4.43-.7,3.02-.28,2.11,1.41.7,2.11-.14,1.41.42-.42,1.83-3.24-.28-.42.7h-1.83l.14.99-1.55,1.26-.84,4.78,1.05,2.53v2.32l-.21,3.16,1.27,1.69-.21,3.8,1.9.21,1.69,1.48,1.48-.42,2.11.21,1.05,1.69.42,4.64,1.48,2.74,3.16,2.95-.63,2.11h-1.28l-1.27-.84h-1.48l.42,1.9,1.27,1.27.63,2.11,2.11-1.05,4.01.42,1.27,4.85,2.11.42.21,1.69,1.27,1.48,4.85-.21,2.32,1.9h1.9l1.67,1.5,2.55,2.3-1.69,2.11-.42,3.58-1.27-.21-2.11,2.11-1.83,3.23,2.95-.98.42.56-2.81,1.41.98,1.83-.28.84-1.55,1.55-.14.7-1.83.14.28.98.56.98,1.12.56.98,1.12h1.41l2.67,3.09,1.55,1.12,3.94.98,4.43.63,1.48-.42,4.01,1.9,4.01,2.32h.84l1.48,1.69,3.8,1.9,1.9-.63.04-2.31c-.4-.42-.72-.91-.95-1.45-1.94-1.69-1.77-3.88-1.94-6.24-1.1-1.18-2.36-2.36-2.19-4.05l.93-.51c.34-1.1.82-2.15,1.43-3.12,1.69-.08,2.87-1.52,4.14-2.45.43-.03.56-.28.88-.34l-1.49-.83.63-2.95-1.9-2.32-4.01-.84.84-12.02,1.69-.42,1.05,1.48,1.9-.21v-3.16l6.33-4.22,1.48,1.69h2.95l1.27,1.05,2.74-.21,1.69,2.32,1.69-.21,1.27,1.27h1.05l1.69-1.69h5.28l1.48,1.27,4.01.84.21-1.69-3.15-3.11",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.62,142.33l-.56.84-2.95,2.39-.84,2.39h-1.27l-.14-2.11-.7-.28-.7-.84,1.55-1.83.08-.56h5.54Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1025.33,142.33c-.49.62-1.35,1.68-1.35,1.68l-1.55.42-.84,1.69-2.96,1.55-1.97,2.25-.42,1.41-1.41.84-.28-1.69-.7-1.41-2.67-1.4-5.2,2.39-1.27,2.53-1.55,1.12-.14-2.11,1.13-2.11-.28-.56-1.55,1.41-1.27.98-1.12,1.55-1.13-.7-1.41-.14-2.11,2.11-.56,2.81-1.55,2.39-1.12.56-.84,3.23,1.55,1.55.42-.98,1.97.84.28.7-1.97,1.83.14,2.53,1.41.7.84,2.95-.7.7h-1.55v-2.11l-1.97,2.11-1.27,3.37.42.84.99,1.41-.84,2.11-1.27.42-.56-.84-3.8,3.09.7,3.66-.56,1.12-1.69-.56-1.83.56-.56,2.67-.28,1.55-4.78,6.18-1.27.28.56-.84-.7-1.97.14-2.67-.28-2.53-1.13-4.78-.7-1.83-.14-2.67-.42-5.06.42-5.2,2.11-2.53.42-.84.56-4.92h2.53l.98-1.26,1.12-.42,1.83-1.55.14-.98,3.23-2.81.28-2.39,1.55-.28,2.81-3.65.7-1.69,4.78-1.97.14-1.55.42-.7.29-2.39h28.62Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.9,566.94h.99l.28-.6-1.41-1.43-2.11-.48-2.11.36-.14.48.84.48h1.69l1.12.6.85.6Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.3,565.27v-.36l.84-.48,1.55.48v.72l-.98.12-1.41-.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.16,567.54l1.27-.48.98.48-.14.6-1.69-.24-.42-.36Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.26,563.47l.14-.48-.7-.24-.42.36-1.41.24-.14.48,2.53-.36Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.57,558.93l.7.72.14,1.2h-.84l-.28-.72.28-1.2Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.58,559.65v.6l.14.84-.7.12v-1.55h.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.32,559.53l.14.96-.28.48-.56-.24.14-.36.56-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.05,559.77l-.42.6.14.6-.7-.12v-.72l.98-.36Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.36,559.41l-.42.6-.56,1.08-1.69-1.08-.99-.84-.42-1.08,2.39.12,1.69,1.2Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291,557.62h.99l-1.12-1.31-2.39-1.79h-.56v.6l1.41.96,1.69,1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.54,556.9l1.13-1.2,1.41.12.28-1.08-1.55-.24-1.12.72-.14,1.67Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.6,549.97v.6l.7.96-.7.24-.56-.84v-.84l.56-.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.49,552.24l.56-.48.42.36-.7.72-.29-.6Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.32,553.08l.84-.24.14.84-.42.36-.56-.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.79,550.81l-.7-1.08.28-.84h.56l.42,1.43-.57.48Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.49,548.18l.14-.96h.98l-.56,1.91-.56-.96Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.33,543.04l-.28-1.2.14-1.67-.14-1.32-.56-.12-.28,1.31-.7.6.14.72.99,1.2.7.47Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.77,545.55l.56-.96-1.12.72.42.6.14-.36Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.79,544.71l.99-.48-.42-.6-.99.24-.28.6.7.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.8,545.79l.42-.36.28.48-.7.72v-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.49,536.47v-1.32l.56.72v.72l-.56-.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.8,536.35l.42-.48.42.48-.42.72-.42-.72Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.66,541.01l.7,1.08-.7.48-.28-.36.28-1.19Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.19,527.15l.28-.96.7-.48.42.96-.56.48h-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.46,525.23l.14-1.08.98.36.14.96-.42.36-.84-.6Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.85,524.4l.56-.6.28-.36-.7-.42-.42.67.28.72Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.6,513.31v-.84l.7-.42,1.69.98v1.97l-1.12,2.11-.28.84-1.27-.28.28-4.36Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.48,212.32l1.83.7,1.12-.28-.84-2.11-1.41-.84-2.25-1.97-.14-1.41-1.41-1.12-1.69.14-3.52-1.12-1.69-2.53-2.11.14v.84l1.41,3.52,1.27.14,1.13.98h1.27l1.27,1.27,2.39,2.53,1.83.84,1.55.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.88,186.73l1.41-.28.7.42.14.7,1.12-.42-.28,1.69-.28,1.97-1.83.14-1.12-2.11.14-2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.75,176.05h.7l1.83,2.53,1.27,3.8-.42.42-3.09-3.51-.28-3.24Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.6,180.97l1.12,1.83-.56.42-1.12-2.11.56-.14Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.93,172.68l.42-.56.42.56.14,3.65-.56-.28-.42-3.37Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.25,171.27l.56,1.55.14,2.11-.56.28-.98-2.11.84-1.83Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.38,165.37l-.14.7v4.64l.84.14.84-.7-.14-3.23-1.41-1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.3,169.16l-.84-1.41-1.12-1.55v-.85l2.39-.84,1.27.56,1.12.56v.56l-1.27-.28v.7l1.12,1.26-.56.42-1.41-1.41-.42.42.56,1.97-.84-.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.05,173.94l-.84-1.83.42-.7,1.41.7.99.84-.14.42-1.12-.56.28.84-.98.28Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.95,191.76l.63-.42,1.06.1v.53l-1.16.1-.53-.31Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.48,193.45l.53-.32h1.37v.53l-1.37.1-.53-.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.49,195.56l-.11-.74.63.21.63.53-.21.42-.95-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.7,187.75l-.42-.32.32-.42.74.21.11.74-.74-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.54,190.07l.11-.63.84.42,1.06.74-.74.21-1.27-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.75,144.84l.63-1.05.84.63.21,1.48-.63.21-1.05-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.92,191.38l.98-.56,1.12.14.99.98.14,1.12-1.41.14-.7-.98-1.12-.14v-.7Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.52,154.76l-1.27-1.05-1.9.84-.63-1.27.21-1.69-2.95-1.48-1.05-2.11-4.22.42-.84,1.48-.84-.42-.21-2.32-1.69-1.05-.21-1.05-1.48-1.26-.84-2.11-.21-1.48-2.32-1.26-.42-.84.84-1.05-.42-.63v-1.26l-1.48-1.69-.21-.63-1.48-1.26v-2.53l2.32-.21v-1.48l.84-1.69,1.05.63.42-1.26-2.53-1.69-1.27,1.05-1.48,2.74-1.27-.42.42-2.74-.63-2.95.42-1.05-2.95-2.11.42-.63h1.69l-.63-1.48-1.69-.21-1.27-2.32.63-1.9h1.27l1.05-1.7-1.9-.25-1.48.51-.42-.76.84-2.15,3.8-1.39,1.9.38,2.11.89,1.05-.38-.63-1.26-3.59-.13h-1.47l-2.53,1.14-.84-.13-.21-1.01,2.95-1.14h2.95l2.95.51.63-1.01-1.48-.13-.84-.51-2.53.51-1.48-.25.21-1.01,2.53-.51,2.74-.13v-.76l-1.27-.51.63-2.15,2.11-.76-1.05-1.14,1.05-.76-.21-1.14-2.53.38-3.8-.51-2.32-1.52-2.53-.51-1.48-1.65.84-.38,2.74.38,2.32.63h1.48l3.59,1.65,1.05-.51-2.11-1.01.21-.76-1.05-1.14,1.27-1.01-1.69-.25-2.74-1.39,1.05-.89-2.53-1.52-.42-.89-1.48-.13v1.39l-1.05.13-.21,1.9-2.53-.38-2.11-1.14,2.53-.76-1.27-1.01.63-1.14-.84-1.52.42-.38,2.11.38-.42-2.91-2.53-.38.84-1.9-2.32-2.02.63-1.39-1.48-.89-.63-2.4,1.05-.51-1.27-1.01-1.48-.51-3.59-4.13-1.48-.27.42-1.65-2.53-.82-1.48.09-.84-.91-1.69.27-1.27-.64.21-.37-2.95-.46-1.69.55-.63-1.01-1.05-.09-.63.91h-1.69v-.91l-1.05.09-.42,1.1-1.9.46-.84-.27-.42-1.01-1.27.18-.84.64-1.05-.73h-1.48l.21.82,1.48.27v.55l-1.9.09-1.05-.46-3.8-.46-2.32-1.46,2.95-1.01,2.11.09-.21-.91-5.06-.18.42-1.46h-1.27l-.63.73-1.9.09-1.48-1.37,2.95-.91,2.53.09,1.9.55,2.74-.09.63-.18,2.74.73,1.27-.18-.21-.55-3.59-.64-3.16.27.21-.46,3.38-.55h1.27l1.48.37,2.11-1.1-1.05-.73-2.32-.27-1.27.64-1.9.18-1.27-.37-1.48.91-3.16-.64v-.64l-1.05-.18-.42-.55-2.53-.09v-.27l-2.11-.18-2.53-1.46.21-.46.63-.37-.63-.37.21-.55,1.69-.73,1.05-.64,1.9-.09,1.27.27,2.95-1.46h2.32l.84-.46-1.27-.55,2.11-.18,1.27-.82,4.43-.18,1.27.37,4.64-3.2-1.69-1.65,2.95-.55-1.27-.64.84-.55.84-.46-1.05-.73-1.69.73-1.05-.09-1.27.64-4.22-.46v-.73l-.84-.46v-1.47l2.74-.73,1.69-1.01,1.48-.18v-1.01l4.43-2.74.84-.09.63,1.83,1.05-.27-.21-2.2,1.9.37.84.55,2.95-.82v-1.19l-.84-.64,1.48-1.1-1.69-.64-.21-.91-.63-.64.42-.46,1.9-.37,4.01-.09,1.27.64v.91l4.85,1.92-.21-1.19-2.95-1.65-.63-.82-2.32-1.1.42-.37,4.85-1.01h2.32l2.32-.64,2.53.18-.42-1.01,2.95-.55,1.05.55.84,1.92-.42,4.57.63.37.84-.27,1.9-2.65-.84-.37.84-.46,2.32.46,6.54,2.93.84-.55-4.64-2.1h4.22l-1.27-.82-2.53-1.46.21-2.19-.84-.73.63-.55,3.59-.09,1.9,1,.21.82,2.95.55.21.82,2.32.18,2.11,1,3.8,2.65h2.11l.21-.46-2.11-.91.63-.55-.63-2.1.84-.55,2.74.18,2.32.18,1.05-.37-4.64-.91,1.05-.46-4.64-2.93-1.9-.55,1.69-.37,4.22.27,4.43-.09.84.37-.21,1.55.63.64,1.27-.37-.63-1.37.84-.46,1.48.64,1.48,1.37v.73l1.69.73v-.91l-1.48-2.19-1.9-.82-5.48-1.1-5.06.64-.21-.82,2.32-.09-.42-.55-1.69-.18-2.95-1.19,1.05-.46h3.17l1.9.46,1.69-.09-.42-.55-2.74-.45.63-.46,2.74-.27,2.95.64.21,1.19,1.9.18,1.69,1.28,2.74-.09,1.48.64,1.05,1.28h1.27l.21-.73-2.11-1.1,1.05-.55h2.74l1.05-.55h-3.38v-.64l1.69-.18,2.53-.18v-.45l-3.59-.09-1.9-.55,1.05-.82-.84-1.19.63-.27,1.27.37.84-.27-.63-.64h1.48l2.32,1.19,1.27-.46-1.9-1.46,1.48-.37,1.27.46,1.69-.73,1.05.09,1.48.46,1.05-.09.84-.55,3.38-.27,1.05.55,1.69-.27,1.9.09,2.74.18h1.69l1.27.46,2.11-.09.84.46-1.69.55,1.05.55,1.69-.09,1.05-.82,6.75,1.37,1.05,1.19-3.59.91-4.85.46-4.85-.37-4.43.55-2.95.82-2.11-.46-2.11.09,1.05.55-3.59.91-3.8.73.84.37-.63.73h1.27l1.48-.91,1.48.09.21,1.1,1.27-.46.21-1.28,5.06-.09.42-.82,4.01-1.1h3.17l2.95.55,5.7-.18.84-.55,3.8-.46,1.48,1.19-.63,1.46-1.27.73.21,1.01,3.59-1.46h1.27l-.21,1.01,2.32-.55,3.74.81,1.95,1.57-.21,1.1-1.74.27-.37,1.19-3.38.73-2.11-.27-2.74,1.37-6.75.18-3.17-.18-6.33.46-1.48-.37h-3.6l2.11.46-.21.46-5.06,1.37-1.69,1.28.84,1.37,2.11-.37v-.73l5.91-1.46,1.27.27,5.27-1.37,1.27.27,6.96.18.84.27v1.19l-3.38.91-1.48.91-2.32,1.01h1.05l.63.55,2.11-.55,1.69-.64,5.06-1.46.21-2.1.63-.46,5.06-.09.42.46.21,4.48-2.11,1.19-1.05,1.1v1.55l-1.69,1.19.21.73-1.27.64v.82l.84.27,1.48-.64v-1.55l3.38-1.65,1.48-2.38,3.38-1.74.21-.64,1.9-.18v.82l1.48-.09,1.69.27,2.32-.18.42-1.46,1.27-.46-.63-1.1,1.27-.18,1.27.37,2.11-1.1,5.91.55,6.12,2.74.21.46-5.06,3.57-2.95-.27-.84.64,1.48,1.01-.84.55-2.32.09-.63.91-1.48.37-2.32-.09-2.95-.64-.63.73-1.27-.27-3.8.09-1.27.64-1.05.09v1.01l2.53-.09.21-.82,1.9-.18,2.95,1.28,1.69-.18,1.69-.91,3.8,1.19-3.17,1.74-1.69.18-2.74-.46h-3.8l-1.48,1.37v1.92l1.48.09.63-1.01.42-.46-.84-.64,1.05-.64,1.69.27.42.64,1.9-.64,1.27.64-1.48,2.29h-4.01l-1.48,3.38h1.9l-.21.73-1.9,2.01h-2.11l-2.11,2.01,1.05.09-2.74,4.39.42,1.01h1.69l.63-1.28,1.27-.27,4.01,1.37.21,1.01-2.32-.46-1.27-.46-.42.46,1.05,1.1,3.38,1.46.42-.73,2.32.37.21.91-.84,1.55-2.53.09-4.43-.73-1.48.09,1.05.82-2.53.09-1.08.07-.18.55.84,1.21.21,1.01,1.27.37,1.9-.37,2.53.27v1.01l-2.32.18h-4.01l1.48.37,4.22.27,2.74,1.19.42,1.37-2.11,1.32-1.9-1.13-1.9-.37-1.27-.73-1.27.27,3.59,1.58-.21.51-2.9.13-1.27.63.84.63,2.69-.25.84.63-1.05,1.14.21.76,3.17.38,1.05-.38.84.63-.84,1.65-1.27.25-1.9-1.9-3.38-.25-.55.25-.84,1.14,1.05,1.9.76,2.66.63-.38-.42-1.14,3.38.13.21,2.15-2.95.51-3.38.89-3.38-1.65-1.05-.38,3.38.13-2.74-1.14-2.32.13-2.53-1.26-1.05.25,2.74,1.9-1.69,1.65-1.48.38-3.16-.9-.63.51,1.27.89-2.74.38,1.05,1.14,1.69-.63.84.38,1.48-.89,1.9.63-.63,1.01-3.59.25,1.05,1.26,3.17-.89,1.27,1.39-2.74.51,1.48,1.14,2.95-.63,2.32,1.52,2.11.63,1.63,1.37.81,1.79.72-.5,1.27.89-.42,4.43h-1.05l-1.27-1.01-.84.51-.21.89-3.38-.76-2.32-3.16v-1.13l-4.22-1.26-3.38-.25-1.69-2.02-2.32-.51-1.27.63,2.32,1.01v1.26l2.53.63,4.43.38-.21,1.52-3.59.89h-4.43l.84.89-1.27,1.26-1.69.13.21.51,2.53.51,2.32-.13,1.05-.51h1.69l-.21,1.26-2.95.13-2.32.25.63.76h2.74l2.11-.51h1.47l.84-1.39,1.9-.13.63,1.14h5.27l.63.38,1.27-.51.68.42-.21.63-4.27,2.24h-1.26l-.84,1.52-1.05-.25-1.27,1.52h-1.06l-1.48,1.52h-2.53l-2.11,1.14-1.27-.51-2.95,1.52h-1.27l-1.05-.51-1.27.76-1.27-.38-1.05.76-1.27-.13-2.53-1.52-1.69-.13.84.89,1.69.76-.42,1.9-2.95.25-1.27,1.9-1.27,2.28-2.32,3.01-2.53-.21-.21,2.1-2.32,1.26-1.27-.84-1.69.84-.63-1.05.42-2.32-1.69-.42-.42,1.05-.42,4.22-5.7,1.05-.21.63.84,1.26v1.05l-2.74.21-.21,2.11,1.05,1.26-.42,1.48h-2.32l.42,1.69,2.32.42.21,2.74-2.53-.42,1.05,1.9-.21,1.05-1.05.21-.63,2.53-1.27-.21-1.05,1.26.84,1.05-.84,2.32,1.48,2.95-.84,2.11-1.27.63.21,1.27-1.05,1.48.21,1.27-2.11.21,1.48,1.69-1.05,2.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.72,78.61l.21.63-1.05.38-.21-1.01h1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.09,87.35l1.27-.25,1.05.76-1.9.89-.42-1.39Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.25,87.22l.42-.38,1.05.51-.42.63-1.05-.76Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.61,92.41l1.05.38,2.32.38,1.48.76,2.53,1.77-.21.63-1.9,1.01-1.69.13-1.9-1.26-2.11.13-.63-1.14.84-.76-.63-.63.85-1.39Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.94,15.88l-.21-.91,1.05-.37,2.53.55-.21.55,1.48.46,1.27,1.65-2.74-.37-3.16-1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.8,12.41l1.05.55.21.55,1.05.09-.21-.64-1.27-.82-.84.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.18,11.4l1.69,1.83,3.8,2.01.84.64v.64l1.27-.09-.42-1.37,2.11-1.01-5.27-3.11-4.01.46Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.55,8.75l1.48.91-1.9.27-1.48-.37.21-.55,1.69-.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.19,7.11l1.9.64.84.55.21.91-2.95.09-1.48-.55-.42-.46h1.05v-.92l.84-.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.86,3.91l1.05.09,4.43,1.92-1.05.55-2.95-1.19-1.27-.27-.21-1.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.7,6.01l1.9.46,1.05.37-.84.55-1.05-.37-1.06-1.01Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.01,5.92l1.27.91,1.05.64-1.13-.21-1.9-1.37.71.02Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.6,3.45l.84-.18.84.27-.84.73-.84-.46v-.37Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.68,15.97l1.05.55,1.69,1.37-.63.46-2.11-1-1.05-1.1,1.05-.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.21,15.43l.42,1.1,1.48,1.19-.63-2.19-1.27-.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.26,19.27l2.11.27,1.05.55-1.48.18-1.69-1.01Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.9,39.93l-.21.82h1.06l.42-.82h-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.06,42.12l-.42.91-1.48.55,1.27.18,1.48-.82.21-.91-1.05.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.12,48.25l-1.27,1.19,1.05.18,1.05-1.28-.84-.09Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.74,54.92l-.42,1.01.21,3.11,1.05.27v-2.65l.63-1.37-1.48-.37Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.27,62.23l-2.11.27-.42.8,1.48,1.01h1.9l1.9.13-.21-.63-1.9-.38-.63-1.2Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.57,64.32l-.84.89.42.76.84.38.84-.25v-.89l-1.27-.88Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.35,69.38v-.51l1.69-.51,1.05.51.84.89-1.9.51-1.69-.89Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.01,76.22l-.21-.63,1.48-.63,2.32-.25,1.05.38-.84.51,1.05.38-1.05.76h-2.32l-1.48-.51Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.81,77.35l2.32-.51,2.74.51.84.63-.63,1.26-3.17-1.39-2.11-.51Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.33,79.12l.63-.51h2.95l1.9,1.26,1.9.25v.51l-.86.63.02.64-.42.63-3.59-1.39-2.53-2.02Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.36,91.15v-.38l2.32-1.14,5.06-1.01.84.89-.21,1.14-1.27.13-1.69-.25-5.06.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.45,307.92l2.67-1.41,1.83-.28,1.83.28,4.36.14,1.83.98.56,1.12h2.25l4.78,2.67.98.98,1.12.14,1.83,1.41,2.81.42.7,1.12-4.08.56-1.27-.14-3.52.84-1.12-.56.14-.98,1.12-1.12-.42-.7-2.11-.28-2.11-1.83-2.67-.42-1.13-1.27h-2.11l-2.39-1.41v-.7l-1.97.14-2.53,1.55-1.69-.28.28-.99Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.25,309.04l.56-.28.14.56-.84.14.14-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.77,321.56l1.55-.7,3.94,1.69-.14.84-3.52-.14-1.27-.7-.56-.99Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.14,294.78l1.16,1.79-.21,1.69.63.11.1-2.53-.84-1.16-.84.1Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.41,299.31l1.16,1.27v1.69l.74.11-.32-2.11-1.16-1.16-.42.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.94,302.05l.74,1.9.84.11-.84-1.79-.74-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.32,305.43l.74,2.74.53.11-.42-1.9-.32-.95h-.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.95,308.06l.95.63v.63l-.84.74.32.63,1.05-1.48-.21-.74-.74-.63-.53.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.96,313.33l1.16-.74.74.42-.53.63-1.37-.32Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.86,309.01l.63.11-.11.63-.53-.21v-.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.44,310.91l1.16.32-.42.53-.84-.32.11-.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.51,300.79l-.74.84.32,1.48,1.37-.32-.32-1.05-.63-.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.19,295.2l-.1.63h-1.48l.11-.74,1.48.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.93,304.27l.74-.53v.95l-.74-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.65,319.87v-2.85l-2.21-.32-1.16-.42-1.69.74.32.84,1.37.21v1.16l1.16.53-.42.84-2.53-.42-2.32.21-.1.84,1.9.74,1.9.21,3.27-.21.53-2.11Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.65,319.87l-.53,2.11.21.95.84.32,1.79-1.27.42-.84,2.43.21h2l1.27.74,1.05-.84-.21-1.16-1.9-1.58-1.58-.11-2.53-1.69-2.74-.32-.53.63v2.85Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.16,321.35l.53-.53,3.17.21.32.53-.42.84h-3.59v-1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.7,322.72l.53-.21.63.53-.63.32-.53-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.09,344.44l.11,1.58,1.9.11.21-1.58-.53-.11.53-.63-2.22.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.83,343.07l1.05-.32.11.74-.84.21-.32-.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.98,327.46l.11.95.63.53.21-.74h.74v-.95l-.95.42-.74-.21Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.46,332.52l1.05,1.16.42-.21-.21-1.05-.84-.32-.42.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.56,324.93l.42-.32.53.42-.53.53-.32-.21-.11-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.93,330.2l.53-.32.74.63-.84.42-.42-.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.35,336.95l.63-.11.21.53-.84.53v-.95Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.98,340.01l.42-.63.84.42-.53.74-.74-.53Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.93,340.11l.84-.42.56.84-.56.14-.84-.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.06,443.87l.84-2.53.56-3.8.7-1.69,3.38-1.41,6.75-.14,2.25,1.83.42,7.17,2.25,1.12,3.94,1.69.14,2.95,1.69-.7,1.83.7.14,2.53-.7,1.27-.28,1.97-.7,2.81-1.97,1.69-3.94.56-3.23-.14-1.27-.42,3.1-4.64.14-1.27-1.97-1.69-4.36-1.12-2.39-1.83-2.25.28-1.69-2.25-1.83-2.11-1.56-.84Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.06,443.87l.84-2.53.56-3.8.7-1.69,3.38-1.41,6.75-.14,2.25,1.83.14-3.94-1.27-1.83.28-2.39-1.27-.7-.14-2.39-6.47-.98-.28-7.17-2.95-.56-6.05-3.52-2.11-.28-1.55-.84-.28-4.92-2.39-1.55-3.38,1.05-1.55,2.74-5.49.84,2.81,3.65.14,1.12-1.55.7.7,4.36-1.97.7,1.12,5.34-1.55,3.8,1.27.7,1.27,3.51.42,4.36,1.97,6.75.98.7,2.67-2.81,1.41.14,2.67,1.27,1.12,1.83h1.55l.42-.84v-1.12l.98-.42,1.69.56,2.11-.13Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.44,322.72l1.24-1.77,2.66.5.84-1.16.1-.74-.1-3.06,1.27-2.53,1.05-1.48-1.05-1.27-1.48.21-.84-.42h-2.53l-2.11,1.48-1.48-.42-1.27,1.9-.21,3.16-2.11,2.32-.21,1.05-5.49,1.05-1.48-.21-1.69.42-2.32-1.27h-.84l-.84-.63-1.48-.63-.42-1.27-1.27-1.69-1.27-2.32-1.48-2.53-1.05-3.16v-2.95l.21-3.8,1.69-2.74v-1.27l-2.85-.53-3.38-2.64-.42-1.9-3.9-6.22-4.43-2.21-1.9,1.48.32,1.48-.63.42-2-.74-2.32-2.21-.21-2.64-1.05-1.05h-1.05l-2.74-2.64-2.95-.63-2.74-.11-.63,1.79-2.74.74-6.33-.11-1.69-.32-4.11-2.53-4.54-2.11-5.17.21-1.58.53.28,1.27.56,2.39,3.09,3.09.42,1.55,1.12,1.55.84.28,2.39,2.53.14,1.27.14,2.39h-2.11c-.56,0-.14.56-.14.56l2.82,1.97,1.83.7,2.11,1.4,1.13,1.41.56,2.95,1.55,1.97,1.27.42,2.53,2.25.28,2.11,1.55-.42v-1.41l-.7-1.41-1.13-1.4-1.12-.7-.56-1.83-.98-1.4-.42-1.13-.84-2.53-3.1-3.51-.28-.98-1.27-1.27v-1.12l-4.36-4.5-.42-.84-.56-5.2.56-.28.98.98,1.27-.28.56-.14.42,1.27.98.14.56,1.55-.42,1.41,1.27,1.27.56,1.97,1.41,1.97.84.56,1.55,2.11,2.11.56.14,1.41,1.97,2.39,1.13-.14,1.12,1.4-.7.7-.14,1.41,1.69.84,1.55.42.84.98.42,1.55,1.41,1.41.7.14,1.13,1.97,2.95,2.81.28,1.12,1.27,2.25-.28,2.53-.84,1.27.7.7.14.98,1.69.98,1.41.42,1.27.84.7,1.55,1.69.28,1.69.98,1.83.28,1.41.98,1.55.98.99.98,1.41.28.7.7,2.25.14,1.83,1.27.84-.14,1.55.84,1.55.28.84.7,3.1-.42,3.24-1.83h.84l.7.84,2.11.42.28,1.27,2.96,2.67,1.14-3.99,4.11-.11,1.37-.63-.1-1.05-2.43-2,1.16-.84v-2l3.06.11,1.58.73Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.39,328.3l-1.37-.95.42-4.64,1.24-1.77,2.66.5-.84.74-.21,2-1.9,4.12Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.15,369.85l.07-2.74-2.53-1.27-.14-2.39,1.83-1.83.21-2.53,1.69-.63,6.33.21,1.48.63v1.05l-.7.56-.84,2.67,1.27,3.37-1.12,2.39-2.95.14-.56-.56-.84-.14-.56,1.12-2.6-.07Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.68,369.36l1.12-2.39-1.27-3.37.84-2.67.7-.56v-1.05l2.53.42,1.27.42,3.38,2.95-.7,2.46-1.41,2.95-1.41,1.83-3.66-.56-1.41-.42Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.52,552.24l-.42.96-.84.6h-1.55l-1.41.84.56,1.31-.84,1.2v1.67l-2.67.12-1.41-1.08v-.72l2.39-.12.56-.84-.14-1.55-1.69-.96-2.11.12-1.41,1.55-.84.12-.28-2.63,1.27-.36,1.27-.36-.28-1.08-.84-.12-.7.72-1.27-.6v-2.27l-1.13-1.19.99-.6-.56-1.31-1.41-.36.56-1.2-.42-2.51.14-2.27.28-1.55-.56-1.43s.14-.48.56-.36,1.13.96,1.13.96l.98-.36-.14-1.43-.7-.96-.98.72-.84.24-.56-.48.42-.72.98-1.31-.14-.84-1.55-.36-.56-.48-1.69.24v-.48l1.55-1.31.28-1.55,1.97.48v1.55l.28.96.84-.24.84-1.55-.14-1.67.7-.72.98-.36v-1.67l1.12-.84-.14-.93-1.13-.56-.42-1.69,1.41-2.39-.28-3.09.84-.98-.42-1.69.28-1.12-.84-.28-1.41.84-2.11-2.11.84-2.11.42-3.09.99-1.27.14-3.23-.99-3.09v-3.38l1.12-.56.28-2.39,1.13-1.69.98-1.97.63-2.46,1.05-2.96,1.48-2.32v-4.85l-.84-4.64,1.27-1.05-.21-2.95-.42-1.05,2.32-8.01.63-3.16-.42-7.17,1.05-.84.63-8.01-.84-.84.21-4.85,2.18-2.46,1.27.7,1.27,3.51.42,4.36,1.97,6.75.98.7.84,2.39-.7,1.97-1.55.56-1.41,1.12.28,6.19.28,1.27-2.67,2.81-2.25,5.06-.42,1.83-.98,5.48,1.55,5.9-.28,4.5-1.97,2.67.28,2.95-1.69,3.94.42,5.62-1.27,2.67-1.69,5.2.42,6.61-.84,1.12.28,3.38,1.41,4.36-1.55,1.15.42,1.43.56.12.56,5.62-1.27,1.2.14,1.2-1.83.96.28,3.35-3.09,2.87-.7,2.15,1.13,3.11h1.55l.84.6.42,3.35,1.69,1.32,6.47.12.42.72Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.04,387.77l-1.27.84.42,1.97-.42,1.12.84.84v.56l-.91.56,1.48,1.69,1.69.21,2.11,4.22,1.9,2.11,1.27,4.64,1.69,3.16.21,1.27,1.48,1.48.21,1.27,1.9,2.11-.21,1.48.63,2.74,2.11.84.63.84,2.95,2.32h2.11l2.95,3.37,2.11.21,4.43,4.22,2.18-2.46,1.55-3.8-1.12-5.34,1.97-.7-.7-4.36,1.55-.7-.14-1.12-2.81-3.65-2.67-.84-.28-3.52-.7-.7-5.49.42-1.69-1.83-.28-1.69-1.69-3.8,1.55-2.53-.42-2.39,4.5-2.53,3.87-1.05,2.04-.49.14-1.83h-1.83l.7-2.95-2.67-1.27-6.19.42-4.78-6.61-2.81-.28-.84.7,2.67,1.55-.42,1.69-2.68,2.67-3.52,1.55-3.8,4.08.28,1.83-1.41.14-1.41-1.41h-2.53l-.42-1.27Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.26,376.95l2.67,1.55-.42,1.69-2.67,2.67-3.52,1.55-3.8,4.08.28,1.83-1.41.14-1.41-1.41h-2.53l-.42-1.27.14-.84,1.55-.42,1.55-.28.28-1.55-.42-1.27-.7.7-1.27-.14-.98-1.27v-4.08l1.41-1.12v-3.51l1.27-.7,1.27-.42h1.12l2.25,1.55-.14,1.41,1.12.7.99-.42h2.25l1.54.85Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.31,334.91l-5.35-.98-1.41-1.41,1.12-4.01,4.11-.11,1.37-.63-.1-1.05-2.43-2,1.16-.84v-2l3.06.11,1.58.74-.42,4.64,1.37.95,2.53,1.05h-.32l-.63,1.27-4.22,2.85-1.44,1.44Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.05,337.02l.04.35,1.16.53.95-.74-.21-1.69,2.64-1.37h1.37l1.9-2,2.53-.21,2.21-.42-1.05-.63-2.11-2.11-5.06.21-5.49.42h-.32l-.63,1.27-4.22,2.85,3.63.97,1.68,2.02.99.56Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.63,331.47l-2.21.42-2.53.21-1.9,2h-1.37l-2.64,1.37.21,1.69-.95.74-1.16-.53-.18.77,1.69.98,1.97,2.11,1.69,2.39,2.95.18,2.21.21,1.37.53.21-2.11-.42-2.53.21-2.53.84-3.16v-2.74Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.75,333.47l3.63.97,1.68,2.02h0l-.84.56-1.27.42-4.64-2.53,1.44-1.44Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.25,343.63l2.95.18,2.21.21,1.37.53,3.38,2.74v1.05l-1.05,1.37.21,1.37-1.2.28-2.25-2.11-1.12-1.97-1.41-.84-.84.42-2.11-1.27-.14-1.97Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.78,352.56l-1.05,1.58-1.69.18-1.27-1.12-.7-2.25-1.69-.84-1.55.56-1.27.42-.42.98.56,1.41-2.11,1.55-.99-.98-1.69-.7-.14-.98-2.46-1.27-.21-1.37,1.05-1.37,2.32,1.9,1.27.21,2.53-1.27,1.69-.63,2.32.21,2.11,1.48,1.69,1.69,1.68.63Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.68,386.93h-1.83l.7-2.95-2.67-1.27-6.19.42-4.78-6.61-2.81-.28-.84.7-1.55-.84h-2.24l-.99.42-1.12-.7.14-1.41-2.25-1.55.14-2.67,1.41-1.97,1.55-.28.84-.84v-.98l1.27-1.55-.42-1.97-.42-2.81v-3.37l-.56-2.11,1.69-.18,1.05-1.58.84-.84-.42-1.48,1.9-1.69v-1.48l1.48-.63.21-1.9,1.05-1.27,1.48.63.84-.84,5.49-1.9.42-1.48h1.9l1.27.42-.18.91-2,.35-2.95,3.23-1.55,4.22,1.12.98,1.55,1.97-.56,1.41,1.41,1.97,6.75,1.12,1.12,1.12,3.8.42,1.41,1.27-.28,2.95-.56,1.41,1.41,2.67-.7,1.83,1.41.7.98,1.69-.14,2.67-1.83-.7-1.83-1.69-4.92.56-.28.98,2.25,1.83-.84,1.27-1.27-.14.42,3.23,1.12.98-1.42,7.6Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.26,373.01l.14-2.67-.98-1.69-1.41-.7.7-1.83-1.41-2.67.56-1.41.28-2.95-1.41-1.27-3.8-.42-1.12-1.12-6.75-1.12-1.41-1.97.56-1.41-1.55-1.97-1.12-.98,1.55-4.22,2.96-3.24,2-.35-1.93,1.41-.42,1.48.42,1.05-.84,2.11.84,2.32,1.9-.63v-2.11l-.84-1.9.63-1.48,3.38-.84-.42-2.11,1.05.21.84,1.05h1.27l2.11,1.05v1.69l6.96.63,1.27.84,1.9.42,1.48-.42,1.9-1.48,1.27-.21,1.9.42,1.69,2.53,2.11-.21,2.32,1.48,1.05,1.48,1.69,1.27-.21,2.11-1.83.7-.14,1.41.84.42-.14.84-1.97.42v3.23l.56.56-.7,2.81-4.64,1.69-3.38-1.97-1.97.14-.28,1.55.98.56-.14,3.65,2.11-.28.56.7-.28,1.27-5.63,2.67-2.25.7-2.82-1.25Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.57,351.08l-.21,2.11-1.83.7-.14,1.41.84.42-.14.84-1.97.42v3.23l.56.56,1.12.28,2.25,1.83.14,2.25-.7,2.25v3.1l1.83,1.69,2.25.56,1.69-.14.84-1.27,1.69-.56.35-.91.07-2.74-2.53-1.27-.14-2.39,1.83-1.83.21-2.53-.63-1.69-.63-1.48-1.69-.21-1.05-2.32-1.9-1.27-2.11-1.05Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.69,360.78l1.12.28,2.25,1.83.14,2.25-.7,2.25v3.09l1.83,1.69,2.25.56,1.69-.14.84-1.27,1.69-.56.35-.91,2.6.07.56-1.12.84.14.56.56,2.95-.14,1.41.42,3.66.56,1.41-1.83,1.41-2.95.7-2.46.63.42,1.05,2.32,1.05,2.95,1.48,1.27,1.48,1.27-.42,2.32-1.27.63-1.05.84,1.05.63,1.69-.21,1.05,1.05,1.05.21,1.69.63-1.05,2.11-2.53,1.27v.84h1.48l2.74-2.32.63-1.27,2.95.21,3.17,1.69,2.81-.07,1.69,1.69-1.41,2.25.84,1.12,1.69-1.41,1.69-.28,5.06,1.12,3.38-.28,2.53,1.69,3.1.84,4.5,3.37,6.47,1.69.84,2.53v7.59l-1.69,2.24-.84,1.69-.84,1.41-2.25.84-.84.56-.84,2.53-1.13,1.97-3.09,1.69-.56.84-.56,4.78.84,2.25-.84,2.53.56,3.37-2.26,1.12-.56,3.37-.28,1.97-.84.84-.28,1.97-1.69,2.46-.32,3.37-2.11.63-.42,1.48-1.9.63-1.37-.42-1.27.74-2,.21h-2l-1.37,1.69-1.27.53-2.11-.32-2.43,2-.11.84-.84.32-1.37,1.48-1.58.63-.53,3.8.53,1.69-.42,3.27-2.32,2.74-1.37.32-.84,1.69-.56,2-2.29,4.22-2,2.11-.21-.84,1.83-1.69.28-1.27,1.12-2.11-.7-.42-2.25,2.39-.7,1.41-1.27,1.83.84,1.27v.98l-3.1,3.09-.28-1.55-1.97-1.69-.98-1.55-1.97-.84-.7-1.69-1.12-.56-3.8-.42-.84-1.83-1.55-.84,1.97-2.11.42-.84,2.53-2.53,1.97-1.69,3.66-3.23.56-.84-1.55-3.37-1.27-.14.28-1.97.7-1.27-.14-2.53-1.83-.7-1.69.7-.14-2.95-3.94-1.69-2.25-1.12-.42-7.17.14-3.94-1.27-1.83.28-2.39-1.27-.7-.14-2.39-6.47-.98-.28-7.17-2.95-.56-6.05-3.52-2.11-.28-1.55-.84-.28-4.92-2.39-1.55-3.38,1.05-1.55,2.74-5.49.84-2.67-.84-.28-3.52-.7-.7-5.49.42-1.7-1.83-.28-1.69-1.69-3.8,1.55-2.53-.42-2.39,4.5-2.53,3.87-1.05,2.04-.49.14-1.83,1.41-7.59-1.12-.98-.42-3.23,1.27.14.84-1.27-2.25-1.83.28-.98,4.92-.56,1.83,1.69,1.83.7,2.82,1.28,2.25-.7,5.63-2.67.28-1.27-.56-.7-2.11.28.14-3.65-.98-.56.28-1.55,1.97-.14,3.38,1.97,4.64-1.69.7-2.82Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.52,552.24l2.39.36.14-.72-.7-.96-.7-1.08-.28-1.08.7-1.43-.28-1.55,1.27-1.2.28-1.43,1.27.36,1.27-.72v-2.99l1.41-.6.84-1.08.56-.72,1.41-1.32,1.12-.6.56-.6-.42-2.75-2.67-.12-1.27-.6-1.27-2.51.14-1.2.98-1.32.98-.24.7-.96,2.95-.24.84-.48v-1.36l.42-1.41-.42-2.25,2.82-2.09-.98-.84.56-.84,1.41.28.98-.14-.14-2.25-.98-.14-1.27.84-1.12-.98-.56-4.92.84-.7h.84l3.23,1.69,2.25-.14,1.27-.84v-4.5l1.41-1.41.28-1.41h3.8l2.39-1.12,2.81-.28,2.11-1.69.98-.14,1.97-2.95,1.41-2.25-1.83-1.55-.14-.98,1.12-1.83-1.69-2.39-1.12-.14-1.41-1.41-.14-.84-.14-2.53,1.12-1.27.42-6.33.14-1.55,1.27-2.25,1.97-2.11.42-.84,2.53-2.53,1.97-1.69,3.66-3.23.56-.84-1.55-3.37-1.27-.14-.7,2.81-1.97,1.69-3.94.56-3.23-.14-1.27-.42,3.1-4.64.14-1.27-1.97-1.69-4.36-1.12-2.39-1.83-2.25.28-1.69-2.25-1.83-2.11-1.55-.84-2.11.14-1.69-.56-.98.42v1.13l-.42.84h-1.55l-1.12-1.83-2.67-1.27-1.41-.14-2.67,2.81.84,2.39-.7,1.97-1.55.56-1.41,1.12.28,6.19.28,1.27-2.67,2.81-2.25,5.06-.42,1.83-.99,5.48,1.55,5.9-.28,4.5-1.97,2.67.28,2.95-1.69,3.94.42,5.62-1.27,2.67-1.69,5.2.42,6.61-.84,1.12.28,3.37,1.41,4.36-1.55,1.15.42,1.43.56.12.56,5.62-1.27,1.2.14,1.2-1.83.96.28,3.35-3.11,2.87-.7,2.15,1.12,3.11h1.54l.84.6.42,3.35,1.69,1.31,6.47.12.42.71Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.9,480.56l-.14.7-1.83,2.11v.7l-1.97,2.25-2.53.14-2.25-.56-2.53-1.12-1.83.14-1.55-1.83-1.41.42-.14-2.53,1.12-1.27.42-6.33.14-1.55,1.27-2.25,1.55.84.84,1.83,3.8.42,1.12.56.7,1.69,1.97.84.98,1.55,1.97,1.69.28,1.55Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.63,554.03l-.98.12-1.12-.24-.84.72-2.11,1.2.28.84v1.2l1.12-.6.99-.36.84.48-.7.84-1.41,1.08.98,1.2,1.41.72,1.64.32-.1-7.5Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.75,562.2l-3.63-.52-2.11.12-2.95.36v.48l1.12.24,2.25.36h4.92l.4-1.04Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.35,563.23l1.83.12,2.53.48,2.39.12.98.12,2.39-.24.84-.36.14-.6-3.23-.6-1.69-.72-2.53-1.67-.56-1.43-1.55-3.58-1.27-.84.09,7.49,1.84.36-.21.54-1.61-.23-.4,1.04Z",
    style: {
      fill: "#2598a5",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520,237.21l.7-2.53,2.11-1.27,2.39.98,1.69-.14,1.41.42,1.69-.42,1.41-.84,1.41-.42,1.69-1.05-1.27-1.48-1.48-.42-.63-2.95-.42-3.37.42-1.48-1.27-.21-1.05.84-.63-.84,1.05-1.48.63-1.27,1.05-.42v-1.27l.63-1.27,1.69.21,1.05-3.8,1.48-3.8-2.32-.63-2.74-.21-2-.42-2.21-1.69-1.9-.84-1.27-.42-2.74-1.9-2.11-2.18-2.39.56-.84,3.51-2.67,1.83-1.55.84v.84h-2.39l-.98-1.11h-1.97v.84l1.12,1.83.56,1.12-.84,1.12-1.27-.42-.98.42-1.97-.98-.98-.14-1.27,1.12-1.69-.14-.56,1.12.84.7-.28.84,1.27.98,1.83.42,1.41.28.56.7h1.12l1.27,1.41-.56,1.41,2.81,2.11.14,1.12-.56.14.28,2.11.28,1.55.84.42.42,1.12-1.12-.84v1.97l-.56,2.39-.84,2.25,2.25,1.55h.84l.98.84,3.66-.14.14-.56.7-.14.42.42-.28.56,1.12.56h3.24Z",
    style: {
      fill: "#6ac3c9",
      stroke: "#015263",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "map-white1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.32,211.51l1.06-5.54h.02l2.99,6.07c.16.07.34.09.51.09,1.31,0,2.6-1.59,2.6-4.81,0-2.62-.94-4.12-2.99-4.12-1.2,0-2.12.32-2.87.9l-.07-.02,1.22-8.51h9.66l-.74,4.14h-9.01l-.55,3.68c1.22-.69,2.51-1.08,4.18-1.08,3.93,0,6.23,1.82,6.23,4.76,0,3.22-2.6,5.52-6.88,5.52-2.28,0-3.73-.41-5.36-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570.28,207.51c0,3.1-2.74,5.08-7.63,5.08-1.75,0-3.38-.32-4.9-1.01l1.06-5.52h.02l3.1,6.02c.16.05.3.07.51.07,1.33,0,2.55-1.52,2.55-4.21,0-2.41-1.59-4.32-4.3-4.32v-.23c2.46,0,3.43-1.38,3.43-4.37,0-2.16-.64-3.47-1.7-3.47-.18,0-.39.02-.53.07l-2.39,5.96h-.02l-2.05-4.97c1.82-1.01,3.66-1.5,5.77-1.5,3.89,0,6.21,1.63,6.21,3.91,0,2.14-2.07,3.82-5.01,4.3,3.5.21,5.89,1.91,5.89,4.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576.4,210.57c0,2.76-1.72,5.06-5.33,6.39v-.05c1.82-1.4,2.53-2.6,2.85-4.46-1.38-.14-2.02-1.06-2.02-2.21,0-1.31.8-2.23,2.21-2.23,1.31,0,2.3.71,2.3,2.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.43,211.67c2.78-4.83,5.5-8.46,9.06-11.96h-8.05l-1.43,2.14v-6.28h11.54l-1.68,4.16c-1.5,3.7-2.42,7.75-3.13,12.97l-6.32-1.04Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m614.39,211.77v.37h-9.13v-.37h2.3l-1.82-14.1-4.85,14.58h-1.26l-5.77-14.6-.62,14.12h2.37v.37h-5.59v-.37h1.47l2.02-14.92v-.02l-2.07-1.24h7.04l4.02,10.55,2.55-10.55h7.77l-2.07,1.24,1.89,14.95h1.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m628.33,205.99l1.75,5.31c-1.24.76-2.99,1.29-5.08,1.29-4.3,0-7.63-2.64-8.03-7.5h-2.02v-.46h1.98v-.53c0-.41.02-.8.07-1.2h-2.05v-.46h2.09c.64-4.28,3.79-7.34,7.98-7.34,2.28,0,3.84.78,5.24,1.59l-1.93,4.99h-.02l-2.32-5.91c-.32-.14-.6-.21-.97-.21-1.49,0-2.62,2.42-2.78,6.88h3.47v.46h-3.5v.71c0,.34,0,.69.02,1.01h3.47v.46h-3.47c.21,4.51,1.36,7.06,3.06,7.06.23,0,.51-.05.67-.14l2.34-6.02h.02Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m553.95,222.93v2.16h-5.84v2.48h4.55v2.16h-4.55v4.4h-2.41v-11.2h8.24Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.94,228.38c-.16-.05-.4-.08-.72-.09-.57,0-1.02.18-1.35.54-.33.36-.5.88-.5,1.55v3.76h-2.16v-7.84h2.16v.96c.06-.07.15-.17.27-.29.12-.12.37-.27.75-.46.39-.19.8-.29,1.22-.29h.32v2.16Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.46,233.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.37-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.85,227.25c.06-.08.15-.19.27-.31.12-.12.37-.29.75-.5.39-.21.8-.31,1.22-.31.9,0,1.63.31,2.19.93.57.62.85,1.46.85,2.51v4.56h-2.16v-4.32c0-.48-.14-.87-.43-1.16-.28-.29-.65-.44-1.1-.44-.49,0-.88.16-1.17.48s-.43.77-.43,1.36v4.08h-2.16v-7.84h2.16v.96Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.98,227.36c.84-.82,1.83-1.22,2.98-1.22.41,0,.79.06,1.16.17s.67.25.9.4.44.31.62.46c.18.16.32.29.4.41l.12.16-1.36,1.36c-.04-.07-.11-.17-.21-.29-.1-.12-.3-.27-.62-.46s-.66-.29-1.01-.29c-.57,0-1.06.21-1.46.63-.41.42-.61.93-.61,1.53s.21,1.11.62,1.53c.41.42.9.63,1.46.63.35,0,.69-.09,1.01-.26s.55-.34.7-.52l.21-.27,1.28,1.36s-.07.1-.13.18-.18.2-.38.38c-.2.18-.41.34-.64.48-.23.14-.53.27-.89.38s-.75.18-1.16.18c-1.15,0-2.15-.41-2.98-1.22-.84-.82-1.26-1.77-1.26-2.86s.42-2.04,1.26-2.86Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m589.37,230.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.06.07-.2.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.75.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.54.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.31-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#fbf6ea"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m679.77,207.77h2.18v-11.96l-2.74-1.54v-.02l7.8-3.24v16.76h2.18v.37h-9.43v-.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m695.94,199.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-4.49-4.37c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702.19,193.65v3.55h-.01c-1.39-1.54-2.03-1.89-2.49-1.81v4.86h1.01v.21h-4.36v-.21h.67v-4.87l-.76-.66,3.45-1.15v1.68c.76-1.01,1.64-1.64,2.25-1.64.09,0,.17.01.25.04Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m680.23,229.86c0,4.05-2.23,6.51-5.33,6.51-1.06,0-1.98-.32-2.76-.83v5.98h1.84v.37h-7.59v-.37h1.15v-14.14l-1.31-1.13,5.91-2.07v2.28c1.22-1.24,2.64-2.05,4-2.05,2.32,0,4.09,1.89,4.09,5.45Zm-4.92,1.31c0-3.08-.67-4.62-2.21-4.62-.34,0-.64.09-.97.23v8.37c.32.23.74.35,1.13.35,1.2,0,2.05-1.56,2.05-4.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m693.04,235.77v.37h-5.75v-1.31c-1.08.92-2.3,1.54-3.56,1.54-1.49,0-2.51-.85-2.51-2.3,0-2.12,2.25-3.52,6.07-3.93,0-2.53-1.01-3.79-2.76-3.79-1.03,0-1.75.28-2.53.87l-.12-.12c1.56-1.75,3.27-2.69,5.57-2.69,2.9,0,4.44,1.66,4.44,4.99v6.37h1.15Zm-5.75-1.26v-4.07c-1.38.39-1.91,1.26-1.91,2.48,0,1.08.46,1.66,1.38,1.66.14,0,.32-.02.53-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m706.24,224.87l-1.54,1.13-4.99,10.14-2.74,6-4.37-3.06,6.69-3.06-5.43-10.03-1.56-1.13h8.07l-1.54,1.13,2.55,6.05,2.16-6.05-1.77-1.13h4.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m705.78,235.77l.71-3.75h.02l2.85,3.82c.32.09.48.12.76.12,1.01,0,1.7-.53,1.7-1.47,0-.69-.41-1.08-1.38-1.59l-1.52-.8c-1.91-1.01-2.83-2.09-2.83-3.84,0-2.32,1.88-3.84,4.94-3.84,1.5,0,2.69.25,3.82.67l-.9,3.63h-.02l-2.67-3.79c-.12-.05-.28-.07-.39-.07-1.01,0-1.52.58-1.52,1.22,0,.81.37,1.38,1.72,2.09l1.72.92c1.59.85,2.42,2,2.42,3.43,0,2.39-2.42,3.86-5.24,3.86-1.08,0-2.6-.11-4.21-.6Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 693.27,
    cy: 219.13,
    r: 49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 693.27,
    cy: 219.13,
    r: 48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 523.02,
    y1: 218.52,
    x2: 644.02,
    y2: 218.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.52,
    cy: 218.02,
    r: 5,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "map-white2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m359.05,272.77h2.18v-11.96l-2.74-1.54v-.02l7.79-3.24v16.76h2.18v.37h-9.43v-.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.38,272.77h2.18v-11.96l-2.74-1.54v-.02l7.8-3.24v16.76h2.18v.37h-9.43v-.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.58,271.57c0,2.76-1.72,5.06-5.33,6.39v-.05c1.82-1.4,2.53-2.6,2.85-4.46-1.38-.14-2.02-1.06-2.02-2.21,0-1.31.8-2.23,2.21-2.23,1.31,0,2.3.71,2.3,2.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.52,272.77h2.18v-11.96l-2.74-1.54v-.02l7.8-3.24v16.76h2.18v.37h-9.43v-.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.66,272.77v.37h-9.13v-.37h2.3l-1.82-14.1-4.85,14.58h-1.26l-5.77-14.6-.62,14.12h2.37v.37h-5.59v-.37h1.47l2.02-14.92v-.02l-2.07-1.24h7.04l4.02,10.55,2.55-10.55h7.77l-2.07,1.24,1.89,14.95h1.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.6,266.99l1.75,5.31c-1.24.76-2.99,1.29-5.08,1.29-4.3,0-7.63-2.64-8.03-7.5h-2.02v-.46h1.98v-.53c0-.41.02-.8.07-1.2h-2.05v-.46h2.09c.64-4.28,3.79-7.34,7.98-7.34,2.28,0,3.84.78,5.24,1.59l-1.93,4.99h-.02l-2.32-5.91c-.32-.14-.6-.21-.97-.21-1.5,0-2.62,2.42-2.78,6.88h3.47v.46h-3.5v.71c0,.34,0,.69.02,1.01h3.47v.46h-3.47c.21,4.51,1.36,7.06,3.06,7.06.23,0,.51-.05.67-.14l2.35-6.02h.02Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m369.58,283.93h2.12v11.2h-2.4v-7.47l-3.6,4.59-3.59-4.55v7.44h-2.41v-11.2h2.16l3.84,4.88,3.88-4.88Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.43,294.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.37-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.38,289.38c-.16-.05-.4-.08-.72-.09-.57,0-1.02.18-1.35.54-.33.36-.5.88-.5,1.55v3.76h-2.16v-7.84h2.16v.96c.06-.07.15-.17.27-.29.12-.12.37-.27.75-.46.39-.19.8-.29,1.22-.29h.32v2.16Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.17,294.07c-.83.82-1.8,1.22-2.92,1.22s-2.09-.41-2.92-1.22-1.24-1.77-1.24-2.86.41-2.04,1.24-2.86,1.8-1.22,2.92-1.22,2.09.41,2.92,1.22c.83.82,1.24,1.77,1.24,2.86s-.41,2.04-1.24,2.86Zm-4.27-1.38c.38.4.83.6,1.35.6s.97-.2,1.35-.6c.38-.4.57-.89.57-1.48s-.19-1.08-.57-1.48c-.38-.4-.83-.6-1.35-.6s-.97.2-1.35.6c-.38.4-.57.89-.57,1.48s.19,1.08.57,1.48Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.79,288.36c.84-.82,1.83-1.22,2.98-1.22.41,0,.79.06,1.16.17s.67.25.9.4.44.31.62.46c.18.16.32.29.4.41l.12.16-1.36,1.36c-.04-.07-.11-.17-.21-.29-.1-.12-.3-.27-.62-.46s-.66-.29-1.01-.29c-.57,0-1.06.21-1.46.63-.41.42-.61.93-.61,1.53s.21,1.11.62,1.53c.41.42.9.63,1.46.63.35,0,.69-.09,1.01-.26s.55-.34.7-.52l.21-.27,1.28,1.36s-.07.1-.13.18-.18.2-.38.38c-.2.18-.41.34-.64.48-.23.14-.53.27-.89.38s-.75.18-1.16.18c-1.15,0-2.15-.41-2.98-1.22-.84-.82-1.26-1.77-1.26-2.86s.42-2.04,1.26-2.86Z",
    style: {
      fill: "#fbf6ea"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271.44,266.64v5.5h-12.14v-.02l1.17-1.49c4.07-5.17,5.52-8.14,5.52-11.36,0-2.44-.62-3.7-1.72-3.7-.16,0-.32.02-.46.07l-2.39,6.65h-.02l-1.91-5.73c1.63-.87,3.47-1.43,5.47-1.43,4.16,0,6.32,1.5,6.32,4.21s-1.93,4.62-8.32,8.67h8.03v-1.36h.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m278.76,263.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-2.28-5.9l-3.29-2.8h0s2.83-.01,2.83-.01l.47,2.82h-.01Zm-2.21,1.53c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.59,264.25v.21h-3.89v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.28,0-.56.07-.83.2.03.19.04.39.04.62v4.61h.54v.21h-3.76v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.27,0-.54.05-.79.17v5.26h.54v.21h-3.89v-.21h.67v-4.9l-.76-.66,3.45-1.21v1.34c1.09-.87,1.8-1.27,2.55-1.27.91,0,1.42.46,1.6,1.33,1.13-.91,1.85-1.33,2.62-1.33,1.14,0,1.66.71,1.66,2.08v4.61h.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.33,263.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-4.49-4.37c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m268.23,293.86c0,4.05-2.23,6.51-5.33,6.51-1.06,0-1.98-.32-2.76-.83v5.98h1.84v.37h-7.59v-.37h1.15v-14.14l-1.31-1.13,5.91-2.07v2.28c1.22-1.24,2.64-2.05,4-2.05,2.32,0,4.09,1.89,4.09,5.45Zm-4.92,1.31c0-3.08-.67-4.62-2.21-4.62-.34,0-.64.09-.97.23v8.37c.32.23.74.35,1.13.35,1.2,0,2.05-1.56,2.05-4.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.04,299.77v.37h-5.75v-1.31c-1.08.92-2.3,1.54-3.56,1.54-1.49,0-2.51-.85-2.51-2.3,0-2.12,2.25-3.52,6.07-3.93,0-2.53-1.01-3.79-2.76-3.79-1.03,0-1.75.28-2.53.87l-.12-.12c1.56-1.75,3.27-2.69,5.56-2.69,2.9,0,4.44,1.66,4.44,4.99v6.37h1.15Zm-5.75-1.26v-4.07c-1.38.39-1.91,1.26-1.91,2.48,0,1.08.46,1.66,1.38,1.66.14,0,.32-.02.53-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.24,288.87l-1.54,1.13-4.99,10.14-2.74,6-4.37-3.06,6.69-3.06-5.43-10.03-1.56-1.13h8.07l-1.54,1.13,2.55,6.05,2.16-6.05-1.77-1.13h4.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.78,299.77l.71-3.75h.02l2.85,3.82c.32.09.48.12.76.12,1.01,0,1.7-.53,1.7-1.47,0-.69-.41-1.08-1.38-1.59l-1.52-.8c-1.91-1.01-2.83-2.09-2.83-3.84,0-2.32,1.89-3.84,4.94-3.84,1.49,0,2.69.25,3.82.67l-.9,3.63h-.02l-2.67-3.79c-.12-.05-.28-.07-.39-.07-1.01,0-1.52.58-1.52,1.22,0,.81.37,1.38,1.72,2.09l1.72.92c1.59.85,2.41,2,2.41,3.43,0,2.39-2.41,3.86-5.24,3.86-1.08,0-2.6-.11-4.21-.6Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 281.27,
    cy: 280.13,
    r: 49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.27,
    cy: 280.13,
    r: 48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 488.27,
    y1: 279.13,
    x2: 330.27,
    y2: 279.13,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.77,
    cy: 279.63,
    r: 5,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "map-white3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m697.61,322.67c2.78-4.83,5.5-8.46,9.06-11.96h-8.05l-1.43,2.14v-6.28h11.54l-1.68,4.16c-1.49,3.7-2.41,7.75-3.13,12.97l-6.32-1.04Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.79,321.57c0,2.76-1.72,5.06-5.34,6.39v-.05c1.82-1.4,2.53-2.6,2.85-4.46-1.38-.14-2.02-1.06-2.02-2.21,0-1.31.8-2.23,2.21-2.23,1.31,0,2.3.71,2.3,2.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m728.51,317.89c0,3.43-2.99,5.7-6.83,5.7s-6.95-2.28-6.95-6.9c0-5.4,4.32-9.22,10.88-10.72l.09.25c-3.08,1.22-4.74,3.52-5.38,7.27.71-.32,1.56-.48,2.62-.48,3.43,0,5.56,1.93,5.56,4.88Zm-5.29.67c0-3.84-.71-4.83-1.89-4.83-.39,0-.76.12-1.1.37-.14,1.06-.21,2.23-.21,3.52,0,4.23.48,5.52,1.72,5.52,1.15,0,1.47-1.22,1.47-4.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m753.58,322.77v.37h-9.13v-.37h2.3l-1.82-14.1-4.85,14.58h-1.26l-5.77-14.6-.62,14.12h2.37v.37h-5.59v-.37h1.47l2.02-14.92v-.02l-2.07-1.24h7.04l4.02,10.55,2.55-10.55h7.77l-2.07,1.24,1.88,14.95h1.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m767.52,316.99l1.75,5.31c-1.24.76-2.99,1.29-5.08,1.29-4.3,0-7.63-2.64-8.03-7.5h-2.02v-.46h1.98v-.53c0-.41.02-.8.07-1.2h-2.05v-.46h2.09c.64-4.28,3.79-7.34,7.98-7.34,2.28,0,3.84.78,5.24,1.59l-1.93,4.99h-.02l-2.32-5.91c-.32-.14-.6-.21-.97-.21-1.49,0-2.62,2.42-2.78,6.88h3.47v.46h-3.5v.71c0,.34,0,.69.02,1.01h3.47v.46h-3.47c.21,4.51,1.36,7.06,3.06,7.06.23,0,.51-.05.67-.14l2.35-6.02h.02Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m705.39,333.93v2.16h-3.2v9.04h-2.4v-9.04h-3.2v-2.16h8.8Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m708.91,338.25c.06-.08.15-.19.26-.31.11-.12.36-.29.75-.5.39-.21.8-.31,1.22-.31.9,0,1.63.31,2.19.93.57.62.85,1.46.85,2.51v4.56h-2.16v-4.32c0-.48-.14-.87-.43-1.16-.28-.29-.65-.44-1.1-.44-.49,0-.88.16-1.16.48-.29.32-.43.77-.43,1.36v4.08h-2.16v-11.2h2.16v4.32Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m720.58,344.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.37-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m723.37,334.29c.24-.24.52-.36.84-.36s.6.12.84.36.36.52.36.84-.12.6-.36.84-.52.36-.84.36-.6-.12-.84-.36-.36-.52-.36-.84.12-.6.36-.84Zm3.61,10.84h-2.16v-7.84h2.16v7.84Zm-.09-10.84c.24-.24.52-.36.84-.36s.6.12.84.36c.24.24.36.52.36.84s-.12.6-.36.84c-.24.24-.52.36-.84.36s-.6-.12-.84-.36c-.24-.24-.36-.52-.36-.84s.12-.6.36-.84Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m731.46,345.13h-2.16v-11.2h2.16v11.2Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m737.94,344.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.37-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m744.33,338.25c.06-.08.15-.19.27-.31.12-.12.37-.29.75-.5.39-.21.8-.31,1.22-.31.9,0,1.63.31,2.19.93.57.62.85,1.46.85,2.51v4.56h-2.16v-4.32c0-.48-.14-.87-.43-1.16-.28-.29-.65-.44-1.1-.44-.49,0-.88.16-1.17.48s-.43.77-.43,1.36v4.08h-2.16v-7.84h2.16v.96Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m756.22,337.41c.39.19.66.37.82.55l.24.29v-4.32h2.16v11.2h-2.16v-.96s-.05.07-.1.12c-.04.05-.14.14-.28.27-.14.13-.3.24-.46.34-.17.1-.38.19-.65.27s-.54.12-.83.12c-1.02,0-1.9-.39-2.64-1.18-.75-.79-1.12-1.75-1.12-2.89s.37-2.11,1.12-2.89c.75-.79,1.63-1.18,2.64-1.18.45,0,.87.09,1.25.28Zm.5,5.35c.38-.41.56-.92.56-1.55s-.19-1.15-.56-1.55-.83-.61-1.36-.61-.98.2-1.36.61-.56.92-.56,1.55.19,1.15.56,1.55.83.61,1.36.61.98-.2,1.36-.61Z",
    style: {
      fill: "#fbf6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m763.36,341.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.06.07-.2.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.75.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.54.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.31-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#fbf6ea"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m632.51,316.51c0,3.1-2.74,5.08-7.63,5.08-1.75,0-3.38-.32-4.9-1.01l1.06-5.52h.02l3.1,6.02c.16.05.3.07.51.07,1.33,0,2.55-1.52,2.55-4.21,0-2.41-1.59-4.32-4.3-4.32v-.23c2.46,0,3.43-1.38,3.43-4.37,0-2.16-.64-3.47-1.7-3.47-.18,0-.39.02-.53.07l-2.39,5.96h-.02l-2.05-4.97c1.82-1.01,3.66-1.5,5.77-1.5,3.89,0,6.21,1.63,6.21,3.91,0,2.14-2.07,3.82-5.01,4.3,3.5.21,5.89,1.91,5.89,4.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m639.6,312.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-2.28-5.9l-3.29-2.8h0s2.83-.01,2.83-.01l.47,2.82h-.01Zm-2.21,1.53c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.43,313.25v.21h-3.89v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.28,0-.56.07-.83.2.03.19.04.39.04.62v4.61h.54v.21h-3.75v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.27,0-.54.05-.79.17v5.26h.54v.21h-3.89v-.21h.67v-4.9l-.76-.66,3.45-1.21v1.34c1.09-.87,1.8-1.27,2.55-1.27.91,0,1.42.46,1.6,1.33,1.13-.91,1.85-1.33,2.62-1.33,1.14,0,1.66.71,1.66,2.08v4.61h.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.17,312.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-4.49-4.37c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m626.23,342.86c0,4.05-2.23,6.51-5.33,6.51-1.06,0-1.98-.32-2.76-.83v5.98h1.84v.37h-7.59v-.37h1.15v-14.14l-1.31-1.13,5.91-2.07v2.28c1.22-1.24,2.64-2.05,4-2.05,2.32,0,4.09,1.89,4.09,5.45Zm-4.92,1.31c0-3.08-.67-4.62-2.21-4.62-.34,0-.64.09-.97.23v8.37c.32.23.74.35,1.13.35,1.2,0,2.05-1.56,2.05-4.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m639.04,348.76v.37h-5.75v-1.31c-1.08.92-2.3,1.54-3.56,1.54-1.49,0-2.51-.85-2.51-2.3,0-2.12,2.25-3.52,6.07-3.93,0-2.53-1.01-3.79-2.76-3.79-1.03,0-1.75.28-2.53.87l-.12-.12c1.56-1.75,3.27-2.69,5.57-2.69,2.9,0,4.44,1.66,4.44,4.99v6.37h1.15Zm-5.75-1.26v-4.07c-1.38.39-1.91,1.26-1.91,2.48,0,1.08.46,1.66,1.38,1.66.14,0,.32-.02.53-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.24,337.87l-1.54,1.13-4.99,10.14-2.74,6-4.37-3.06,6.69-3.06-5.43-10.03-1.56-1.13h8.07l-1.54,1.13,2.55,6.05,2.16-6.05-1.77-1.13h4.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651.78,348.76l.71-3.75h.02l2.85,3.82c.32.09.48.12.76.12,1.01,0,1.7-.53,1.7-1.47,0-.69-.41-1.08-1.38-1.59l-1.52-.8c-1.91-1.01-2.83-2.09-2.83-3.84,0-2.32,1.88-3.84,4.94-3.84,1.5,0,2.69.25,3.82.67l-.9,3.63h-.02l-2.67-3.79c-.12-.05-.28-.07-.39-.07-1.01,0-1.52.58-1.52,1.22,0,.81.37,1.38,1.72,2.09l1.72.92c1.59.85,2.42,2,2.42,3.43,0,2.39-2.42,3.86-5.24,3.86-1.08,0-2.6-.11-4.21-.6Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 639.27,
    cy: 329.13,
    r: 49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 639.27,
    cy: 329.13,
    r: 48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 809.52,
    y1: 328.63,
    x2: 688.52,
    y2: 328.63,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.02,
    cy: 329.13,
    r: 5,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "map-yellow1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1031.54,335.12c0,3.01-2.88,5.47-6.37,5.47s-6.32-1.61-6.32-4.37c0-1.91,1.59-3.38,4.02-3.59-2.35-1.77-3.1-3.01-3.08-4.85.02-2.62,2.32-4.67,5.75-4.67,3.04,0,5.24,1.56,5.24,3.4s-1.56,2.76-3.84,2.88l1.63,1.17c2.07,1.47,2.97,2.85,2.97,4.55Zm-3.86,2.58c0-1.31-.9-2.32-2.28-3.29l-1.63-1.13c-.23-.16-.44-.3-.64-.46-.37.9-.53,1.72-.53,2.78,0,3.08,1.17,4.51,2.94,4.51,1.29,0,2.14-1.03,2.14-2.41Zm-4.39-12.21c0,.9.62,1.75,1.72,2.53l1.7,1.22c.41-.83.6-1.72.6-2.81,0-1.79-.92-2.83-2.16-2.83-1.08,0-1.86.74-1.86,1.89Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1037.91,338.57c0,2.76-1.72,5.06-5.33,6.39v-.05c1.82-1.4,2.53-2.6,2.85-4.46-1.38-.14-2.02-1.06-2.02-2.21,0-1.31.8-2.23,2.21-2.23,1.31,0,2.3.71,2.3,2.55Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1053.64,334.89c0,3.43-2.99,5.7-6.83,5.7s-6.94-2.28-6.94-6.9c0-5.4,4.32-9.22,10.88-10.72l.09.25c-3.08,1.22-4.74,3.52-5.38,7.27.71-.32,1.56-.48,2.62-.48,3.43,0,5.56,1.93,5.56,4.88Zm-5.29.67c0-3.84-.71-4.83-1.89-4.83-.39,0-.76.12-1.1.37-.14,1.06-.21,2.23-.21,3.52,0,4.23.48,5.52,1.72,5.52,1.15,0,1.47-1.22,1.47-4.58Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1078.71,339.77v.37h-9.13v-.37h2.3l-1.82-14.1-4.85,14.58h-1.26l-5.77-14.6-.62,14.12h2.37v.37h-5.59v-.37h1.47l2.02-14.92v-.02l-2.07-1.24h7.04l4.02,10.55,2.55-10.55h7.77l-2.07,1.24,1.88,14.95h1.75Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1092.65,333.99l1.75,5.31c-1.24.76-2.99,1.29-5.08,1.29-4.3,0-7.63-2.64-8.03-7.5h-2.02v-.46h1.98v-.53c0-.41.02-.8.07-1.2h-2.05v-.46h2.09c.64-4.28,3.79-7.34,7.98-7.34,2.28,0,3.84.78,5.24,1.59l-1.93,4.99h-.02l-2.32-5.91c-.32-.14-.6-.21-.97-.21-1.49,0-2.62,2.42-2.78,6.88h3.47v.46h-3.5v.71c0,.34,0,.69.02,1.01h3.47v.46h-3.47c.21,4.51,1.36,7.06,3.06,7.06.23,0,.51-.05.67-.14l2.34-6.02h.02Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m953.27,350.93c1.15,0,2.11.36,2.86,1.08s1.14,1.61,1.14,2.68-.38,1.96-1.13,2.68c-.76.72-1.71,1.08-2.87,1.08h-2.31v3.68h-2.41v-11.2h4.72Zm-2.31,2.16v3.2h2.23c.48,0,.88-.15,1.2-.46s.48-.68.48-1.13-.16-.83-.48-1.14-.72-.46-1.2-.46h-2.23Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m962.94,361.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.36-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m970.4,362.01c-.39-.18-.66-.37-.82-.55l-.24-.29v4.32h-2.16v-11.2h2.16v.96s.05-.07.1-.12c.04-.05.14-.13.28-.26.14-.13.3-.24.46-.34.17-.1.38-.19.65-.27s.54-.12.83-.12c1.02,0,1.9.39,2.64,1.18.75.79,1.12,1.75,1.12,2.89s-.37,2.11-1.12,2.89c-.75.79-1.63,1.18-2.64,1.18-.45,0-.87-.09-1.25-.28Zm-.5-5.35c-.38.4-.56.92-.56,1.55s.19,1.15.56,1.55.83.61,1.36.61.99-.2,1.36-.61c.37-.41.56-.92.56-1.55s-.19-1.15-.56-1.55c-.37-.4-.83-.61-1.36-.61s-.99.2-1.36.61Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m983.61,361.07c-.83.82-1.8,1.22-2.92,1.22s-2.09-.41-2.92-1.22-1.24-1.77-1.24-2.86.41-2.04,1.24-2.86,1.8-1.22,2.92-1.22,2.09.41,2.92,1.22c.83.82,1.24,1.77,1.24,2.86s-.41,2.04-1.24,2.86Zm-4.27-1.38c.38.4.83.6,1.35.6s.97-.2,1.35-.6c.38-.4.57-.89.57-1.48s-.19-1.08-.57-1.48c-.38-.4-.83-.6-1.35-.6s-.97.2-1.35.6c-.38.4-.57.89-.57,1.48s.19,1.08.57,1.48Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.73,361.34c-.06.07-.15.16-.27.27-.12.11-.37.25-.75.42-.39.17-.8.26-1.22.26-.9,0-1.63-.3-2.19-.9-.57-.6-.85-1.4-.85-2.4v-4.7h2.16v4.48c0,.44.14.8.43,1.09s.65.43,1.09.43c.49,0,.88-.16,1.17-.48s.43-.77.43-1.36v-4.16h2.16v7.84h-2.16v-.8Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1000.37,361.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.36-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1008.92,356.61s-.08-.1-.15-.17-.22-.17-.44-.29c-.22-.12-.45-.18-.69-.18-.3,0-.53.06-.7.19s-.26.27-.26.44c0,.2.12.37.37.51.24.14.54.26.89.36s.71.23,1.07.38.66.39.91.72c.24.33.37.74.37,1.23,0,.7-.28,1.29-.83,1.77s-1.32.71-2.29.71c-.42,0-.81-.05-1.19-.15s-.68-.22-.91-.36-.44-.28-.61-.42c-.17-.14-.3-.25-.38-.35l-.11-.16,1.2-1.2c.04.06.11.14.2.24.09.1.28.23.57.39.29.16.59.25.91.25.34,0,.6-.07.78-.2.17-.13.26-.31.26-.52s-.12-.39-.37-.54c-.25-.14-.55-.27-.91-.38s-.71-.24-1.07-.39-.65-.39-.89-.7c-.25-.32-.37-.72-.37-1.2,0-.63.29-1.2.88-1.71s1.31-.77,2.16-.77c.54,0,1.04.1,1.5.3.46.2.77.4.95.59l.27.3-1.12,1.27Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1013.93,352.92c-.23.22-.54.33-.94.33-.37,0-.66-.11-.87-.33-.22-.22-.32-.51-.32-.87s.11-.65.33-.87.51-.33.87-.33c.4,0,.71.11.94.33.23.22.34.51.34.87s-.12.65-.34.87Zm.19,9.21h-2.16v-7.84h2.16v7.84Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1018.03,358.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.07.07-.21.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.74.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.55.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.32-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1039.14,350.93v11.2h-2.08l-5.52-7.12v7.12h-2.41v-11.2h2.09l5.52,7.12v-7.12h2.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1048.14,361.07c-.83.82-1.8,1.22-2.92,1.22s-2.09-.41-2.92-1.22-1.24-1.77-1.24-2.86.41-2.04,1.24-2.86,1.8-1.22,2.92-1.22,2.09.41,2.92,1.22c.83.82,1.24,1.77,1.24,2.86s-.41,2.04-1.24,2.86Zm-4.27-1.38c.38.4.83.6,1.35.6s.97-.2,1.35-.6c.38-.4.57-.89.57-1.48s-.19-1.08-.57-1.48c-.38-.4-.83-.6-1.35-.6s-.97.2-1.35.6c-.38.4-.57.89-.57,1.48s.19,1.08.57,1.48Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1056.26,361.34c-.06.07-.15.16-.27.27-.12.11-.37.25-.75.42-.39.17-.8.26-1.22.26-.9,0-1.63-.3-2.19-.9-.57-.6-.85-1.4-.85-2.4v-4.7h2.16v4.48c0,.44.14.8.43,1.09s.65.43,1.09.43c.49,0,.88-.16,1.17-.48s.43-.77.43-1.36v-4.16h2.16v7.84h-2.16v-.8Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1062.57,362.13l-2.96-7.84h2.24l1.84,5.2,1.84-5.2h2.23l-2.95,7.84h-2.24Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1070.64,358.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.07.07-.2.18-.42.33s-.44.3-.68.42c-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.55.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.32-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1080.24,362.13h-2.16v-11.2h2.16v11.2Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1084.64,362.13h-2.16v-11.2h2.16v11.2Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088.55,358.93c.08.43.31.79.68,1.08s.84.44,1.4.44c.41,0,.78-.08,1.13-.24s.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.07.07-.2.18-.42.33s-.44.3-.68.42-.55.23-.93.32-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88,1.76-1.2,2.88-1.2,2.05.37,2.8,1.12,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.55.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03s-.7-.41-1.16-.41-.85.13-1.17.4Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1052.34,378.05v4.16c-.04.05-.11.13-.2.23-.09.1-.29.28-.6.52-.31.25-.64.47-.98.66-.35.19-.8.36-1.36.52-.56.16-1.14.23-1.73.23-1.71,0-3.15-.57-4.32-1.71-1.17-1.14-1.76-2.52-1.76-4.13s.59-2.98,1.76-4.12c1.17-1.14,2.62-1.71,4.32-1.71.59,0,1.15.08,1.68.23s.97.34,1.31.56c.34.22.64.44.91.66.26.22.45.4.57.55l.18.23-1.52,1.52s-.07-.1-.13-.18-.18-.2-.37-.39c-.19-.18-.4-.34-.62-.48-.22-.14-.52-.27-.88-.38-.37-.12-.74-.18-1.12-.18-1.05,0-1.92.35-2.62,1.05s-1.05,1.58-1.05,2.62.35,1.92,1.05,2.62,1.58,1.05,2.62,1.05c.5,0,.96-.07,1.37-.22.41-.15.7-.3.87-.45l.24-.2v-1.52h-2v-1.76h4.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059.77,383.34c-.06.07-.15.16-.27.27-.12.11-.37.25-.75.42-.39.17-.8.26-1.22.26-.9,0-1.63-.3-2.19-.9-.57-.6-.85-1.4-.85-2.4v-4.7h2.16v4.48c0,.44.14.8.43,1.09s.65.43,1.09.43c.49,0,.88-.16,1.17-.48s.43-.77.43-1.36v-4.16h2.16v7.84h-2.16v-.8Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1066.14,374.92c-.23.22-.54.33-.94.33-.37,0-.66-.11-.87-.33-.22-.22-.32-.51-.32-.87s.11-.65.33-.87.51-.33.87-.33c.4,0,.71.11.94.33.23.22.34.51.34.87s-.12.65-.34.87Zm.19,9.21h-2.16v-7.84h2.16v7.84Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1070.64,377.25c.06-.08.15-.19.27-.31.11-.12.37-.29.75-.5.39-.21.79-.31,1.22-.31.9,0,1.63.31,2.19.93.56.62.85,1.46.85,2.51v4.56h-2.16v-4.32c0-.48-.14-.87-.43-1.16-.28-.29-.65-.44-1.1-.44-.49,0-.88.16-1.17.48s-.43.77-.43,1.36v4.08h-2.16v-7.84h2.16v.96Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1079.76,380.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.07.07-.21.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.74.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.55.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.32-.27-.7-.41-1.16-.41s-.85.13-1.17.4Zm1.64-5.52h2.24l-1.76,2.4h-1.77l1.28-2.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088.87,380.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.07.07-.21.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.74.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.55.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.32-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#ffd600"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1136.77,331.77h2.18v-11.96l-2.74-1.54v-.02l7.8-3.24v16.76h2.18v.37h-9.43v-.37Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1152.94,323.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-4.49-4.37c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1159.19,317.65v3.55h-.01c-1.39-1.54-2.03-1.89-2.49-1.81v4.86h1.01v.21h-4.36v-.21h.67v-4.87l-.76-.66,3.45-1.15v1.68c.76-1.01,1.64-1.64,2.25-1.64.09,0,.17.01.25.04Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1137.23,353.86c0,4.05-2.23,6.51-5.33,6.51-1.06,0-1.98-.32-2.76-.83v5.98h1.84v.37h-7.59v-.37h1.15v-14.14l-1.31-1.13,5.91-2.07v2.28c1.22-1.24,2.64-2.05,4-2.05,2.32,0,4.09,1.89,4.09,5.45Zm-4.92,1.31c0-3.08-.67-4.62-2.21-4.62-.34,0-.64.09-.97.23v8.37c.32.23.74.35,1.13.35,1.2,0,2.05-1.56,2.05-4.32Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1150.04,359.76v.37h-5.75v-1.31c-1.08.92-2.3,1.54-3.56,1.54-1.49,0-2.51-.85-2.51-2.3,0-2.12,2.25-3.52,6.07-3.93,0-2.53-1.01-3.79-2.76-3.79-1.03,0-1.75.28-2.53.87l-.12-.12c1.56-1.75,3.27-2.69,5.57-2.69,2.9,0,4.44,1.66,4.44,4.99v6.37h1.15Zm-5.75-1.26v-4.07c-1.38.39-1.91,1.26-1.91,2.48,0,1.08.46,1.66,1.38,1.66.14,0,.32-.02.53-.07Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1163.24,348.87l-1.54,1.13-4.99,10.14-2.74,6-4.37-3.06,6.69-3.06-5.43-10.03-1.56-1.13h8.07l-1.54,1.13,2.55,6.05,2.16-6.05-1.77-1.13h4.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1162.78,359.76l.71-3.75h.02l2.85,3.82c.32.09.48.12.76.12,1.01,0,1.7-.53,1.7-1.47,0-.69-.41-1.08-1.38-1.59l-1.52-.8c-1.91-1.01-2.83-2.09-2.83-3.84,0-2.32,1.88-3.84,4.94-3.84,1.5,0,2.69.25,3.82.67l-.9,3.63h-.02l-2.67-3.79c-.12-.05-.28-.07-.39-.07-1.01,0-1.52.58-1.52,1.22,0,.81.37,1.38,1.72,2.09l1.72.92c1.59.85,2.42,2,2.42,3.43,0,2.39-2.42,3.86-5.24,3.86-1.08,0-2.6-.11-4.21-.6Z",
    style: {
      fill: "#ffd600"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1150.27,
    cy: 343.13,
    r: 49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1150.27,
    cy: 343.13,
    r: 48,
    style: {
      fill: "none",
      stroke: "#ffd600",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 940.77,
    cy: 391.63,
    rx: 5,
    ry: 4.5,
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m940.6,391.63v-45.93h161.77",
    style: {
      fill: "none",
      stroke: "#ffd600",
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "map-yellow2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m921.64,235.64v5.5h-12.14v-.02l1.17-1.49c4.07-5.17,5.52-8.14,5.52-11.36,0-2.44-.62-3.7-1.72-3.7-.16,0-.32.02-.46.07l-2.39,6.65h-.02l-1.91-5.73c1.63-.87,3.47-1.43,5.47-1.43,4.16,0,6.32,1.5,6.32,4.21s-1.93,4.62-8.32,8.67h8.03v-1.36h.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m933.83,237.68v3.08h1.95v.37h-8.39v-.37h1.38v-3.08h-6.09v-.46c2.37-2.23,4.48-8.25,4.83-12.65h6.58c-1.88,4.48-4.71,7.89-10.83,12.65h5.52v-3.17l5.06-1.7v4.88h2.18v.46h-2.18Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m942.02,239.57c0,2.76-1.72,5.06-5.33,6.39v-.05c1.82-1.4,2.53-2.6,2.85-4.46-1.38-.14-2.02-1.06-2.02-2.21,0-1.31.8-2.23,2.21-2.23,1.31,0,2.3.71,2.3,2.55Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m943.96,240.77h2.18v-11.96l-2.74-1.54v-.02l7.8-3.24v16.76h2.18v.37h-9.43v-.37Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.1,240.77v.37h-9.13v-.37h2.3l-1.82-14.1-4.85,14.58h-1.26l-5.77-14.6-.62,14.12h2.37v.37h-5.59v-.37h1.47l2.02-14.92v-.02l-2.07-1.24h7.04l4.03,10.55,2.55-10.55h7.77l-2.07,1.24,1.89,14.95h1.75Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m992.05,234.99l1.75,5.31c-1.24.76-2.99,1.29-5.08,1.29-4.3,0-7.63-2.64-8.03-7.5h-2.02v-.46h1.98v-.53c0-.41.02-.8.07-1.2h-2.05v-.46h2.09c.64-4.28,3.79-7.34,7.98-7.34,2.28,0,3.84.78,5.24,1.59l-1.93,4.99h-.02l-2.32-5.91c-.32-.14-.6-.21-.96-.21-1.5,0-2.62,2.42-2.78,6.88h3.47v.46h-3.5v.71c0,.34,0,.69.02,1.01h3.47v.46h-3.47c.21,4.51,1.36,7.06,3.06,7.06.23,0,.51-.05.67-.14l2.34-6.02h.02Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m917.83,251.93c.53.15.97.34,1.31.56.34.22.64.44.91.66.26.22.45.4.57.55l.18.23-1.52,1.52s-.07-.1-.13-.18-.18-.2-.37-.39c-.19-.18-.4-.34-.62-.48-.22-.14-.52-.27-.88-.38-.36-.12-.74-.18-1.12-.18-1.05,0-1.92.35-2.62,1.05s-1.05,1.58-1.05,2.62.35,1.92,1.05,2.62,1.58,1.05,2.62,1.05c.41,0,.8-.06,1.17-.17.37-.11.68-.25.93-.4.25-.15.46-.31.65-.46s.32-.29.41-.41l.12-.16,1.45,1.52c-.04.06-.11.14-.19.25s-.28.28-.57.54c-.29.26-.61.48-.95.68s-.78.37-1.32.54c-.54.16-1.11.24-1.69.24-1.71,0-3.15-.57-4.32-1.71-1.17-1.14-1.76-2.52-1.76-4.13s.59-2.98,1.76-4.12c1.17-1.14,2.62-1.71,4.32-1.71.59,0,1.15.08,1.68.23Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m928.91,262.07c-.83.82-1.8,1.22-2.92,1.22s-2.09-.41-2.92-1.22-1.24-1.77-1.24-2.86.41-2.04,1.24-2.86,1.8-1.22,2.92-1.22,2.09.41,2.92,1.22c.83.82,1.24,1.77,1.24,2.86s-.41,2.04-1.24,2.86Zm-4.27-1.38c.38.4.83.6,1.35.6s.97-.2,1.35-.6c.38-.4.57-.89.57-1.48s-.19-1.08-.57-1.48c-.38-.4-.83-.6-1.35-.6s-.97.2-1.35.6c-.38.4-.57.89-.57,1.48s.19,1.08.57,1.48Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m936.47,257.38c-.16-.05-.4-.08-.72-.09-.57,0-1.02.18-1.35.54-.33.36-.5.88-.5,1.55v3.76h-2.16v-7.84h2.16v.96c.06-.07.15-.17.27-.29.12-.12.37-.27.75-.46.39-.19.8-.29,1.22-.29h.32v2.16Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m939.42,259.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.06.07-.2.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.75.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.54.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.31-.27-.7-.41-1.16-.41s-.85.13-1.17.4Zm1.64-5.52h2.24l-1.76,2.4h-1.77l1.28-2.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m948.54,259.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.06.07-.2.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.75.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.54.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.31-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m963.71,255.41c.39.19.66.37.82.55l.24.29v-4.32h2.16v11.2h-2.16v-.96s-.05.07-.1.12c-.04.05-.14.14-.28.27-.14.13-.3.24-.46.34-.17.1-.38.19-.65.27s-.54.12-.83.12c-1.02,0-1.9-.39-2.64-1.18-.75-.79-1.12-1.75-1.12-2.89s.37-2.11,1.12-2.89c.75-.79,1.63-1.18,2.64-1.18.45,0,.87.09,1.25.28Zm.5,5.35c.38-.41.56-.92.56-1.55s-.19-1.15-.56-1.55-.83-.61-1.36-.61-.98.2-1.36.61-.56.92-.56,1.55.19,1.15.56,1.55.83.61,1.36.61.98-.2,1.36-.61Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m974.37,262.34c-.06.07-.15.16-.27.27-.11.11-.37.25-.75.42-.39.17-.79.26-1.22.26-.9,0-1.63-.3-2.19-.9-.56-.6-.85-1.4-.85-2.4v-4.7h2.16v4.48c0,.44.14.8.43,1.09s.65.43,1.09.43c.49,0,.88-.16,1.17-.48s.43-.77.43-1.36v-4.16h2.16v7.84h-2.16v-.8Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m992.43,251.93v11.2h-2.08l-5.52-7.12v7.12h-2.41v-11.2h2.09l5.52,7.12v-7.12h2.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001.42,262.07c-.83.82-1.8,1.22-2.92,1.22s-2.09-.41-2.92-1.22-1.24-1.77-1.24-2.86.41-2.04,1.24-2.86,1.8-1.22,2.92-1.22,2.09.41,2.92,1.22c.83.82,1.24,1.77,1.24,2.86s-.41,2.04-1.24,2.86Zm-4.27-1.38c.38.4.83.6,1.35.6s.97-.2,1.35-.6c.38-.4.57-.89.57-1.48s-.19-1.08-.57-1.48c-.38-.4-.83-.6-1.35-.6s-.97.2-1.35.6c-.38.4-.57.89-.57,1.48s.19,1.08.57,1.48Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1008.98,257.38c-.16-.05-.4-.08-.72-.09-.57,0-1.02.18-1.35.54-.33.36-.5.88-.5,1.55v3.76h-2.16v-7.84h2.16v.96c.06-.07.15-.17.27-.29.12-.12.37-.27.75-.46.39-.19.8-.29,1.22-.29h.32v2.16Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1014.71,255.41c.39.19.66.37.82.55l.24.29v-4.32h2.16v11.2h-2.16v-.96s-.05.07-.1.12c-.04.05-.14.14-.28.27-.14.13-.3.24-.46.34-.17.1-.38.19-.65.27s-.54.12-.83.12c-1.02,0-1.9-.39-2.64-1.18-.75-.79-1.12-1.75-1.12-2.89s.37-2.11,1.12-2.89c.75-.79,1.63-1.18,2.64-1.18.45,0,.87.09,1.25.28Zm.5,5.35c.38-.41.56-.92.56-1.55s-.19-1.15-.56-1.55-.83-.61-1.36-.61-.98.2-1.36.61-.56.92-.56,1.55.19,1.15.56,1.55.83.61,1.36.61.98-.2,1.36-.61Z",
    style: {
      fill: "#ffd600"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1072.94,231.64v5.5h-12.14v-.02l1.17-1.49c4.07-5.17,5.52-8.14,5.52-11.36,0-2.44-.62-3.7-1.72-3.7-.16,0-.32.02-.46.07l-2.39,6.65h-.02l-1.91-5.73c1.63-.87,3.47-1.43,5.47-1.43,4.16,0,6.32,1.5,6.32,4.21s-1.93,4.62-8.32,8.67h8.03v-1.36h.46Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1080.26,228.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-2.28-5.9l-3.29-2.8h0s2.83-.01,2.83-.01l.47,2.82h-.01Zm-2.21,1.53c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1093.1,229.25v.21h-3.89v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.28,0-.56.07-.83.2.03.19.04.39.04.62v4.61h.54v.21h-3.76v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.27,0-.54.05-.79.17v5.26h.54v.21h-3.89v-.21h.67v-4.9l-.76-.66,3.45-1.21v1.34c1.09-.87,1.8-1.27,2.55-1.27.91,0,1.42.46,1.6,1.33,1.13-.91,1.85-1.33,2.62-1.33,1.14,0,1.66.71,1.66,2.08v4.61h.67Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1099.84,228.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-4.49-4.37c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1067.23,258.86c0,4.05-2.23,6.51-5.33,6.51-1.06,0-1.98-.32-2.76-.83v5.98h1.84v.37h-7.59v-.37h1.15v-14.14l-1.31-1.13,5.91-2.07v2.28c1.22-1.24,2.64-2.05,4-2.05,2.32,0,4.09,1.89,4.09,5.45Zm-4.92,1.31c0-3.08-.67-4.62-2.21-4.62-.34,0-.64.09-.97.23v8.37c.32.23.74.35,1.13.35,1.2,0,2.05-1.56,2.05-4.32Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1080.04,264.77v.37h-5.75v-1.31c-1.08.92-2.3,1.54-3.56,1.54-1.49,0-2.51-.85-2.51-2.3,0-2.12,2.25-3.52,6.07-3.93,0-2.53-1.01-3.79-2.76-3.79-1.03,0-1.75.28-2.53.87l-.12-.12c1.56-1.75,3.27-2.69,5.57-2.69,2.9,0,4.44,1.66,4.44,4.99v6.37h1.15Zm-5.75-1.26v-4.07c-1.38.39-1.91,1.26-1.91,2.48,0,1.08.46,1.66,1.38,1.66.14,0,.32-.02.53-.07Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1093.24,253.87l-1.54,1.13-4.99,10.14-2.74,6-4.37-3.06,6.69-3.06-5.43-10.03-1.56-1.13h8.07l-1.54,1.13,2.55,6.05,2.16-6.05-1.77-1.13h4.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1092.78,264.77l.71-3.75h.02l2.85,3.82c.32.09.48.12.76.12,1.01,0,1.7-.53,1.7-1.47,0-.69-.41-1.08-1.38-1.59l-1.52-.8c-1.91-1.01-2.83-2.09-2.83-3.84,0-2.32,1.88-3.84,4.94-3.84,1.5,0,2.69.25,3.82.67l-.9,3.63h-.02l-2.67-3.79c-.12-.05-.28-.07-.39-.07-1.01,0-1.52.58-1.52,1.22,0,.81.37,1.38,1.72,2.09l1.72.92c1.59.85,2.42,2,2.42,3.43,0,2.39-2.42,3.86-5.24,3.86-1.08,0-2.6-.11-4.21-.6Z",
    style: {
      fill: "#ffd600"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1080.27,
    cy: 245.13,
    r: 49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1080.27,
    cy: 245.13,
    r: 48,
    style: {
      fill: "none",
      stroke: "#ffd600",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 890.27,
    y1: 245.63,
    x2: 1031.77,
    y2: 245.63,
    style: {
      fill: "none",
      stroke: "#ffd600",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 890.77,
    cy: 245.13,
    r: 5,
    style: {
      fill: "#ffd600"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "map-yellow3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m810.64,411.64v5.5h-12.14v-.02l1.17-1.49c4.07-5.17,5.52-8.14,5.52-11.36,0-2.44-.62-3.7-1.72-3.7-.16,0-.32.02-.46.07l-2.39,6.65h-.02l-1.91-5.73c1.63-.87,3.47-1.43,5.47-1.43,4.16,0,6.32,1.5,6.32,4.21s-1.93,4.62-8.32,8.67h8.03v-1.36h.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m824.63,412.12c0,3.01-2.88,5.47-6.37,5.47s-6.32-1.61-6.32-4.37c0-1.91,1.59-3.38,4.02-3.59-2.35-1.77-3.1-3.01-3.08-4.85.02-2.62,2.32-4.67,5.75-4.67,3.04,0,5.24,1.56,5.24,3.4s-1.56,2.76-3.84,2.88l1.63,1.17c2.07,1.47,2.97,2.85,2.97,4.55Zm-3.86,2.58c0-1.31-.9-2.32-2.28-3.29l-1.63-1.13c-.23-.16-.44-.3-.64-.46-.37.9-.53,1.72-.53,2.78,0,3.08,1.17,4.51,2.94,4.51,1.29,0,2.14-1.03,2.14-2.41Zm-4.39-12.21c0,.9.62,1.75,1.72,2.53l1.7,1.22c.41-.83.6-1.72.6-2.81,0-1.79-.92-2.83-2.16-2.83-1.08,0-1.86.74-1.86,1.89Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m831,415.57c0,2.76-1.72,5.06-5.34,6.39v-.05c1.82-1.4,2.53-2.6,2.85-4.46-1.38-.14-2.02-1.06-2.02-2.21,0-1.31.8-2.23,2.21-2.23,1.31,0,2.3.71,2.3,2.55Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m833.02,416.67c2.78-4.83,5.5-8.46,9.06-11.96h-8.05l-1.43,2.14v-6.28h11.54l-1.68,4.16c-1.5,3.7-2.42,7.75-3.13,12.97l-6.32-1.04Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m868.99,416.76v.37h-9.13v-.37h2.3l-1.82-14.1-4.85,14.58h-1.26l-5.77-14.6-.62,14.12h2.37v.37h-5.59v-.37h1.47l2.02-14.92v-.02l-2.07-1.24h7.04l4.02,10.55,2.55-10.55h7.77l-2.07,1.24,1.89,14.95h1.75Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m882.93,410.99l1.75,5.31c-1.24.76-2.99,1.29-5.08,1.29-4.3,0-7.63-2.64-8.03-7.5h-2.02v-.46h1.98v-.53c0-.41.02-.8.07-1.2h-2.05v-.46h2.09c.64-4.28,3.79-7.34,7.98-7.34,2.28,0,3.84.78,5.24,1.59l-1.93,4.99h-.02l-2.32-5.91c-.32-.14-.6-.21-.97-.21-1.5,0-2.62,2.42-2.78,6.88h3.47v.46h-3.5v.71c0,.34,0,.69.02,1.01h3.47v.46h-3.47c.21,4.51,1.36,7.06,3.06,7.06.23,0,.51-.05.67-.14l2.35-6.02h.02Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m803.78,426.57h-1.92l-.96-1.28-.96,1.28h-1.92l1.92-2.4h1.92l1.92,2.4Zm-4.07,1.36h2.41v11.2h-2.41v-11.2Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m806.75,439.13h-2.16v-11.2h2.16v11.2Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m810.66,435.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.06.07-.2.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.75.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.54.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.31-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m822.34,433.61s-.08-.1-.15-.17-.22-.17-.44-.29c-.22-.12-.45-.18-.69-.18-.3,0-.53.06-.7.19s-.26.27-.26.44c0,.2.12.37.37.51.25.14.54.26.89.36s.71.23,1.07.38.66.39.91.72c.25.33.37.74.37,1.23,0,.7-.28,1.29-.83,1.77s-1.32.71-2.29.71c-.42,0-.81-.05-1.19-.15s-.68-.22-.91-.36-.44-.28-.61-.42c-.17-.14-.3-.25-.38-.35l-.11-.16,1.2-1.2c.04.06.11.14.2.24.09.1.28.23.57.39.29.16.59.25.91.25.34,0,.6-.07.78-.2.17-.13.26-.31.26-.52s-.12-.39-.37-.54c-.24-.14-.55-.27-.91-.38s-.71-.24-1.07-.39-.65-.39-.89-.7c-.24-.32-.37-.72-.37-1.2,0-.63.29-1.2.88-1.71s1.31-.77,2.16-.77c.54,0,1.04.1,1.5.3.46.2.77.4.95.59l.27.3-1.12,1.27Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m837.37,427.93l2.32,7.68,2.32-7.68h2.56l-3.68,11.2h-2.24l-2.4-7.52-2.4,7.52h-2.24l-3.68-11.2h2.56l2.32,7.68,2.32-7.68h2.23Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m849.52,438.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.37-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m856,439.13h-2.16v-11.2h2.16v11.2Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m860.4,439.13h-2.16v-11.2h2.16v11.2Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m864.61,429.92c-.23.22-.54.33-.94.33-.36,0-.65-.11-.87-.33-.22-.22-.32-.51-.32-.87s.11-.65.33-.87.51-.33.87-.33c.4,0,.71.11.94.33.23.22.34.51.34.87s-.11.65-.34.87Zm.19,9.21h-2.16v-7.84h2.16v7.84Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m871.27,433.61s-.08-.1-.15-.17-.22-.17-.44-.29c-.22-.12-.45-.18-.69-.18-.3,0-.53.06-.7.19s-.26.27-.26.44c0,.2.12.37.37.51.25.14.54.26.89.36s.71.23,1.07.38.66.39.91.72c.25.33.37.74.37,1.23,0,.7-.28,1.29-.83,1.77s-1.32.71-2.29.71c-.42,0-.81-.05-1.19-.15s-.68-.22-.91-.36-.44-.28-.61-.42c-.17-.14-.3-.25-.38-.35l-.11-.16,1.2-1.2c.04.06.11.14.2.24.09.1.28.23.57.39.29.16.59.25.91.25.34,0,.6-.07.78-.2.17-.13.26-.31.26-.52s-.12-.39-.37-.54c-.24-.14-.55-.27-.91-.38s-.71-.24-1.07-.39-.65-.39-.89-.7c-.24-.32-.37-.72-.37-1.2,0-.63.29-1.2.88-1.71s1.31-.77,2.16-.77c.54,0,1.04.1,1.5.3.46.2.77.4.95.59l.27.3-1.12,1.27Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.26,435.93c.08.43.31.79.68,1.08.37.29.84.44,1.4.44.41,0,.78-.08,1.13-.24.35-.16.59-.32.73-.48l.23-.24,1.12,1.44-.14.14c-.06.07-.2.18-.42.33-.21.16-.44.3-.68.42-.24.12-.55.23-.93.32s-.78.14-1.18.14c-1.15,0-2.13-.4-2.95-1.2s-1.22-1.76-1.22-2.88.4-2.08,1.2-2.88c.8-.8,1.76-1.2,2.88-1.2s2.05.37,2.8,1.12c.75.75,1.12,1.68,1.12,2.8l-.08.88h-5.68Zm.68-2.55c-.32.27-.54.61-.68,1.04h3.6c-.08-.42-.28-.76-.6-1.03-.31-.27-.7-.41-1.16-.41s-.85.13-1.17.4Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m887.58,428.98h1.92v2.48h1.59v1.92h-1.59v3.12c0,.25.09.45.27.62s.41.26.68.26c.14,0,.28-.01.41-.04s.23-.06.3-.09l.09-.03v1.84c-.43.16-.91.24-1.45.23-1.65,0-2.48-.91-2.48-2.72v-3.2h-1.36v-1.92h.72c.25,0,.45-.1.62-.29s.26-.44.26-.75v-1.44Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m905.08,427.93v2.16h-5.84v2.48h4.55v2.16h-4.55v4.4h-2.41v-11.2h8.24Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m911.32,438.34c-.06.07-.15.16-.27.27-.11.11-.37.25-.75.42-.39.17-.79.26-1.22.26-.9,0-1.63-.3-2.19-.9-.56-.6-.85-1.4-.85-2.4v-4.7h2.16v4.48c0,.44.14.8.43,1.09s.65.43,1.09.43c.49,0,.88-.16,1.17-.48s.43-.77.43-1.36v-4.16h2.16v7.84h-2.16v-.8Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m916.59,428.98h1.92v2.48h1.59v1.92h-1.59v3.12c0,.25.09.45.27.62s.41.26.68.26c.14,0,.28-.01.41-.04s.23-.06.3-.09l.09-.03v1.84c-.43.16-.91.24-1.45.23-1.65,0-2.48-.91-2.48-2.72v-3.2h-1.36v-1.92h.72c.25,0,.45-.1.62-.29s.26-.44.26-.75v-1.44Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m927.39,438.34c-.06.07-.15.16-.27.27-.11.11-.37.25-.75.42-.39.17-.79.26-1.22.26-.9,0-1.63-.3-2.19-.9-.56-.6-.85-1.4-.85-2.4v-4.7h2.16v4.48c0,.44.14.8.43,1.09s.65.43,1.09.43c.49,0,.88-.16,1.17-.48s.43-.77.43-1.36v-4.16h2.16v7.84h-2.16v-.8Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m933.86,432.25c.06-.08.15-.19.27-.31.12-.12.37-.29.75-.5.39-.21.8-.31,1.22-.31.9,0,1.63.31,2.19.93.57.62.85,1.46.85,2.51v4.56h-2.16v-4.32c0-.48-.14-.87-.43-1.16-.28-.29-.65-.44-1.1-.44-.49,0-.88.16-1.17.48s-.43.77-.43,1.36v4.08h-2.16v-7.84h2.16v.96Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945.54,438.34c-.06.07-.15.16-.26.27-.11.11-.36.25-.73.42s-.77.26-1.17.26c-.78,0-1.42-.22-1.91-.65-.49-.43-.73-.96-.73-1.58s.21-1.17.62-1.6c.41-.43.98-.71,1.7-.84l2.48-.45c0-.33-.12-.6-.36-.8-.24-.21-.57-.31-1-.31-.35,0-.68.07-.97.2-.29.13-.5.27-.62.41l-.18.19-1.2-1.2s.07-.1.13-.17.18-.19.37-.36c.19-.17.4-.32.62-.46.22-.13.52-.25.88-.37.37-.11.74-.17,1.12-.17.99,0,1.8.3,2.42.89s.94,1.33.94,2.23v4.88h-2.16v-.8Zm-.43-1.27c.29-.31.43-.74.43-1.29v-.24l-1.76.32c-.59.09-.88.39-.88.88,0,.53.35.8,1.04.8.49,0,.88-.16,1.17-.46Z",
    style: {
      fill: "#ffd600"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m726.51,407.51c0,3.1-2.74,5.08-7.63,5.08-1.75,0-3.38-.32-4.9-1.01l1.06-5.52h.02l3.1,6.02c.16.05.3.07.51.07,1.33,0,2.55-1.52,2.55-4.21,0-2.41-1.59-4.32-4.3-4.32v-.23c2.46,0,3.43-1.38,3.43-4.37,0-2.16-.64-3.47-1.7-3.47-.18,0-.39.02-.53.07l-2.39,5.96h-.02l-2.05-4.97c1.82-1.01,3.66-1.5,5.77-1.5,3.89,0,6.21,1.63,6.21,3.91,0,2.14-2.07,3.82-5.01,4.3,3.5.21,5.89,1.91,5.89,4.18Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m733.6,403.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-2.28-5.9l-3.29-2.8h0s2.83-.01,2.83-.01l.47,2.82h-.01Zm-2.21,1.53c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m746.43,404.25v.21h-3.89v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.28,0-.56.07-.83.2.03.19.04.39.04.62v4.61h.54v.21h-3.75v-.21h.54v-4.04c0-1.05-.16-1.39-.74-1.39-.27,0-.54.05-.79.17v5.26h.54v.21h-3.89v-.21h.67v-4.9l-.76-.66,3.45-1.21v1.34c1.09-.87,1.8-1.27,2.55-1.27.91,0,1.42.46,1.6,1.33,1.13-.91,1.85-1.33,2.62-1.33,1.14,0,1.66.71,1.66,2.08v4.61h.67Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m753.17,403.26c-.56.86-1.46,1.34-2.71,1.34-1.89,0-3.45-1.31-3.45-3.39,0-1.96,1.31-3.58,3.46-3.58,1.26,0,2.13.74,2.13,1.72,0,1.11-.86,2.09-2.47,2.7.76.75,1.73,1.25,2.63,1.25.13,0,.27-.01.39-.04h.01Zm-4.49-4.37c0,1.11.58,2.24,1.38,3.07.38-.48.52-1.02.52-1.7,0-1.17-.78-2.16-1.35-2.16-.35,0-.55.29-.55.79Z",
    style: {
      fill: "#ffd600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m720.23,433.86c0,4.05-2.23,6.51-5.33,6.51-1.06,0-1.98-.32-2.76-.83v5.98h1.84v.37h-7.59v-.37h1.15v-14.14l-1.31-1.13,5.91-2.07v2.28c1.22-1.24,2.64-2.05,4-2.05,2.32,0,4.09,1.89,4.09,5.45Zm-4.92,1.31c0-3.08-.67-4.62-2.21-4.62-.34,0-.64.09-.97.23v8.37c.32.23.74.35,1.13.35,1.2,0,2.05-1.56,2.05-4.32Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m733.04,439.76v.37h-5.75v-1.31c-1.08.92-2.3,1.54-3.56,1.54-1.49,0-2.51-.85-2.51-2.3,0-2.12,2.25-3.52,6.07-3.93,0-2.53-1.01-3.79-2.76-3.79-1.03,0-1.75.28-2.53.87l-.12-.12c1.56-1.75,3.27-2.69,5.57-2.69,2.9,0,4.44,1.66,4.44,4.99v6.37h1.15Zm-5.75-1.26v-4.07c-1.38.39-1.91,1.26-1.91,2.48,0,1.08.46,1.66,1.38,1.66.14,0,.32-.02.53-.07Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m746.24,428.87l-1.54,1.13-4.99,10.14-2.74,6-4.37-3.06,6.69-3.06-5.43-10.03-1.56-1.13h8.07l-1.54,1.13,2.55,6.05,2.16-6.05-1.77-1.13h4.46Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745.78,439.76l.71-3.75h.02l2.85,3.82c.32.09.48.12.76.12,1.01,0,1.7-.53,1.7-1.47,0-.69-.41-1.08-1.38-1.59l-1.52-.8c-1.91-1.01-2.83-2.09-2.83-3.84,0-2.32,1.88-3.84,4.94-3.84,1.5,0,2.69.25,3.82.67l-.9,3.63h-.02l-2.67-3.79c-.12-.05-.28-.07-.39-.07-1.01,0-1.52.58-1.52,1.22,0,.81.37,1.38,1.72,2.09l1.72.92c1.59.85,2.42,2,2.42,3.43,0,2.39-2.42,3.86-5.24,3.86-1.08,0-2.6-.11-4.21-.6Z",
    style: {
      fill: "#ffd600"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 733.27,
    cy: 423.13,
    r: 49,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 733.27,
    cy: 423.13,
    r: 48,
    style: {
      fill: "none",
      stroke: "#ffd600",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 1017.77,
    y1: 422.13,
    x2: 782.27,
    y2: 422.13,
    style: {
      fill: "none",
      stroke: "#ffd600",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1017.27,
    cy: 422.63,
    r: 5,
    style: {
      fill: "#ffd600"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB3Map);
export default __webpack_public_path__ + "static/media/b3-map.120e3fd095d13d2c8ecfcca35f4426fd.svg";
export { ForwardRef as ReactComponent };